export const pt = {
    app: {
      home: 'Casa',
      playerScout: "Jogador Observado",
      playerComparison: "Comparação de Jogadores",
      playerRecruitment: 'Recrutamento de jogadores',
      collections: "Coleções",
      favoritePlayers: 'Jogador Favorito',
      teamAnalytics: 'Analítica de Equipa',
      gameAnalysis: 'Analise de Jogo',
      seasonStats: 'Estatisticas da Época',
      leagueTable: 'Tabela da Liga',
      scoresAndFixtures: 'Resultados & Jogos',
      notifications: 'Notificações',
      administration: 'Administração',
      inbox: "Caixa de Correio",
      teamStats: "Estatísticas de Equipa",
      blog: "Blog",
      leagues: "Ligas",
      squadBuilder: "Squad Builder",
      playerAlerts:"Player Alerts",
      searchAlerts:"Search Alerts",
      videoUploadTool:"Video Upload Tool",
      videoPlaylists: "Playlists",
      uploadedGames:"Uploaded games",
      favoriteTeams:"Favorite Teams"
    },
    playerRecruitment: {
      title: "Ficha do jogador",
      subtitle: "Aprofundar as características e estatísticas do jogador",
      league: 'liga',
      selectedSeason: "Época selecionada",
      year: 'Ano',
      radar: 'Radar',
      positions: 'Posições',
      numberOfPlayers: 'Número de jogadores',
      template: "Modelo",
      compareWith: "Comparar com",
      previousPerformance: "Previous Performance",
      xGames: "{0} games",
      average: "Average",
      leagueAverage: "League Average",
      positionsPlayed: "Posições Jogadas",
      minMax: "Min & Max",
      top5Leagues: "Top 5 Ligas",
      infoMessage: "Selecione apenas uma época para ativar Min & Max",
      infoMessage2: "Selecione a mesma época para ambos os jogadores",
      dataPer90MinText: "Dados por 90 minutes",
      adjustToPossessionText: "* Ajustado à posse",
      text: "Texto",
      lollipop: "Lollipop",
      polar: 'Polar',
      radarTemplates: {
        Goalkeeper: "Guarda-redes",
        GoalkeeperCustom1: "Portero Personalizado 1",
        GoalkeeperCustom2: "Portero Personalizado 2",
        GoalkeeperCustom3: "Portero Personalizado 3",
        GoalkeeperCustom4: "Portero Personalizado 4",
        GoalkeeperCustom5: "Portero Personalizado 5",
        GoalkeeperCustom6: "Portero Personalizado 6",
        Defender: "Defesa",
        DefenderCustom1: "Defensa Personalizado 1",
        DefenderCustom2: "Defensa Personalizado 2",
        DefenderCustom3: "Defensa Personalizado 3",
        DefenderCustom4: "Defensa Personalizado 4",
        DefenderCustom5: "Defensa Personalizado 5",
        DefenderCustom6: "Defensa Personalizado 6",
        FullBack: "Lateral",
        FullBackCustom1: "Lateral Personalizado 1",
        FullBackCustom2: "Lateral Personalizado 2",
        FullBackCustom3: "Lateral Personalizado 3",
        FullBackCustom4: "Lateral Personalizado 4",
        FullBackCustom5: "Lateral Personalizado 5",
        FullBackCustom6: "Lateral Personalizado 6",
        FullBackPredictive: "Lateral",
        Midfielder: "Médio",
        MidfielderCustom1: "Centrocampista Personalizado 1",
        MidfielderCustom2: "Centrocampista Personalizado 2",
        MidfielderCustom3: "Centrocampista Personalizado 3",
        MidfielderCustom4: "Centrocampista Personalizado 4",
        MidfielderCustom5: "Centrocampista Personalizado 5",
        MidfielderCustom6: "Centrocampista Personalizado 6",
        MidfielderPredictive: "Médio",
        MidfielderDefensive: "Médio Defensivo",
        MidfielderOffensive: "Médio Centro",
        'AttackingMidfielder': "Médio Ofensivo",
        MidfielderWing: "Médio Ala",
        Winger: "Ala",
        WingerCustom1: "Extremo Personalizado 1",
        WingerCustom2: "Extremo Personalizado 2",
        WingerCustom3: "Extremo Personalizado 3",
        WingerCustom4: "Extremo Personalizado 4",
        WingerCustom5: "Extremo Personalizado 5",
        WingerCustom6: "Extremo Personalizado 6",
        WingerOffensive: "Ala ofensivo",
        Forward: "Avançado",
        ForwardCustom1: "Delantero Personalizado 1",
        ForwardCustom2: "Delantero Personalizado 2",
        ForwardCustom3: "Delantero Personalizado 3",
        ForwardCustom4: "Delantero Personalizado 4",
        ForwardCustom5: "Delantero Personalizado 5",
        ForwardCustom6: "Delantero Personalizado 6",
        ForwardPredictive: "Avançado",
        WingBack: "Ala",
        WingBackCustom1: "Carrilero Personalizado 1",
        WingBackCustom2: "Carrilero Personalizado 2",
        WingBackCustom3: "Carrilero Personalizado 3",
        WingBackCustom4: "Carrilero Personalizado 4",
        WingBackCustom5: "Carrilero Personalizado 5",
        WingBackCustom6: "Carrilero Personalizado 6",
        WingBackMedia: "Ala (SocialMedia)",
        FullBackMedia: "Lateral (SocialMedia)",
        MidfielderMedia: "Médio (SocialMedia)",
        WingerMedia: "Ala (SocialMedia)",
        ForwardMedia: "Avançado (SocialMedia)",
        PhysicalWingBack: "Físico Ala",
        PhysicalForward: "Físico Avançado",
        PhysicalWinger: "Físico Ala",
        PhysicalMidfielder: "Físico Médio",
        PhysicalFullBack: "Físico Lateral",
        PhysicalDefender: "Físico Defesa",
        PhysicalWingBackLMO: "Físico Ala",
        PhysicalForwardLMO: "Físico Avançado",
        PhysicalWingerLMO: "Físico Ala",
        PhysicalMidfielderLMO: "Físico Médio",
        PhysicalFullBackLMO: "Físico Lateral",
        PhysicalDefenderLMO: "Físico Defesa"
      },
      radarTemplatesWomen: {
        Goalkeeper: "Guarda-redes",
        Defender: "Defesa",
        FullBack: "Lateral",
        FullBackPredictive: "Lateral",
        Midfielder: "Médio",
        MidfielderPredictive: "Médio",
        MidfielderDefensive: "Médio Defensivo",
        MidfielderOffensive: "Médio Centro",
        'AttackingMidfielder': "Médio Ofensivo",
        MidfielderWing: "Médio Ala",
        Winger: "Ala",
        WingerOffensive: "Ala ofensivo",
        Forward: "Avançado",
        ForwardPredictive: "Avançado",
        WingBack: "Ala lateral",
        WingBackMedia: "Ala lateral (SocialMedia)",
        FullBackMedia: "Lateral (SocialMedia)",
        MidfielderMedia: "Médio (SocialMedia)",
        WingerMedia: "Extremo (SocialMedia)",
        ForwardMedia: "Avançado (SocialMedia)",
        PhysicalWingBack: "Físico Ala",
        PhysicalForward: "Físico Avançado",
        PhysicalWinger: "Físico Ala",
        PhysicalMidfielder: "Físico Médio",
        PhysicalFullBack: "Físico Lateral",
        PhysicalDefender: "Físico Defesa",
        PhysicalWingBackLMO: "Físico Ala",
        PhysicalForwardLMO: "Físico Avançado",
        PhysicalWingerLMO: "Físico Ala",
        PhysicalMidfielderLMO: "Físico Médio",
        PhysicalFullBackLMO: "Físico Lateral",
        PhysicalDefenderLMO: "Físico Defesa"
      },
      radarDescription: {
        basicStatistics: {
            title: "Estatísticas Base",
            minutes: "minutos",
            goals: "golos",
            assists: "assistências",
            redCards: "cartões vermelhos",
            yellowCards: "cartões amarelos",
            games: "jogos",
            goalsReceived: "golos sem penaltis sofridos",
            xGFaced: "xG faced"
        },
        //Inside, Ids of Profiles
        profiles: {
          //GoalKeeperBallPlaying
          3: {
            1: "Guarda-redes técnico com bola, tanto no passe curto como longo."
            // 2
            // 3
            // 4
            // 5
            // 6
            // 7
          },
          //Recuperaçõesdefensivas
          5: {
            1: "Defesa caracterizado pelos duelos individuais e por alto número de cortes e interceções.",
            // 2
            // 3
            // 4
            // 5
            // 6
            // 7
          },
          //Defesacombola
          6: {
            1: "Defesa com grande contribuição para a criação de oportunidades e boa visão de jogo.",
          },
          //LateraisMix
          7: {
            1: "Jogador com um desempenho equilibrado entre o jogo ofensivo (grande contribuição para \ 'xg Buildup\') e defensivo (grande volume de recuperações.",
          },
          //LateraisDefensiva
          8: {
            1: "Solido defensivamente no um-contra-um com um alto volume de recuperações, tanto para cortes como intercepções.",
          },
          //LateralOfensivo
          9: {
            1: "Jogador com grande contribuição ofensiva ao gerar ações perigosas e criar oportunidades.",
          },
          //MedioBoxToBox
          10: {
            1: "Jogador complete com capacidade de cobrir larga zona do campo, conseguindo contribuir para várias recuperações assim como tendo uma percentagem relevante de \'xG Buildup\' Com respeito para o que a equipa cria.",
          },
          //Mediorecuperadordebola
          11: {
            1: "Medio com alta performance defesiva e grande eficácia de passe apesar da pouca influência no ataque.",
          },
          //MedioDefensivo
          12: {
            1: "Medio complete com grande contribuição na criação de oportunidades e com grande eficácia aérea, assim como muita interceções e cortes.",
          },
          //ExtremoClassico
          15: {
            1: "Extremo com habilidades no um-contra-um e um bom nível de cruzamentos, gerando mais expetativas de assistências do que remates.",
          },
          //Extremoaberto
          16: {
            1: "Jogador com grande volume de bolas entrelinhas e progressões de bola, gerando oportunidades e com mais influência, em posse de bola, no meio do que no corredor.",
          },
          //ExtremoInterior
          17: {
            1: "Jogador com boas habilidades de drible, com movimentos interiores para gerar mais remates (xG) do que passes (xA).",
          },
          //PressãoAvançado
          18: {
            1: "Avançado que faz um excelente trabalho sem a bola nos pés, sabendo escolher bem o momento de finalizar ou de passar.",
          },
          //AvançadoMóvel
          22: {
            1: "Avançado com grande mobilidade para receber bolas entre linhas, descair para o corredor e com nível alto de oportunidades criadas. Alta percentagem de toques fora da área em relação ao total número de toques no jogo.",
          },
        },
        description: "DESCRIPTION",
        //Words
        conjuction: " and ",
        //¡¡¡¡ Please, don't remove conjuction2 !!!!
        conjuction2: " and ",
        over: "sobre",
        under: "por baixo",
        respectively: ", respetivamente",
        //Categories and quintiles description
        Defending1: {
            1: "A sua atuação defensiva está entre os piores das 5 principais ligas",
        },
        Defending2: {
            1: "Defensivamente não tem um bom papel dado que a atuação está abaixo da média",
        },
        Defending3: {
            1: "Defensivamente demonstra um bom pepel, o nível está um pouco acima da média",
        },
        Defending4: {
            1: "Excecional trabalho nas tarefas defensivas com atuações acima da média",
        },
        Defending5: {
            1: "Excecional em tarefas defensivas, com uma atuação semelhante aos melhores jogadores na posição nas 5 principais ligas",
        },
        Saving1: {
            1: "Guarda-Redes com uma atuação muito pobre, muitas dificuldades para bloquear remates",
        },
        Saving2: {
            1: "Não atua bem como guarda-redes dado que o nível está abaixo da média",
        },
        Saving3: {
            1: "Guarda-redes com nível de atuação aceitável, está entre a media nas 5 principais ligas metric_name",
        },
        Saving4: {
            1: "Guarda-redes com nível bom acima da média das 5 principais ligas, destacando-se especialmente in metric_name",
        },
        Saving5: {
            1: "Saving é um jogador muito completo, todas as suas métricas colocam-no entre o top 20% comparando-o com os guarda-redes das 5 principais ligas na europa.",
        },
        Passing1: {
            1: "Com a bola o nível dele está entre os piores jogadores",
        },
        Passing2: {
            1: "Quantos aos passes, as atuações está abaixo da média",
        },
        Passing3: {
            1: "Nível de passe é aceitável, ligeiramente acima da média",
        },
        Passing4: {
            1: "Muito bom nível de passe, muito acima da média",
        },
        Passing5: {
            1: "Muito efetivo no passe com uma atuação melhor do que muitos jogadores",
        },
        Aerial1: {
            1: "Jogador muito fraco no jogo aéreo, entre os piores na sua posição nesse aspeto",
        },
        Aerial2: {
            1: "Quanto a ganhar bolas aéreas, o jogador não atua bem, abaixo da média",
        },
        Aerial3: {
            1: "Nível aceitável no jogo aéreo, um pouco abaixo da média",
        },
        Aerial4: {
            1: "Grande atuação no jogo por cima, com grande eficácia neste respeito",
        },
        Aerial5: {
            1: "As suas métricas no jogo aéreo colocam-no entre os melhores",
        },
        Shooting1: {
            1: "Estatisticamente muito pobre em frente a baliza, dos piores jogadores nesse respeito",
        },
        Shooting2: {
            1: "Nível de remate com muito margem de melhoria, abaixo da média",
        },
        Shooting3: {
            1: "Trabalho aceitável no jogo ofensivo, ligeiramente acima da media",
        },
        Shooting4: {
            1: "Atua muito bem dentro da área, com uma atuação melhor que 60% dos jogadores",
        },
        Shooting5: {
            1: "Grandes habilidades nas tarefas ofensivas, com atuação espetacular, colocando-o entre os melhores nesse aspeto",
        },
        Association1: {
            1: "A atuação dele associada com a bola é muito baixa, entre os piores das 5 primeiras ligas",
        },
        Association2: {
            1: "Tem muito que melhorar com a bola nos pés dado que está muito abaixo de média neste aspeto",
        },
        Association3: {
            1: "Associa-se bem com a bola, ligeiramente acima da media",
        },
        Association4: {
            1: "Associa-se muito bem com a bola apresentando um nível muito extraordinário",
        },
        Association5: {
            1: "Habilidades extraordinárias em associar com a bola nos pés, entre os melhores jogadores",
        },
        BallHandling1: {
            1: "Terrível a manusear a bola, entre os piores comparando com as 5 principais ligas",
        },
        BallHandling2: {
            1: "Quanto a manusear a bola, os níveis estão muito abaixo da media",
        },
        BallHandling3: {
            1: "Nível aceitável a manusear a bola, ligeiramente acima da média",
        },
        BallHandling4: {
            1: "Nível alto em termos de manusear, com as estatísticas entre os melhores neste aspeto",
        },
        BallHandling5: {
            1: "Excecional nas habilidades de manusear a bola, entre os melhores nas 5 principais ligas",
        },
        Crosses1: {
          1: "Mau desempenho ao atravessar a bola para dentro da caixa. Entre os piores jogadores no cruzamento de métricas",
        },
        Crosses2: {
          1: "Desempenho abaixo da média na criação de perigo com as suas cruzes",
        },
        Crosses3: {
          1: "Nível aceitável, mas melhorando, de cruzes para dentro da caixa, um pouco over_under_average da média",
        },
        Crosses4: {
          1: "Boas estatísticas ao cruzar a bola, bem acima da média",
        },
        Crosses5: {
          1: "Entre os melhores jogadores a atravessar para a caixa, especificamente, entre os 20% melhores dos perfis mais eficazes a este respeito",
        },
        Carries1: {
          1: "Entre os piores 20% dos jogadores em termos de manipulação de bola",
        },
        Carries2: {
          1: "O seu desempenho de condução na posse está longe da média dos jogadores na sua posição",
        },
        Carries3: {
          1: "Desempenho próximo da média, ligeiramente acima da média, em termos de manipulação da bola",
        },
        Carries4: {
          1: "Jogador excepcional com muito boa profundidade e números de manipulação de bola",
        },
        Carries5: {
          1: "Manipulador de bolas muito talentoso, com um alto desempenho na métrica da categoria de Manipulação",
        },
        Turnovers1: {
          1: "O seu desempenho é muito negativo com um elevado volume de negócios que facilita aos oponentes a produção de perigo. Entre os piores desta métrica",
        },
        Turnovers2: {
          1: "Ele beneficia os adversários com os seus numerosos e perigosos volumes de negócios, precisa de melhorar muito e reduzir os seus volumes de negócios",
        },
        Turnovers3: {
          1: "Este jogador está ligeiramente acima_da_média em termos de volume de negócios, pelo que ainda há espaço para melhorar o seu desempenho",
        },
        Turnovers4: {
          1: "Desempenho notável nos turnos, acima dos 60% dos jogadores que perdem o menor número de bolas",
        },
        Turnovers5: {
          1: "Vale a pena notar os seus poucos turnovers, que o colocam entre os melhores jogadores na posse da sua equipa",
        },
        SequenceInvolvement1: {
          1: "Relativamente à posse de bola, os números falam mal deste jogador, muito poucas vezes ele termina as acções com um remate",
        },
        SequenceInvolvement2: {
          1: "O seu acabamento de posses é bastante improvável, ele dificilmente as termina com um tiro, e isso coloca-o bem abaixo da média",
        },
        SequenceInvolvement3: {
          1: "Nível aceitável quando se trata de terminar posse de bola à frente do objectivo, com um percentil um pouco over_under_average da média, tendo assim uma grande possibilidade de melhoria",
        },
        SequenceInvolvement4: {
          1: "Boa capacidade para terminar as posses da sua equipa com remates, alguns dos quais terminam em golos, tendo assim um desempenho notável nesta categoria",
        },
        SequenceInvolvement5: {
          1: "Ele está entre os melhores jogadores quando se trata de terminar as posses da sua equipa, terminando-as com tiros que geram perigo",
        },
        Physical1:{
          1: "O seu desempenho físico é dos piores em comparação com os jogadores das 5 principais ligas",
        },
        Physical2:{
          1: "Em termos de desempenho físico, está abaixo da média",
        },
        Physical3:{
          1: "Nível aceitável de desempenho físico, ligeiramente acima/abaixo da média",
        },
        Physical4:{
          1: "O seu desempenho físico é de alto nível, com valores próximos dos melhores",
        },
        Physical5:{
          1: "Desempenho físico excecional, entre os melhores das 5 principais ligas",
        }, 
        //Highlight metrics description
        OverMaxValue: {
            1: "Tem uma capacidade extrema em over_max_metric_name, com um desempenho acima do valor máximo o que faz com que este jogador nesse aspeto esteja no top 10% das 5 principais ligas"
        },
        OverAverageSeason: {
            1: "Quanto ao seu desempenho em over_average_metric_name está acima da média da Liga league_name (over_average_metric_value vs average_metric_value)",
            2: "Se compararmos os números dele com os da liga league_name, em over_average_metric_name podes dizer que o seu desempenho está acima da média (over_average_metric_value vs average_metric_value)",
        },
        UnderMinValue: {
            1: "Quanto a under_min_metric_name, deverá melhorar consideravelmente o seu desempenho, uma vez que o coloca no percent_metric_name mais baixo das 5 principais ligas"
        },
        Over70Percent: {
            1: "especialmente destacando-se em over_70_metric_name com over_70_metric_value por 90 minutos, respectivamente",
            2: "acima de 70% em over_70_metric_name com over_70_metric_value por 90 minutos, respectivamente",
            3: "realizar um trabalho mais do que notável em over_70_metric_name com over_70_metric_value por 90 minutos, respectivamente"
        },
        Under30Percent: {
            1: ", tendo de trabalhar mais na under_30_metric_name porque com under_30_metric_value por 90 minutos, respetivamente, o seu desempenho é baixo",
            2: "ter de melhorar notavelmente em under_30_metric_name uma vez que com under_30_metric_value por 90 minutos, respectivamente, o seu desempenho está abaixo do esperado",
            3: " quanto a under_30_metric_name com under_30_metric_value por 90 minutos, respectivamente, ele tem que se esforçar mais para obter melhores números",
        },
        OverAverageSeasonMoreThanOne: {
            1: "É bom destacar o seu desempenho excedendo a média da liga league_name em ",
        },
        OverAverageStats: {
            1: "over_average_metric_name (over_average_metric_value vs average_metric_value em média)"
        },
        Over70PercentIndividualPressure: {
            1: ", fazendo uma pressão individual muito boa para recuperar a bola",
            2: ", alta pressão sobre o adversário para buscar a bola de volta",
        },
        Under30PercentIndividualPressure: {
            1: ", ter que intensificar a sua pressão mais para recuperar a bola",
            2: "Ter de fazer mais esforço em termos de pressão sobre o rival",
        },
      },
      himSelf:"el mismo",
      ownSeason: "Own Season",
      minMaxTooltip: "Fit minimun and maximun values of radar"
    },
    login: {
        login: 'Login',
        latestBlogPosts: 'Últimos posts de blogue',
        signIn: 'Entrar',
        username: 'Nome de utilizador',
        password: 'Senha',
        passwordForgotten: 'Senha esquecida',
        signUp: 'Inscrever-se',
        enter: "Entre",
        forceTitle: "Conta em uso",
        forceMessage: "A conta já está associada a outro dispositivo. Queres apagar e ligar a este dispositivo?",
        forgotMyPassword: "Esqueci-me da senha",
        firstLogin: "Primeiro Login",
        firstLoginMessage: "Por razões de segurança tem que definir a nova senha do primeiro login. Juntamente com o idioma preferido da app",
        firstLoginOverview: "Aqui tem uma visão geral da sua conta, das ligas e dos produtos a que tem acesso.",
        passwordConfirmation: "Confirmação da senha",
        forgotPasswordMessage: "Digite o e-mail, se houver uma conta associada valida receberá na sua caixa de entrada os próximos passos para repor a senha",
        resetPassword: "Repor Senha",
        skipSettings: "Saltar definições",
        contact: "Contacto",
        cookiesText: "Este site utiliza cookies do Google para fornecer os seus serviços e analisar o seu tráfego para garantir a qualidade do serviço, gerar estatísticas de utilização e detectar e resolver abusos.",
        contactUs: "Contacte-nos",
        newsTitle: "Novidade: Novos templates!",
        newsText: "Atualizámos os nossos templates de Radar, Stats e Season para te oferecer mais personalização e controlo. Agora podes criar, editar e organizar os teus próprios templates, escolhendo se são públicos, privados ou supervisionados. Além disso, os templates de estatísticas e épocas vão ajudar-te a otimizar o teu fluxo de trabalho com seleções mais precisas e adaptadas às tuas necessidades. Explora as novas opções na secção Templates da barra lateral!"        
    },
    settings: {
      pageSubtitle: 'Configurar a sua experiência na aplicação',
      language: 'Lingua',
      availableLeagues: 'Ligas disponíveis',
      availableProducts: 'Produtos disponíveis',
      organization: "Organização",
      changePassword: "Alterar Password",
      seasonTemplates: "Modelos de época",
      seasonTemplatesSubtitle:"Crie seus próprios modelos de temporada que estarão disponíveis posteriormente para seleção no Ranking do Jogador e no Olheiro do Jogador",
      templateName: "Modelo de nome",
      selectTemplate:"Selecione o modelo a editar",
      radarDefault:"Predefinição Radar ",
      default: 'Predefinição',
      tabs: {
        options: "Opções",
        templates: "Templates",
        availableLeagues: "Ligas disponíveis",
        contactData: "GBE Contact Data"
      },
      contactData: {
        userDetails: "Detalhes de utilizador",
        firstName: "Primeiro Nome",
        lastName: "Ultimo Nome",
        contactDetails: "Contact Details for GBE",
        name: "Nome",
        phone: "Telefone",
        mobile: "Telemóvel",
        email: "E-mail",
        representativeDetails: "Detalhes representativos para GBE",
      },
      currency: "Moeda",
      fieldPreferences: "Preferências de campo",
      visualizationsPreferences: "Preferencias de visualização",
      fieldColor: "Cor do terreno",
      fieldColors: {
        green: "Verde",
        blue: "Azul",
        white: "Branco",
        black: "Preto",
        grey:"Grey"
      },
      defaultPlayerVisualization: "Visualização padrão do jogador",
      appPreferences: "Preferências da aplicação",
      darkMode: "Modo negro",
      showTour: "Mostrar visita guiada",
      customStats: "Estatisticas personalizadas",
      radarTemplates: "Radar Templates",
      radarTemplatesSubtitle: "Crie seus próprios modelos de métricas que estarão disponíveis posteriormente para seleção em Desempenho do Jogador e Classificação do Jogador",
      radarCategories:{
        Custom1: "Custom 1",
        Custom2: "Custom 2",
        Custom3: "Custom 3",
        Custom4: "Custom 4",
        Custom5: "Custom 5",
        Custom6: "Custom 6",
        Physical: "Físico",
        CustomPhysical1: "Custom Físico 1",
        CustomPhysical2: "Custom Físico 2",
        CustomPhysical3: "Custom Físico 3",
        CustomPhysical4: "Custom Físico 4",
        CustomPhysical5: "Custom Físico 5",
        CustomPhysical6: "Custom Físico 6",
      },
      templateRemoveTitle:"Remove Template",
      templateRemoveMsg: "Do you want to remove this template?",
      templateEditTitle: "Guardar modelo",
      templateEditMsg: "Existe um modelo não guardado, pretende guardá-lo antes de carregar outro modelo?",
      category:"Category",
      playerRadar:"Player Radar",
      teamRadar:"Team Radar",
      statsAlert:"Insert at least one stat to save",
      recommended: "Recomendado",
      warning: "Há posições que atingiram o número máximo de radares permitido. Por favor, elimine ou edite qualquer modelo",
      fieldPositions: {
        default: "Driblab",
        fifa: "FIFA",
        spanish: "Espanhol",
        numeric: "Numérico"
      },
      showCustomeTemplates: "Mostrar modelos personalizados",
      showMediaMode: 'Mostrar modo multimédia',
      statTemplates: "Modelos de Estatísticas de Jogo",
      statTemplatesSubtitle: "Crie os seus próprios modelos selecionando entre uma grande variedade de métricas",
    },
    playerDetail: {
      passport: 'Passaporte',
      secondPassport: 'Segundo Passaporte',
      age: 'Idade',
      dateOfBirth: 'Data de nascimento',
      height: 'Altura',
      weight: 'Peso',
      wage: 'Salário',
      history: 'Historia',
      positions: 'Posições',
      injuries: 'Lesões',
      transfers: 'Transferências',
      nationalTeam: 'Seleção Nacional',
      addFavorite: "Adicionar aos favoritos",
      removeFavorite: "Remover dos favoritos",
      contractEnd: "Contracto termina",
      yearsOld: " anos de idade",
      playerAvailability: "Disponibilidade",
      playerUsage: "Minutos jogados",
      usage: "Uso",
      addToCollection: "Adicionar a coleção",
      performance: "Atuação",
      info: "Informação",
      career: "Carreira",
      playerStyle: "Estilo de jogo",
      radar: "Radar",
      finishingMap: "Mapa de Gols Marcados",
      threatMap: "Mapa de perigo",
      keyPassMap: "Mapa de passes chaves",
      beeswarm: "Ranking",
      allGames: "Todos os jogos",
      eventsMap: "Mapa de eventos",
      fullName: "Nome completo",
      academy: "Academia",
      name: "Nome",
      lastName: "Ultimo nome",
      playerAvailabilityLong: "% da época sem lesões ou suspensões",
      playerUsageLong: "Minutos jogados",
      playerAvailability1: "Jogos sem lesões ou suspensões",
      playerAvailability2: "Jogos esta época",
      playerUsage1: "minutos jogados",
      playerUsage2: "minutos totais da equipa",
      notMinutesThisSeason: "Não jogou minutos esta época",
      seasonPlaceholder: "Não existe época ativa",
      inactivePlayer: "Jogador inativo",
      inactivePlayerMessage: "Se precisar de mais informação, pode pedir um relatório",
      goRequest: "Ir para requisito",
      warningMinutes: "Causão: Menos de 450 minutos jogados, analise pode não ser representativa",
      warningSeasonGames: "Época tem menos 5 jogos jogados, portanto Min & Max são 'Top 5 ligas'",
      warningStatsRemoved: 'Algumas estatísticas não são mostradas porque não estão disponíveis para a temporada selecionada',
      warningBeeswarm: "Jogador não mostrado porque não há dados disponíveis para a temporada selecionada",
      warningPlayersZeroValue: "Não mostrar {x} jogadores com 0 ",
      onlyPlayersThatFit: "Só jogadores que encaixem no radar modelo",
      gamesPlayedNotEnough: "Opções desativadas devido ao número insuficiente de jogos realizados",
      gbe: "GBE",
      analysis: "Analise",
      documents: "Documentos",
      rankDefensive: "Defensiva",
      rankBallHandling: "Manusear a bola",
      rankGoal: "Contribuição para golo",
      rankXt: "Ameaça",
      rankIndex: "Index",
      visitHistory: "Ver histórico",
      placer: "Campo",
      touchesMap:"Mapa de toques",
      heatMap:"Mapa de calor",
      ageProfile:"Age Profile",
      strongFoot:"Strong foot",
      player: 'Jogador',
      outOf: 'de',
      in: 'na',
      careerTable: {
        nationalTeamCareer: "Carreira na Seleção Nacional",
        nationalTeamCompetitions: "Competições da Seleção Nacional"
      },
      physicalProgression:"Physical Progression",
      gpi: "Índice Global de Jogadores",
      warningGPI: "Disponível apenas para jogadores ativos em ligas ELO nos últimos 30 dias",
      diffGPI: "Variação desde o último jogo",
      rankingInTheWorld: "#{0} no mundo",
      rankingInTheLeague: "#{0} em {1}",
      max: "Máx",
      gpiChart: "Gráfico baseado no valor do Índice Global de Jogadores dos últimos {0} jogos"
    },
    finishingMap: {
      typesOfShot: "Tipos de remate",
      shotStrategy: "Estratégia de remate",
      areas: "Área",
      bodyPart: "Parte corporal",
      more: "mais",
      selectAll: "Selecionar tudo",
      minutes: "Minutos",
      circles: "Círculos",
      boxes: "Caixas",
      lines: "Linhas",
      games: "Jogos",
      perShot: "por Remate",
      goal: "Golo",
      missedShot: "Remate falhado",
      savedShot: "Remate defendido",
      shotOnPost: "Remate ao poste",
      missedChance: "Oportunidade falhada",
      openPlay: "Jogo aberto",
      regularPlay: "Jogada regular",
      fastBreak: "Contra-ataque",
      individualPlay: "Jogada individual",
      setPiece: "Bola Parada ",
      fromCorner: "Através do Canto",
      freeKick: "Livre direto",
      indirectFreeKick: "Livre indireto",
      throwInSetPiece: "Lançamentos laterais",
      inBox: 'Na área',
      goalArea: 'Pequena área',
      boxLeft: 'Caixa esquerda',
      boxCenter: 'Caixa central',
      boxRight: 'Caixa direita',
      outOfBox: 'fora da caixa',
      outBoxDeepLeft: 'Fora da Caixa descaído para a esquerda',
      outBoxDeepRight: 'Foras da caixa descaído para a direita',
      outBoxLeft: 'Fora da Caixa esquerda',
      outBoxCentreLeft: 'Fora da Caixa centro-esquerda',
      outBoxCentre: 'Fora da Caixa centro',
      outBoxCentreRight: 'for a da Caixa centro-direita',
      outBoxRight: 'Fora da Caixa direita',
      left35: '+35 esquerda',
      centreLeft35: '+35 Centro-esquerda',
      centre35: '+35 Centro',
      centreRight35: '+35 Centro-direita',
      right35: '+35 Direita',
      head: "Cabeça",
      rightFooted: "Destro",
      leftFooted: "Canhoto",
      otherBodyPart: "Outra parte do corpo",
      chart: {
        shots: "Remate",
        xGPerShot: "xG por remate",
        exceptionTextPenaltyGoals: "* Penaltis = 0.765 xG",
        exceptionTextGKPenaltyGoals: "* Penaltis = 0.765 xGOT",
        exceptionTextOwnGoals: "* Autogolo não são contabilizados",
        og: "OG",
        penaltiesExcluded: "Golos de penalti excluídos ",
        ownGoalsExcluded: "Golos próprios excluídos",
        sumOfxG: "Sum of xG",
        exceptionShotsOutOfRange: "* Não mostra os remates fora de alcance"
      },
      inGoal: "Na baliza",
      outOfGoal: "Fora da baliza",
      highLeft: "Alta esquerda",
      highCenter: "Alto centro",
      highRight: "Alta direita",
      lowLeft: "Inferior esquerdo",
      lowCenter: "Low Center",
      lowRight: "Inferior direito",
      outHighLeft: "Fora esquerda alta",
      high: "Centro Superior fora",
      outHighRight: "Fora direito alto",
      closeHighLeft: "Esquerda alta perto",
      closeHigh: "Centro alto perto",
      closeHighRight: "Alta direita perto",
      closeLeft: "Perto baixa esquerda",
      closeRight: "Perto baixo direito",
      finishingTable: "Finishing Table",
      onGoal: "On Goal",
      distributionFilters: "Filtros de distribuição",
      penalty: "Penálti",
      penaltyShootout: "Disputa de penáltis",
      onlyPercentage: "Mostrar percentagem",
      showAll: "Mostrar tudo"
    },
    keyPassMap: {
      chart: {
          keyPasses: "Passes chave",
          xAPerPass: "xA por passe",
          xAOpenPlay: "xA bola corrida",
          xASetPiece: "xA Bola Parada"
      }
    },
    beeswarm: {
      template: 'Modelo',
      templates: {
        'Goalkeeper': 'Guarda-redes',
        'Defender': 'Defesa',
        'Full-Back': 'Lateral',
        'FullBack': 'Lateral',
        'Wing-Back': 'Ala',
        'WingBack': 'Ala',
        'Midfielder': 'Medio',
        'AttackingMidfielder': 'Medio ofensivo',
        'Winger': 'Ala',
        'Forward': 'Avançado',
        'Physical': 'Físico'
      },
      compareWith: "Comparar com",
      highlightPlayersOf: "Destacar jogadores de",
      highlightPlayers: "Destacar jogadores",
      per90: "Dados por 90 minutos",
      highlightTeams: "Destacar equipas",
      filterTeams: "Filtrar equipas",
      warningZeros: "Apenas para estatísticas não invertidas"
    },
    collections: {
      newCollection: "Nova coleção",
      editCollection: "Editar coleção",
      name: "Nome",
      visibility: "Visibilidade",
      privacity: {
          publicTitle: "Publico",
          publicDescription: "Visível para ti e o clube",
          privateTitle: "Privado",
          privateDescription: "Só visível para ti",
          supervisedTitle: "Supervisionado",
          supervisedDescription: "Apenas visível para si e para o seu supervisor",
      },
      addSuccess: "Adicionado com sucesso",
      createAddSuccess: "Criado e adicionado com sucesso",
      editSuccess: "Atualizado com sucesso",
      deleteSuccess: "Eliminado com sucesso",
      title: "Collections of players",
      publics: "Publics",
      privates: "Privados",
      supervised: "Supervisionado",
      totalMarketValue: "Valor de mercado total",
      avgMarketValue: "Valor de mercado medio",
      avgAge: "Idade media",
      searchBarPlaceholder: "Para adicionar a coleção, pesquisa e escolha jogadores",
      deleteCollection: "Eliminar coleção",
      deleteCollectionMessage: "Coleção vai ser eliminada, tem a certeza?",
      removePlayer: "Remover jogador",
      removePlayerMessage: "Jogador vai ser resolvido da coleção, tem a certeza",
      subtitle: "Organizar o scouting",
      notExitingTemplate: 'Ainda não existem modelos',
    },
    searchbar: {
      placeholder: "tipo de pesquisa (e.x. `david arsenal´)",
      players: "Jogadores",
      teams: "Equipas",
      games: "Jogos",
      leagues: "Ligas",
      explore: "Explorar mais resultados",
      placeholderNoResults: "Sem resultados por modelo",
      teamPlaceholder: "Para comparar um equipa, procure e selecione",
    },
    favorites: {
      showOnly: "Mostrar só",
      selfFavorites: "Meus favoritos",
      clubFavorites: "Clube favoritos",
      contractExpiration: "Expiração de contrato",
      groupBy: "Grupo de",
      noGrouped: "Nenhum",
      maxSelection: "Só consegue selecionar ",
      selectAtleastOne: "Selecionar pelo menos um",
      comparePlayers: "Comparar jogadores",
      selectedPlayers: "Jogadores selecionados",
      subtitle: "Continuar a seguir futuras estrelas",
      generateXlsx: "Generate XLSX",
      generating: "Generating...",
      subscribed: "Subscribed",
      subscribedTooltip:"Subscribe to recieve a mail when a game have been played"
    },
    expiration: {
      summer: "Verão",
      winter: "Inverno"
    },
    positions: {
      goalkeepers: "Guarda-Redes",
      defenses: "Defesas",
      midfielders: "Médios",
      forwards: "Avançados",
      goalkeeper: "Guarda-Redes",
      defender: "Defesa",
      defenders: "Defesa",
      fullback: "Lateral",
      fullbacks: "Laterais",
      midfielder: "Médio",
      midfielders: "Médios",
      winger: "Ala",
      wingers: "Alas",
      forward: "Avançado",
      wingback: "Defesa ala",
      wingbacks: "Defesa ala",
      noposition: "Sem Posição"
    },
    dPos: { //Dallas Positions
      1: { name: "Goalkeeper", alias: ""},
      2: { name: "Right Full Back", alias: "RFB"},
      3: { name: "Right Center Back", alias: "RCB"},
      4: { name: "Left Center Back", alias: "LCB"},
      5: { name: "Left Full Back", alias: "LFB"},
      6: { name: "Defensive Midfielder", alias: "DM"},
      7: { name: "Right Winger", alias: "RW"},
      8: { name: "Center Midfielder", alias: "CM"},
      9: { name: "Striker", alias: "ST"},
      10: { name: "Attacking Midfielder", alias: "AM"},
      11: { name: "Left Winger", alias: "LW"},
    },
    charts: {
      seasonsCompareSelectLabel: "Comparar com ",
      lastSeasonSelectText: "Última época",
      lastAndCurrentSeasonSelectText: "Ultima + Época presente",
      currentSeasonSelectText: "Presente época",
      last20gamesSelectText: "Últimos 20 jogos",
      last10gamesSelectText: "Último 10 jogos",
      npgVsXGTitle: "Golos sem-penaltis VS xG",
      totalXGLabel: "Total xG",
      xGLabel: "xG",
      totalNPGLabel: "Totais golos sem penaltis",
      xGAgainstvsNPGAgainstTitle: "xG Contra vs sem penalties golos contra",
      totalXGAgainstLabel: "Total xG Contra",
      xGAgainstLabel: "xG Contra",
      totalNPGAgainstLabel: "Total Golos sem penalties",
      xGvsxGAgainstTitle: "xG VS xG Contra",
      pointsVsXPointsTitle: "Pontos VS Expectativa de pontos",
      xTTitle: "Fluidez de jogo",
      totalXPoints: "Total xPontos",
      totalPoints: "Total Pontos",
      requestedReports: "Relatórios requisitados",
      playersScouted: "Jogadores observados ",
      performanceVSAverageChart: "Atuação VS Media",
      perPositions: "Por posições",
      perLeagues: "Por ligas",
      perMonths: "Por Mês",
      perClients: "Por Clientes",
      ofPreposition: "de",
      idJChartTitle: "Iniciativa de jogo",
      idJChartLabel: "Index GI",
      vJOChartTitle: "Volume de jogo ofensivo",
      vJOChartLabel: "Index OGV",
      preJOChartTitle: "Precisão de jogo ofensivo",
      preJOChartLabel: "Index OGPre",
      proJOChartTitle: "Progressão de jogo ofensivo",
      proJOChartLabel: "Index OGPro",
      chart: "Gráfico",
      table: "Tabela"
    },
    table: {
        history: {
            season: 'Época',
            team: 'Equipa',
            position: 'Position',
            side: 'Side',
            games: 'Games',
            minutes: 'Mins',
            goals: 'NPG (G)',
            assists: 'A',
            yellowCards: 'YC',
            redCards: 'RC',
            gameLost: 'GM',
            gamesMissed: "Jogos Ausente"
        },
        injury: {
            season: 'Época',
            team: 'Equipa',
            injury: 'Lesão',
            dateFrom: 'Data de início',
            dateTo: 'Deta de fim',
            daysLost: 'Dias perdidos',
            gamesLost: 'Jogos perdidos',
            allInjuries: 'All Injuries'
        },
        transfers: {
            season: 'Época',
            date: 'Data',
            teamFrom: 'Equipa de',
            teamTo: 'Equipa para',
            marketValue: 'Valor de mercado',
            fee: 'Propina',
            type: 'Tipo'
        },
        caps: {
            team: 'Equipa',
            debut: 'Estreia',
            games: 'Jogos',
            goals: 'Golos',
            coachDuringDebut: 'Treinador durante a estreia',
            debutAge: 'Idade de Estreia',
        },
        roster: {
            country: 'Pais',
            player: 'Jogador',
            positions: 'Posições',
            minutes: 'Minutos',
            games: 'Jogos',
            goals: 'Golos',
            assists: 'Assistências',
            cards: 'Cartas',
            gamesExplicit: 'Jogos Jogados',
        },
        league: {
            title: "Ficha da liga",
            subtitle: "Aprofundar a classificação e as estatísticas da liga",
            team: 'Equipa',
            games: 'JJ',
            gamesExplicit: 'Jogos Jogados',
            gamesRanking: 'JJ',
            gamesRankingExplicit: 'Jogos Jogados',
            points: 'Pts',
            pointsExplicit: 'Pontos',
            expectedPoints: 'xP',
            expectedPointsExplicit: 'Pontos expectáveis',
            goalsScored: 'GSP',
            goalsScoredExplicit: 'Golos sem penâlti',
            xG: 'xG',
            xGExplicit: 'Golos sem penâlti',
            goalsAgainst: 'GSPC',
            goalsAgainstExplicit: 'Golos sem penâlti contra',
            xGAgainst: 'xGC',
            xGAgainstExplicit: 'Golos Contra expectáveis',
            xGAgainstDiff: 'xGC Diff',
            xGAgainstDiffExplicit: 'Diferença golos contra expectáveis',
            form: 'Form',
            sos:"SoS",
            sosExplicit:"Strength of Schedule",
            sosHfa: "SoS HFA",
            sosHfaExplicit:"Home Field Advantage",
            difficultyAboveAvg:"Difficulty above average",
            differentGames: "* Different Number of Games Played",
            berth: "Classificação"
        },
        usersOfClient: {
            userName: 'Nome',
            userRole: 'User',
            devRole: 'Dev',
            adminRole: 'Admin',
            servicesRole: 'Serviços',
            xgRole: 'XG',
            radarRole: 'Radar',
            beeswarmRole: 'Ranking',
            elevenRole: 'Onzes',
            similarityRole: 'Semelhanças',
            gameAnalysisRole: 'Análise de jogo',
            clientStatsRole: 'Estatística de cliente',
            created: 'Criado',
            type: "Tipo",
            logins: "Logins",
            lastLogin: "Ultimo Login",
            trialDate: "Data de captação"
        },
        clientLeagues: {
            league: 'Liga',
            area: 'Área',
            tier: 'Escalão',
            seasons: 'Épocas',
            currentMatchDay: 'Dia de Jogo',
            regular: 'Regular',
            youthLeague: 'Jovem',
            clientActive: 'Activo',
            visibleLeagues: "Ligas visíveis"
        },
        connections: {
            title: 'Combinações comum',
            playerFrom: 'De jogador',
            playerTo: 'Para jogador',
            passes: 'Passes',
            passesTooltip: 'Total Número de passes bem-sucedidos',
            passesFinalThird: "PF ⅓",
            passesFinalThirdTooltip: "Passes último terço"
        },
        playerPassMapData: {
            title: 'Estatísticas de passe',
            player: 'Jogador',
            passes: 'Passes',
            passesPct: '% Passes',
            xA: 'xA',
            xG: 'xG',
            xT: 'xThreat',
            playerTooltip: 'Nome de jogador',
            passesTooltip: 'Total número de passes',
            passesPctTooltip: '% Passes bem-sucedidos',
            xATooltip: 'Assistências expectáveis',
            xGTooltip: 'Golos expectáveis',
            xTTooltip: 'Perigo expectável'
        },
        playerAllGames: {
            gameDate: 'Data',
            game: 'Jogo',
            team: "Equipa",
            positionsPlayed: 'Posições',
            minsPlayed: 'Minutos',
            gameActions: 'Acções',
            gameDateTooltip: 'Data de Jogo',
            gameTooltip: 'Jogo',
            positionsPlayedTooltip: 'Posições jogadas',
            minsPlayedTooltip: 'Minutos jogados',
            gameActionsTooltip: 'Golos, Assistências, Cartas',
            from: "De",
            to: "Para",
            goalText: "Golo no",
            assistText: "Assistência no",
            penaltyText: "Penálti no",
            ownGoalText: "Autogolo no",
            yellowCardText: "Cartão amarelo no",
            secondYellowCardText: "Segundo cartão amarelo no",
            redCardText: "Cartão Vermelho no",
            substitutionIN: "Dentro no",
            substitutionOUT: "Fora no",
            suspendedText: "Suspensão"
        },
        gameFlow: {
            phase: "Fase ",
            mins: "Minutos",
            team: "Equipa",
            period: "Periodo",
            possession: "%Poss.",
            possessionTooltip: "% Posse",
            xT: "xPerigo",
            xTTooltip: "Perigo expectável",
            pft: "PU ⅓",
            pftTooltip: "Passes último terço",
            xG: "xG",
            xGTooltip: "Golos Expectáveis"
        },
    },
    game: {
      title: "Ficha de jogo",
      subtitle: "Aprofundar as características e estatísticas do jogo",
      header: {
        gameDetails: 'Detalhes do jogo',
        gameStats: 'Stats',
        gameXGMap: 'Mapa xG jogo',
        gameXAMap: 'Mapa xA jogo',
        gamePassMap: 'Mapa de passes',
        gameThreat: 'Perigo no jogo',
        gameFlow: 'Fluidez d jogo',
        gameAnalysis: 'Analise de jogo',
        possessions: 'Posse',
        bench: 'Banco',
        video: 'Video highlights'
      },
      passMap: {
        team: 'Equipa',
        minutes: 'Minutos:',
        select: 'Seleccionar',
        all: 'Todos',
        attacking: 'Atacar',
        defending: 'Defender',
        forwards: 'Avançado',
        backwards: 'Retaguarda',
        sideways: 'Lateral',
        longBall: 'Bola longa',
        successfullPasses: 'Passes bem-sucedidos',
        homeTeam: 'Casa',
        awayTeam: 'Fora',
        passingMatrix: 'Matriz de passagem'
      },
      stats: {
        summary: "Summary",
        attacking: 'Attacking',
        defending: 'Defending',
        contribution: "Contribution",
        possession: "Posse",
        expectedPoints: "Pontos expectáveis",
        directness: "Objetivos",
        ppda: "PPDA",
        xg: "xG",
        xG: "xG",
        xGSetPiece: "xG Bola Parada",
        xA: "xA",
        xASetPiece: "xA Bola Parada",
        xT: "xT",
        xTSetPiece: "xT Bola Parada",
        touchesInOppBox: "Toques na área adversária",
        passesFinalThird: "Passes último Terço",
        interceptions: "Interceções",
        recoveries: "Recuperações",
        recoveriesOppHalf: "Recuperações Opponent Half",
        tackles: "Abordagens",
        tacklesWasDribbled: "Cortes foi driblado",
        fouls: "Fouls",
        yellowCards: "Cartão amarelo",
        redCards: "Cartão vermelho",
        passes: "Passes",
        passing: "Passes %",
        crosses: "Cruzamentos",
        crossing: "Cruzamentos %",
        shots: "Remates",
        shotsOnTarget: "Remates no Alvo",
        ppdaExplicit: "Passes por ações defensivas",
        xgExplicit: "Golos expectáveis",
        xp: "xP",
        seasonAvg: "Média competição",
        winChance: "Probabilidade Ganhar",
        postGameWinChance: "Probabilidade de vitória após o jogo",
        winChanceTooltip: "Based on xG generated and conceded",
        drawChance: "Empatar",
        xgAgainst: "xG Contra",
        averagePossession: "Posse média",
        averageShots: "Média de remates",
        averagexG: "Media de golos expectáveis",
        fieldTilt: "Field Tilt",
        fieldTiltExplicit: "Field Tilt"
      },
      detail: {
          halfTime: "Intervalo",
          overTime: "Descontos",
          showStats: "Estatísticas do espetáculo",
          hideStats: "Esconder estatísticas",
          bench: "Banco",
          showShotOptions: "Mostrar opções de remate",
          hideShotOptions: "Esconder opções de remate",
          showPassOptions: "Mostrar opções de passe",
          hidePassOptions: "Esconder opções de passe",
          endGame: "Tempo final",
          penalties: "Penâltis"
      },
      timeline: {
          events: {
              goal: "Golos",
              goal_ownGoal: "Autogolos",
              goal_penalty: "Golos de penálti",
              card: "Cartão",
              card_yellowCard: "Cartão amarelo",
              card_secondYellowCard: "Segundo cartão amarelo",
              card_redCard: "Cartão vermelho",
              formationChange: "Mudanças na formação",
              substitution: "Substituição",
              saveShot: "Remate defendido",
              saveShot_penalty: "Penálti defendido",
              missedShot: "Remate falhado",
              missedShot_penalty: "Penálti falhado",
              shotOnPost: "Remate ao poste",
              shotOnPost_penalty: "Remate ao poste no penálti"
          }
      },
      gameFlow: {
          goalOf: "Golo de ",
          redCardTo: "Cartão vermelho para",
          missedPenalty: "Pena perdida"
      },
      gameThreat: {
          typeOfPlay: 'Tipo de Ação',
          regularPlay: 'Jogada regular',
          setPiece: 'Bola Parada',
          setPiecePlay: 'Bola Parada',
          throwInSetPiecePlay: 'Jogada de Lançamento lateral',
          throwInPlay: 'Lançamento lateral',
          gkThrow: 'Chute do Goleiro',
          gkKick: 'Tiro de Meta',
          kickOff: 'Começo',
          actionEnding: 'Fim de ação',
          pass: 'Passe',
          shot: 'Remate',
          foul: 'Falta',
          other: 'Outro',
          threat: 'Perigo',
          legendSumOfXT: 'Soma de xT',
          legendPass: 'Passe',
          legendShot: 'Remate',
          legendCarryAndAction: 'Condução e ação',
          legendCarryAndPass: 'Condução e passe',
          legendOnlyShowing: 'Só mostrar ações individuais com xT > ',
          legendOnlyShowingPart1: 'Só mostrar individual',
          legendOnlyShowingPart2: 'Ações com xT > ',
          legendOnlyShowingSetPiece: 'Só mostrar ações de bola parada com xT>',
          legendOnlyShowingOpenPlay: 'Só mostrar ações de jogadas com xT>',
          legendPlays: 'Ações',
          legendPerPlay: 'por Acção',
          legendCarry: 'Codução',
          penaltyPlay: 'Penálti',
          freeKickTakenPlay: "Jogada livre direto",
          cornerTakenPlay: "Jogada de canto",
          fromCornerPlay: "Jogada de canto",
          keeperThrowPlay: "Jogada de Lançamento de guarda-redes",
          fastBreakPlay: "Jogada de contra-ataque",
          indirectPlay: "Jogada indireta",
          minutes: "Minutos",
          games: "Jogos",
          xT: "xT",
          xTPer90: "xT por 90'"
      },
      gameAnalysis: {
        next: "Próximo",
        previous: "Anterior",
        phaseLabel: "Fase",
        phasesLabel: "Fases",
        dot: ". ",
        comma: ", ",
        from: "De",
        to: "Para",
        and: " e ",
        steps: {
          finishingMapFullGame: "Mapa de gols marcados",
          keyPassMapFullGame: "Mapa de passes chave",
          gameFlow: "Fluidez de jogo",
          finishingMapPerPhases: "Mapa de gols marcados por fases",
          keyPassMapPerPhases: "Mapa de passes chaves por fases",
          passMapPerPhases: "Mapa de passes por fases",
        },
        step1: {
          table: {
            draw: "Empate",
            win: "Vitória",
            lose: "Lose",
            possession: "Posse de bola",
            xP: "Pontos expectáveis",
            directness: "Objetividade ",
            ppda: "PPDA",
            xG: "xG",
            xGOpenPlay: "xG Jogada",
            xGSetPiece: "xG Bola Parada",
            xA: "xA",
            xAOpenPlay: "xA Jogadas ",
          },
          text: {
            firstParagraph: {
                1: "O mapa à direita demonstra os golos expectáveis gerados pelo home_team_name e away_team_name. Os círculos recarregados são os remates que acabaram em golo. O tamanho do círculo depende do xG valor de cada remate.",
            },
            lastParagraph: {
                1: "A percentagem de probabilidade de um resultado e o número de golos expectáveis são calculados através de simulação de remates (100,000 simulações de remate são conduzidas e a possibilidade de resultados e de ganhar pontos são avaliados de forma preditiva).",
            },
            targetHighTeamXG: {
                1: "target_team_name, assim como rival_team_name, conseguiram criar um volume alto de golos expectáveis",
            },
            targetHighTeamOpenPlayXG: {
                1: ", com a maioria de chances criadas por target_team_name através de jogadas",
            },
            targetHighTeamOpenPlayXGvsGameRival: {
                1: ", mas atuaram melhor ao gerar chances através de jogadas",
            },
            targetHighTeamSetPieceXG: {
                1: ", com a maioria de chances de target_team_name criadas através de bola parada",
            },
            targetHighTeamSetPieceXGvsGameRival: {
                1: ", mas atuaram melhor ao gerar chances através de bola parada",
            },
            targetHighTeamCornerXG: {
                1: ", com a maioria de chances criadas através de cantos",
            },
            targetLowTeamGoalConversion: {
                1: ", apesar das oportunidades concretizadas ser abaixo do expectável ",
            },
            dot: {
                1: ". ",
            },
            targetHighTeamXGOPandSP: {
                1: "target_team_name criaram um volume alto de golos expetáveis tanto em jogadas ou bola parada",
            },
            targetHighTeamGoalConversion: {
                1: " também ter um rácio alto de golos convertidos",
            },
            targetLowTeamGoalConversionZeroGoals: {
                1: ", não ter habilidade de marcar qualquer oportunidade de golo",
            },
            targetLowTeamGoalConversionScoringGoals: {
                1: " mas criaram perigo para marcar mais golos",
            },
            targetHighTeamXGvsGameRival: {
                1: "Neste jogo, target_team_name geraram mais perigo do que rival_team_name",
            },
            targetLowTeamGoalConversionScoringGoals2: {
                1: " e podia e devia ter marcado mais golos. ",
            },
            targetHighTeamXGZeroGoals: {
                1: " mas não foi capaz de marcar qualquer golo das oportunidades criadas.",
            },
            targetHighTeamXGGoalDiff: {
                1: " Coincidindo uma oportunidade vencedora da team_winning_chance para a simulação pós-jogo.",
            },
            startTargetHighTeamOpenPlayXG: {
                1: " Maioria das oportunidades criadas por target_team_name vieram de jogadas.",
            },
            startTargetHighTeamSetPieceXG: {
                1: " Maioria das chances de target_team_name originaram de bola parada.",
            },
            startTargetHighTeamCornerXG: {
                1: " Maioria das chances vieram de cantos.",
            },
            targetSimilarTeamXG: {
                1: "Neste jogo ambas as equipas geraram ações de perigo semelhantes ao rival em termos de xG.",
            },
            targetSimilarTeamXGGoalDiff: {
                1: "mas a target_team_name atuou melhor na gols marcados.",
            },
            targetLowTeamXGGoalDiff: {
                1: "Apesar do resultado, target_team_name não geraram mais perigo em termos de golos expetáveis.",
            },
            targetLowTeamXGZeroGoalDiff: {
                1: "target_team_name não gerou mais perigo em termos de golos expectáveis para ganhar o jogo",
            },
            rivalHighTeamXG: {
                1: "e permitiram target_team_name gerar demasiado perigoso.",
            },
            rivalHighTeamXGGoalDiff: {
                1: "Com esta criação, a equipa target_team_name só conseguiria vencer a team_winning_chance através da simulação pós jogo.",
            },
            targetHighTeamOpenPlayXG: {
                1: "Neste jogo, a maioria das chances da target_team_name veiram de jogadas",
            },
            targetHighTeamOpenPlayXGvsGameRival: {
                1: "Neste jogo, a maioria das chances da target_team_name originou através jogadas abertas (ao invés da rival_team_name)",
            },
            targetHighTeamSetPieceXG: {
                1: "Neste jogo, a maioria das chances da target_team_name originou através de bola parada",
            },
            targetHighTeamSetPieceXGvsGameRival: {
                1: " Neste jogo, a maioria das chances da target_team_name originou através de bola parada (ao invés da rival_team_name)",
            },
            targetHighTeamCornerXG: {
                1: " Neste jogo, a maioria das chances da target_team_name originou através cantos.",
            },
            targetHighTeamGoalConversion2: {
                1: " ter um alto rácio de conversão de golos",
            },
            targetLowTeamGoalConversionZeroGoals: {
                1: ", não conseguir marcar qualquer das chances criadas",
            },
            targetLowTeamGoalConversion: {
                1: " mas a conversão de golos foi baixa",
            },
            winningChance: {
                1: "Dado o número de remates e o xG de ambas como equipas, target_team_name desviar de ter ganho este jogo team_winning_chance quantidade de vezes"
            },
            highPlayerXGManyShots: {
                1: "É interessante de notar que o player_name gerou xg_value de shots_value remates",
            },
            highPlayerXGMoreThanOneGoal: {
                1: "precisando de xg_vlor xG para marcar um golo.",
            },
            highPlayerXGOneGoal: {
                1: " de marcar um golo. ",
            },
            highPlayerXGAnyGoal: {
                1: ", apesar de não conseguir marcar qualquer golo.",
            },
            highPlayerXGNotManyShots: {
                1: "It is worth mentioning that player_name generated xg_value xG in a few shots",
            },
            highManyPlayerXG: {
                1: "É interessante de notar que player_name e player_name2 gerou xg_value e xg_value2 <b>xG</b> respetivamente.",
            },
            highTeamXGPerShot: {
                1: "Em relação a seleção de remates por parte de target_team_name, estes foram muito bons em termos de probabilidade de acabar em golo, com uma média de xG por remate de xg_per_shot_value.",
            },
            highTeamXGPerShotVSGameRival: {
                1: "A seleção de remates por parte de target_team_name foi muito melhor do que rival_team_name, tendo a mesma média de xg_per_shot_value xG por remate. ",
            },
            xGTimesNotAfter70xG: {
                1: "Apesar de alto xG gerado, target_team_name não teve problemas em criar perigo no fim do jogo. ",
            },
            xGTimesBefore25xG: {
                1: "target_team_name criou muito perigo, especialemente no início de cada parte.",
            },
            xGTimesAfter25xG: {
                1: "target_team_name criou muito perigo, especialemente no fim de cada parte. ",
            },
            xGTimesBefore25xGvsItself: {
                1: "target_team_name criou muito perigo no início da primeira parte. ",
            },
            xGTimesAfter25xGvsItself: {
                1: "target_team_name criou muito perigo no fim da primeira parte. ",
            },
            xGTimesBefore70xGvsItself: {
                1: "target_team_name criou muito perigo no início da segunda parte. ",
            },
            xGTimesAfter70xGvsItself: {
                1: "target_team_name criou muito perigo no fim da segunda parte. ",
            },
            xGTimesBefore25xG2: {
                1: "target_team_name começou o jogo de forma sólida com chances que criaram xg_value expectáveis de golos. ",
            },
            xGTimesAfter25xG2: {
                1: "target_team_name acabaram a primeira parte com chances que geraram xg_value expectáveis de golos. ",
            },
            xGTimesBefore70xG: {
                1: "target_team_name veio do intervalo com chances que criaram um xg_value expectável de golos. ",
            },
            xGTimesAfter70xG: {
                1: "target_team_name acabarama asegunda parte com chances que criaram um xg_value expectável de golos. ",
            },
            xGTimesAfter70xGOverOneDotTwo: {
                1: "target_team_name criaram muito perigo no fim da segunda parte.",
            },
            xGTimesBefore70xGOverOneDotTwo: {
                1: "target_team_name criaram muito perigo no início da segunda parte. ",
            },
            xGTimesAfter25xGOverOneDotTwo: {
                1: "target_team_name criaram muito perigo no fim da primeira. ",
            },
            xGTimesBefore25xGOverOneDotTwo: {
                1: "target_team_name criaram muito perigo no início da primeira parte. ",
            },
            xGTimesFirstHalfXGSecondHalfXGRival: {
                1: "target_team_name criaram mais perigo na primeira parte, enquanto a rival_team_name fez o mesmo na segunda parte. ",
            },
            xGTimesSecondHalfXGFirstHalfXGRival: {
                1: "target_team_name criaram mais perigo no início da segunda parte, enquanto a rival_team_name fez o mesmo na primeira parte. ",
            },
            xGTimesFirstHalfXGFirstHalfXGRival: {
                1: "É um jogo onde a maioria do perigo em termos de golos expectáveis foi gerado durante a primeira parte.",
            },
            xGTimesSecondHalfXGSecondHalfXGRival: {
                1: "É um jogo onde a maioria do perigo em termos de golos expectáveis foi gerado durante a segunda parte. ",
            },
            xGTimesFirstHalfXG: {
                1: " target_team_name gerou mais perigo na primeira parte. ",
            },
            xGTimesSecondHalfXG: {
                1: " target_team_name gerou mais perigo durante a segunda parte. ",
            },
            xGTimesFirstHalfXGRival: {
                1: " target_team_name deixou a maioria do perigo em termos de golos expectáveis na primeira parte. ",
            },
            xGTimesSecondHalfXGRival: {
                1: " target_team_name deixou a maioria do perigo em termos de golos expectáveis durante a segunda parte. ",
            },
            highInBoxXG: {
                1: "O mapa de remates expõe que o perigo veio de dentro da área. ",
            },
            highOutOfBoxXG: {
                1: "Pode ser observado no mapa de remates que, neste jogo, target_team_name gerou muito mais perigo de fora da área. ",
            },
            highInBoxXGRival: {
                1: "Queremos mostrar que, a maioria do perigo concedido pela target_team_name veio de dentro da área. ",
            },
            highInBoxXGRival2: {
                1: "It is also interesting to highlight that most of the danger conceded by target_team_name came from shots inside the box. ",
            },
            highOutOfBoxXGRival: {
                1: "target_team_name atuou bem evitando perigo dentro da área. ",
            },
            highTeamChancesHighPPDARival: {
                1: "A falta de pressão da target_team_name, permitindo ppda_valor passes por acção defensiva, foi uma das chaves para que a rival_team_name criasse um número alto de oportunidades. ",
            },
            lowPPDAWithGoalDiff: {
                1: " target_team_name só permitiu ppda_valor passes por acção defensive sendo esta a chave da vitória. ",
            },
            lowPPDA: {
                1: " target_team_name fez um ótimo trabalho ao interromper as jogadas da rival_team_name permitindo uma média de ppda_valor passes por acção defensiva. ",
            },
            highPossession: {
                1: "target_team_name teve que controlar a bola com um possession_value de posse de bola ",
            },
            highPPDARival: {
                1: " assim como a fluidez da distribuição da bola",
            },
            chancesCreated: {
                1: ", que os permitiu a terem um número alto de oportunidades através de jogadas (chances_value). ",
            },
            chancesCreatedRival: {
                1: ", apesar de rival_team_name conseguiu criar um número alto de oportunidades através jogadas (chances_value). ",
            },
            xGPerShotRival: {
                1: ", apesar da rival_team_name conseguiu criar oportunidades perigosas com o xg_per_shot_value xg por remate. ",
            },
            winGame: {
                1: " sendo uma das chaves do jogo. ",
            },
            notEnoughWinGame: {
                1: " não sendo suficiente para ganhar o jogo. ",
            },
            goalsFromErrorsFirstGoal: {
                1: "O primeiro golo veio de através de um erro de player_error_name apreendido por player_name",
            },
            goalsFromErrorsFirstGoalFinalResult: {
                1: "O primeiro e único golo veio de um erro de player_error_name apreendido por player_name",
            },
            lastPhaseOfGame: {
                1: " na última fase do jogo. ",
            },
            goalsFromErrorsFinalResultGoalToLead: {
                1: "O último golo para ganhar o jogo veio de um erro do player_error_name que levou ao golo do player_name. ",
            },
            goalsFromErrorsFinalResultGoalToTie: {
                1: "O último golo para empatar o jogo veio de um erro do player_error_name que levou ao golo do player_name. ",
            },
            goalsFromErrorsGoalToTie: {
                1: "Um erro do player_error_name levou à oportunidade de empatar o jogo para a target_team_name. ",
            },
            goalsFromErrorsGoalToLead: {
                1: "target_team_name ganhou vantagem através de um erro do player_error_name ",
            },
            xGChance: {
                1: " com a oportunidade de xg_value xG. ",
            },
            rivalGoalsFromErrorsFinalResultGoalToLead: {
                1: "O golo final da target_team_name para ganhar o jogo veio através de um erro do player_error_name que levou ao golo de player_name. ",
            },
            rivalGoalsFromErrorsGoalToTie: {
                1: "Um erro do player_error_name levou a oportunidade de empatar o jogo para a rival_team_name. ",
            },
            rivalGoalsFromErrorsGoalToLead: {
                1: " rival_team_name ficou na frente do marcador tirando vantagem de um erro do player_error_name ",
            },
            hugeChancesMissedOneScored: {
                1: " target_team_name marcou na única grande oportunidade que criaram no jogo, isso é o golo do player_name que podemos ver xG no mapa com um Xg de xg_value. ",
            },
            hugeChancesMissedMoreThanOneScored: {
                1: "target_team_name acabou por marcar todas as oportunidades que criaram durante o jogo",
            },
            hugeChancesMissedZeroGoalsOneChance: {
                1: "player_name teve a única oportunidade da target_team_name marcar com um xG de xg_value. ",
            },
            hugeChancesMissedZeroGoalsMoreChances: {
                1: "target_team_name não foi capaz de marcar qualquer valor_oportunidade oportunidades acima dos 40% de possibilidade de ser golo. ",
            },
            oneHugeChancesBeforeFirstGameGoal: {
                1: "player_name teve uma grande oportunidade de xg_value Xg para partir na frente do marcador.",
            },
            moreThanOneHugeChancesBeforeFirstGameGoal: {
                1: "target_team_name teve valor_oportunidade oportunidades de xG acima dos 40% de partir na frente do marcador.",
            },
            moreThanOneBigChancesBeforeFirstGameGoal: {
                1: "target_team_name teve valor_oportunidade oportunidades de alto xG para partir na frente do marcador.",
            },
            shotOnPostBeforeFirstGameGoal: {
                1: "player_name teve a oportunidade para ganhar vantagem no xg_value xG que bateu no poste.",
            },
            beforeEndOfGame: {
                1: "Antes do fim do jogo, ",
            },
            oneHugeChancesAfterFirstGameGoal: {
                1: "player_name teve a oportunidade de xg_value xG de ganhar o jogo. ",
            },
            moreThanOneHugeChancesAfterFirstGameGoal: {
                1: " target_team_name teve valor_oportunidade oportunidades com um xG acima dos 40% para vencer o jogo. ",
            },
            moreThanOneBigChancesAfterFirstGameGoal: {
                1: " target_team_name teve valor_oportunidade oportunidades com alto xG para vencer o jogo. ",
            },
            oneHugeChancesBeforeFirstGameGoalRival: {
                1: "player_name teve uma grande oportunidade de xg_value xG de ganhar vantagem no marcador. ",
            },
            moreThanOneHugeChancesBeforeFirstGameGoalRival: {
                1: " target_team_name teve valor_oportunidade oportunidades com um xG acima dos 40% para ganhar vantagem no marcador. ",
            },
            moreThanOneBigChancesBeforeFirstGameGoalRival: {
                1: "target_team_name teve valor_oportunidade oportunidades com um alto xG para passar a frente no marcador. ",
            },
            shotOnPostBeforeFirstGameGoalRival: {
                1: "player_name teve a oportunidade de partir na frente do marcador de xg_value xG que acertou no poste. ",
            },
            bigChancesMissedWhenLosingByOne: {
                1: "player_name teve a oportunidade de xg_value xG de empatar o jogo, sem sorte. ",
            },
            moreThanOneBigChancesMissedWhenLosingByOne: {
                1: " target_team_name teve o valor_oportunidade oportunidades de empatar o jogo com a probabilidade de marcar acima de 30%. ",
            },
            shotOnPostWhenLosingByOne: {
                1: " player_name teve a oportunidade de xg_value xG de empatar o jogo, acertando no poste. ",
            },
          }
        },
        step2: {
          table: {
            draw: "Empate",
            win: "Vitória",
            possession: "Posse de bola",
            xP: "Pontos expectáveis",
            directness: "Objetividade",
            ppda: "PPDA",
            xA: "xA",
            xAOpenPlay: "xA Jogadas ",
            xASetPiece: "xA Bola Parada",
            chancesCreated: "Chances Criadas",
            shotsOnTarget: "Remates no Alvo",
          },
          text: {
              firstParagraph: {
                  1: "Esta imagem mostra as assistências expectáveis de <b style='color:home_color'>home_team_name</b> and <b>away_team_name</b>.",
              },
              xAPerKeyPass: {
                  1: " xA por passe chave. ",
              },
              keyPassesGeneratedFrom: {
                  1: ", especialmente passes chaves de ",
              },
              highTeamXAvsXG: {
                  1: "Como o mapa xA demonstra, a maioria do perigo criado por target_team_name vem da combinação de jogadas mais do que ações individuais",
              },
              openPlay: {
                  1: "jogadas",
              },
              setPiece: {
                  1: "Bola Parada",
              },
              cornerKicks: {
                  1: "cantos",
              },
              combinationPlays: {
                  1: "jogadas combinadas",
              },
              dot: {
                  1: ". ",
              },
              comma: {
                  1: ", ",
              },
              averageTeamXAvsXG: {
                  1: "Neste jogo, target_team_name gerou perigo de ambas as jogadas combinadas",
              },
              individualActions: {
                  1: " e ações individuais. ",
              },
              dangerFromIndividualActions: {
                  1: "Neste jogo, a maioria do perigo gerado por equipa_nome_alco veio através de ações individuais.",
              },
              highTeamXAvsXGRival: {
                  1: "As oportunidades que target_team_name permitiu durante o jogo vieram de combinações como o mapa xA demonstra.",
              },
              rivalStrongKeyPassesFrom: {
                  1: "rival_team_name foi forte nos passes chaves vindo de ",
              },
              manyPlayerKeyPasses: {
                  1: "É interessante notar que o player_name criou xa_value xA em key_passes passes chave",
              },
              playerAssists: {
                  1: " Precisa xa_per_assist xA por assistência.",
              },
              giveAssist: {
                  1: " para dar assistência.",
              },
              noAssists: {
                  1: ", apesar de nenhum dos passes acabar em assistência.",
              },
              highXANotManyShots: {
                  1: "É interessante de notar que o player_name criou xa_value xA em poucos passes",
              },
              manyPlayersHighXA: {
                  1: "É interessante de notar que o player_name e o player_name2 gerou xa_value e xa_value2 xA respetivamente.",
              },
              xATimes: {
                  1: "target_team_name gerou a maioria do perigo na primeira parte enquanto a rival_team_name fez o mesmo na ",
              },
              firstHalf: {
                  1: " Primeira parte. ",
              },
              secondHalf: {
                  1: " Segunda parte. ",
              },
              left: {
                  1: "lado esquerdo ",
              },
              center: {
                  1: "centro ",
              },
              right: {
                  1: "lado direito ",
              },
              xAFirstHalfFirstHalfRival: {
                  1: "É um jogo onde a maioria do perigo em termos de expectativa de golos foi gerado durante o ",
              },
              xAFirstHalf: {
                  1: "target_team_name conseguiu criar a maioria do perigo na ",
              },
              xATimesXARival: {
                  1: " target_team_name permitiu demasiado perigo em termos de expectativa de golos na ",
              },
              xASides: {
                  1: " Maioria do perigo da target_team_name foi produzido a partir do nome_lateral (xa_value <b>xA</b>)",
              },
              xASidesRival: {
                  1: "enquanto rival_team_name gerou a maioria através do nome_lateral (xa_value <b>xA</b>)",
              },
              dangerCreationRival: {
                  1: "A criação de perigo do rival_team_name veio, especialmente, a partir do nome_lateral (xa_value <b>xA</b>). ",
              },
              speciallyEffective: {
                  1: "target_team_name foi especialmente efetivo a ",
              },
              xAPerChanceCreated: {
                  1: " com uma média de xa_value",
              },
              speciallyEffectiveRival: {
                  1: "rival_team_name foi especialmente efetivo a ",
              },
          }
        },
        step3: {
          text: {
            chance: " oportunidade",
            chances: " oportunidades",
            goal: " golo",
            goals: " golos",
            home: "casa",
            away: "fora",
            last: "ultimo",
            first: "primeiro",
            goalScorer: "marcador",
            goalScorers: "marcadores",
            lastPhase: "Na recta final do jogo, ",
            phase: {
                1: "Nesta phase_position do jogo, ",
                //2: "",
            },
            moreXT: {
                1: "<b style='color:more_color'>more_xt_team_name</b> gerou mais Ameaça Esperada (<b style='color:more_color'>more_xt_team_value xT</b>) do que <b style='color:less_color'>less_xt_team_name</b> (<b style='color:less_color'>less_xt_team_value xT</b>)",
                //2: "",
            },
            sameTeamMoreMinutes: {
                1: "e fez durante mais minutos neste período (<b style='color: more_color'>more_time_xt_minutes mins.</b> vs <b style='color:less_color'>less_time_xt_minutes'mins.</b> do rival)",
                //2: "",
            },
            rivalTeamMoreMinutes: {
                1: "no entanto, foi o seu rival que gerou o perigo por mais tempo (<b style='color:more_color'>more_time_xt_minutes mins.</b> vs <b style='color:less_color'>less_time_xt_minutes'mins.</b> do rival) neste período do jogo",
                //2: "",
            },
            maxXTValue: {
                1: "<b style='color:max_color'>max_xt_team_name</b> foi a equipa que criou mais perigo (<b style='color:max_color'>max_xt_team_value xT</b>) em <b style='color:max_color'>max_xt_team_minute'</b>"
                //2: "",
            },
            maxXTValueRival: {
                1: ", enquanto o estilo <b='color:max_rival_color'>max_xt_rival_team_name</b> gerou o seu maior perigo (<b style='color:max_rival_color'>max_xt_rival_team_value xT</b>) em <b style='color:max_rival_color'</b>, em <b style='color:max_rival_color'>max_xt_rival_team_minute </b>",
            },
            bothTeamsScoreButDraw: {
                1: "Ambas as equipas conseguiram bater o guarda-redes adversário em <b>number_of_goals_each_team</b> cada um. A equipa da casa através de <b style='color:#3366FF'>home_player_name_goals</b> e a equipa de fora através de <b>away_player_name_goals</b>",
                //2: "",
            },
            oneTeamTakesTheLead: {
                1: "Em termos de golos, <b style='color:replace_color'>goal_scored_team_name</b> superou o rival por <b style='color:replace_color'>difference_number_of_goals</b> de diferença ao bater o seu guarda-redes com <b style='color:replace_color'>home_player_name_goals</b> como goal_scorer_word",
                //2: "",
            },
          }
        },
        step4: {
          table: {
            team: "Equipa",
            period: "Periodo",
            possession: "Poss.",
            ppda: "PPDA",
            xGOpenPlay: "xG OP",
            tooltip: {
              team: "Equipa",
              period: "Período",
              possession: "Posse",
              ppda: "Passes Por ação defensiva",
              xGOpenPlay: "xG jogadas",
            }
          },
          text: {
            clearly: "claramente",
            very: "muito",
            haveGotText1: "so obteve",
            haveGotText2: "devia ter recebido mais do que",
            gaveUpPoss: "abdicou da posse de bola",
            lostPoss: "perdeu a posse da bola ",
            too: "também ",
            possession: {
                1: "Durante esta fase do jogo <b style='color:team_color'>team_name</b> clearly_text controlou a posse da bola",
            },
            equalPossession: {
                1: "Nesta fase do jogo, ninguém dominou a outra equipa dado que a manusear da bola estava equilibrada, apesar observando os números <b style='color:team_color'>team_name</b> dominou ligeiramente os oponentes com a <b style='color:team_color'>possession_value%</b> of possession",
            },
            lowPossessionHighPPDA: {
                1: ". <b style='color:target_team_color'>target_team_name</b> com má pressão permitida <b style='color:rival_team_color'>rival_team_name</b> dar aos <b style='color:target_team_color'>ppda_value Passes por Ação Defensiva</b>",
            },
            lowPossessionLowPPDA: {
                1: " mas <b style='color:target_team_color'>target_team_name</b> fez bem em pressionar a bola quando rival_team_name tinha a posse, com um <b>PPDA</b> de <b>ppda_value</b>",
            },
            highPossessionLowPPDA: {
                1: " e conseguiu jogar devido a very_lowtext intensidade de pressão da rival_team_name",
            },
            highPossessionHighPPDA: {
                1: " apesar da intensidade da pressão da rival_team_name foi very_texthigh",
            },
            highPossessionHighPFT: {
                1: "<b style='color:target_team_color'>target_team_name</b> apreendeu uma posse elevada dando <b>pft_value</b> <b>Passes no Último Terço</b> do campo. ",
            },
            highPossessionMidLowPFT: {
                1: "Independentemente da posse elevada, <b style='color:target_team_color'>target_team_name</b> have_got_text <b>pft_value</b> <b>Passes na Final Third</b>. ",
            },
            lowPossessionHighPFT: {
                1: "Embora <b style='color:target_team_color'>target_team_name</b> possession_text durante esta fase, foi capaz de dar <b>pft_value</b> <b>Passes no Terceiro Final</b>."
            },
            midPossessionHighPFT: {
                1: "Uma posse bastante equilibrada durante esta fase não impediu <b style='color:target_team_color'>target_team_name</b> de dar <b>pft_value</b> <b>Passs no Terceiro Final</b>. ",
            },
            highPFTHighTouchesIOB: {
                1: " Além de controlar o jogo no último terço, <b style='color:target_team_color'>target_team_name</b> também teve muita presença na caixa rival."
            },
            highPFTLowTouchesIOB: {
                1: "<b style='color:target_team_color'>target_team_name</b> controlou a bola no último terço, mas não conseguiu meter muitas bolas na caixa rival",
            },
            highPFTMidTouchesIOB: {
                1: "Dado o número de <b>Passes no Último Terço</b>, <b style='color:target_team_color'>target_team_name</b> deveria ter criado mais perigo na caixa rival,"
            },
            lowPFTHighTouchesIOB: {
                1: "Embora <b style='color:target_team_color'>target_team_name</b> não tenha completado muitos passes no último terço, conseguiu chegar à caixa do adversário muitas vezes."
            },
            midPFTHighTouchesIOB: {
                1: "Dado o número de passes concluídos no terço final, <b style='color:target_team_color'>target_team_name</b> conseguiu chegar à caixa rival muitas vezes. ",
            },
            maxDirectness: {
                1: "Vale a pena salientar que esta é a fase do jogo quando <b style='color='max_dir_color'>target_team_name</b> jogado mais ofensivamente com um <b>Directness</b> de <b>directness_value</b>"
            },
            maxXG: {
                1: "<b style='color:target_team_color'>target_team_name</b> foi capaz de gerar mais xG do que noutras fases do jogo",
            },
            highXGFifthQuintile: {
                1: " <b style='color:target_team_color'>target_team_name</b> conseguiu gerar um grande volume de Golos Esperados",
            },
            highXG: {
                1: "Gerar um bom volume de expectativa de golos",
            },
            highXGLowPossession: {
                1: " apesar de não ter muito controlo da bola",
            },
            highXGLowShots: {
                1: "só com alguns remates, tendo a <b>xG por remate</b> of <b>xg_per_shot_value</b>",
            },
            highXGLowXGPerShot: {
                1: "apesar do xG por remate é too_textlow. ",
            },
            lowXGZeroXG: {
                1: "<b style='color:target_team_color'>target_team_name</b> não foi capaz de gerar qualquer tipo de perigo para o rival",
            },
            lowXGMinXG: {
                1: "Em termos da geração de expectative de golos, esta foi uma má fase para <b style='color:target_team_color'>target_team_name</b>",
            },
            lowXGFirstQuintileXG: {
                1: "<b style='color:target_team_color'>target_team_name</b> gerou um volume muito baixo de expetativas de golos",
            },
            lowXGSecondQuintileXG: {
                1: "<b style='color:target_team_color'>target_team_name</b> não foi capaz de gerar um bom volume de expectativas de golos",
            },
            lowXGHighPossession: {
                1: " apesar de eles terem tido o controlo da bola.",
            },
            lowXGHighShots: {
                1: " apesar de eles rematarem muitas vezes",
            },
            lowXGHighPFT: {
                1: " apesar de completar <b>pft_value</b> <b>Passes no Terço Final</b> do campo. ",
            },
            midXGQuintileMinXG: {
                1: "Embora a geração de xG não fosse má, esta foi a fase mais fraca do jogo para <b style='color:target_team_color'>target_team_name</b> a esse respeito",
            },
            midXGQuintileMaxXG: {
                1: "Esta foi a fase em que <b style='color:target_team_color'>target_team_name</b> foi capaz de gerar o maior <b>xG (xg_value)</b>",
            },
          }
        },
        step5: {
          table: {
            team: "Equipa",
            period: "Periodo",
            possession: "Poss.",
            directness: "OBJ.",
            passesFinalThird: "PU ⅓",
            tooltip: {
                team: "Equipa",
                period: "Periodo",
                possession: "Posse de bola",
                directness: "Objetividade",
                passesFinalThird: "Passes último Terço",
            }
          },
          text: {
            last: "Último",
            goal: "golo",
            goals: "golos",
            chance: "opportunidade",
            chances: "opportunidades",
            first: "primeira",
            homeTeam: "Equipa visitada",
            awayTeam: "Equipa visitante",
            home: "Casa",
            away: "Fora",
            clearly: "claramente",
            slightly: "Ligeiramente",
            firstOrLastPhase: {
                1: "Nesta phase_position fase do jogo",
                2: "No phase_position período da partida",
            },
            phase: {
                1: "Durante este período da partida",
                2: "",
            },
            bothZeroGoalsScored: {
                1: "sem que nenhuma das equipas seja capaz de mudar o marcador.",
            },
            equalGoalsScored: {
                1: "conseguir marcar <b>number_goals</b>",
            },
            differentGoalsScored: {
                1: "conseguir marcar <b>number_goals</b>",
            },
            equalPossesion: {
                1: "ambas as equipas tinham a bola exatamente <b>poss_value%</b> of the time",
            },
            morePossesion: {
                1: "<b style='color:more_color'>more_poss_team_name</b> tinha a bola por mais minutos (<b style='color:more_color'>more_poss_team_value%</b> of the time) do que seu rival <b style='color:less_color'>less_poss_team_name</b> (<b style='color:less_color'>less_poss_team_value%</b> of the time)",
            },
            equalDirectness: {
                1: "ambas as equipas jogaram o jogo com a mesma objetividade (<b>directness_value</b> each one)",
            },
            //Same team with more possession and more directness than his rival
            moreDirectnessSameTeam: {
                1: "eles também eram mais verticais do que seus oponentes, jogando o jogo com uma objetividade de <b style='color:more_color'>more_dir_team_value</b> vs <b style='color:less_color'>less_dir_team_value</b>",
            },
            //One team with more possession and one with more directness
            moreDirectnessDifferentTeam: {
                1: "no entanto, foi a home_away equipa que jogou com mais objetividade (<b style='color:more_color'>more_dir_team_value</b>) do que o seu oponente (<b style='color:less_color'>less_dir_team_value</b>)",
            },
            equalChancesCreated: {
                1: "Ambas as equipass criaram o mesmo número de oportunidades, exatamente <b>chances_created_value</b> chance_text.",
            },
            moreChancesCreated: {
                1: "<b style='color:less_color'>less_cc_team_name</b> criado apenas <b style='color:less_color'>less_cc_team_value less_chance_text</b> e foi adverb_text superado pelo oponente (<b style='color:more_color'>more_cc_team_value more_chance_text created</b>)."
            },
            equalXA: {
                1: "Ambas as equipes tiveram oportunidades iguais, como refletido no <b>xa_value de Assistências Esperadas</b>",
            },
            moreXA: {
                1: "A equipa home_away gerou <b>diff_xa_team_value Assistências Esperadas</b> (<b style='color:more_color'>more_xa_team_value</b> contra <b style='color:less_color'>less_xa_team_value</b>) do que o adversário, ",
            },
            xAOpenPlay: {
                1: "criando, respectivamente, <b style='color:more_color'>more_xa_op_value</b> and <b style='color:less_color'>less_xa_op_value xA Open Play</b>.",
            },
          }
        },
        step6: {
          text: {
            eachOne: " cada um ",
            respectively: ", respectivamente",
            with: " (with <b style='color:replace_color'>other_player_name</b>)",
            playerWas: "jogador era",
            playerWere: "jogadores foram",
            firstPhase: {
                1: "Nesta primeira parte da partida, o player_text mais importante",
                2: "Quanto à primeira parte do jogo, quem se destacou foi",
            },
            otherPhase: {
                1: "Entre <b style='color:replace_color'>min_from'</b> e <b style='color:replace_color'>min_to'</b> devem ser mencionados ",
            },
            lastPhase: {
                1: "Na última parte do jogo, mencione a",
                2: "Quanto à última fase da partida",
            },
            playerMaxSuccessfullPasses: {
                1: "<b style='color:replace_color'>player_name</b> dado que ele realizou o maior número de passes bem sucedidos da sua equipa, exatamente <b style='color:replace_color'>successfull_passes_value passes</b>",
            },
            playerMaxTotalPasses: {
                1: "que se torna ainda mais valioso quando os números mostram que ele também era",
            },
            playerMaxTotalPasses2: {
                1: "with_text o jogador com mais tentativas de passses (<b style='color:replace_color'>total_passes_value passes</b>). ",
            },
            //Just one player with max successfull passes
            playerNotMaxTotalPasses: {
                1: "embora ele não tentou o máximo de passes (<b style='color:replace_color'>player_name</b> with <b style='color:replace_color'>total_passes_value passes</b>). ",
            },
            //More than one player with max successfull passes
            playersMaxSuccessfullPassesTotalPasses: {
                1: " tentando durante este período <b style='color:replace_color'>total_passes_value passes</b> each one. ",
            },
            playerMaxPctPasses: {
                1: "Em termos de <b style='color:replace_color'>% Passes Completed</b>, <b style='color:replace_color'>player_name</b> tem uma alta <b style='color:replace_color'>max_pct_passes_value%</b>. ",
                2: "Em referência à taxa de sucesso, vale a pena mencionar <b style='color:replace_color'>player_name</b> with a <b style='color:replace_color'>max_pct_passes_value%</b> pass success rate</b>. ",
            },
            playerSumTotalXG: {
                1: "Nesta janela de tempo, a equipe gerou um total de <b style='color:replace_color'>sum_xg_value xG</b>, ",
                2: "During this period, <b style='color:replace_color'>team_name</b> created a <b style='color:replace_color'>xG</b> of <b style='color:replace_color'>sum_xg_value</b>, ",
            },
            ZeroSumXG: {
                1: "Apesar de fazer um total de <b style='color:replace_color'>all_team_total_passes</b> entre toda a equipa, foi em vão, pois eles não conseguiram criar uma única chance. ",
                2: "The <b style='color:replace_color'>all_team_total_passes</b> feitas nesse período não geraram uma única oportunidade de marcar. ",
            },
            playerMaxXGMaxXADiffPlayer: {
                1: "with <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> and <b style='color:replace_color'>player_xa_name</b> with <b style='color:replace_color'>xa_value xA</b> sendo os jogadores mais perigosos em termos de criar oportunidades. ",
            },
            playerMaxXGMaxXASamePlayer: {
                1: "being <b style='color:replace_color'>player_name</b> with <b style='color:replace_color'>xg_value xG</b> and <b style='color:replace_color'>xa_value xA</b> o criador da maioria das chances da sua equipa. ",
            },
            playersMaxXGMaxXA: {
                1: "obrigado entre outros para <b style='color:replace_color'>players_name</b> Quem acionou <b style='color:replace_color'>xa_value xA</b> cada um com seus passes-chave. ",
            },
            //Just one player with max xG
            playerMaxXGZeroXA: {
                1: "being <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> que tinha todo o peso das chances, tendo que criá-las por conta própria, já que ele não recebia nenhum passe-chave. ",
            },
            //More than one player with max xG
            playersMaxXGZeroXA: {
                1: "being <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> que tiveram as chances, tendo que criá-los por conta própria, pois não receberam nenhum passe-chave. ",
            },
            oneMaxConnections: {
                1: "A dupla que fez mais passes entre eles durante esta fase da partida foi <b style='color:replace_color'>couple_name</b>, com um total com um total de <b style='color:replace_color'>connections_value passes</b>. ",
                2: "A dupla formada por <b style='color:replace_color'>couple_name</b> Trocados <b style='color:replace_color'>connections_value</b> vezes a bola. ",
                3: "The <b style='color:replace_color'>couple_name</b> duo foram os que passaram a bola mais nesta fase da partida, fazendo isso mesmo em <b style='color:replace_color'>connections_value</b> oportunidades. ",
            },
            twoMaxConnections: {
                1: "Os dois pares formados por <b style='color:replace_color'>couple_name</b> and <b style='color:replace_color'>couple_name2</b> foram as ligações mais repetidas para este período, passando a bola para o outro <b style='color:replace_color'>connections_value</b> times. ",
            },
            moreThanTwoMaxConnections: {
                1: "Os pares de jogadores, tais como <b style='color:replace_color'>couple_name</b>, feito <b style='color:replace_color'>connections_value passes</b> uns aos outros. ",
            },
            oneMinConnections: {
                1: "Por outro lado, foi <b style='color:replace_color'>couple_name</b> que passou a bola para cada outros menos, apenas <b style='color:replace_color'>connections_value passes</b>. ",
                2: "No outro extremo, o tandem composto por <b style='color:replace_color'>couple_name</b> only connected <b style='color:replace_color'>connections_value</b> times. ",
            },
            twoMinConnections: {
                1: "Por outro lado, <b style='color:replace_color'>couple_name</b> and <b style='color:replace_color'>couple_name2</b> passes mal trocados entre eles (<b style='color:replace_color'>connections_value passes</b>). ",
            },
            moreThanTwoMinConnections: {
                1: "Várias combinações não ligam o suficiente, como o <b style='color:replace_color'>couple_name</b> duo, which with <b style='color:replace_color'>connections_value passes</b> estão entre as combinações menos comuns. ",
            },
          },
        },
      },
      gamePossessionMap: {
        of: "de",
        to: "a",
        and: "e",
        endsWith: "Termina com",
        time: "Tempo",
        touches: "Toques",
        passes: "Passes",
        threat: "Perigo",
        xG: "xG",
        xT: "xT",
        minutes: "Minutos",
        duration: "Duração",
        endsGoal: "Termina em Gol",
        endsInBox: "Termina na Área",
        withShot: "Com Remate",
        withCross: "Com Centro",
        possession: "Posse",
        events: "Eventos",
        filters: "Filtros",
        filtersWarning: "O perigo só se aplica a posse de bola sem remate",
        show: "Mostrar",
        sequenceNumbers: "Número de sequência",
        jerseyNumbers: "Dorsales",
        pass: "Passe",
        carryAndPass: "Condução e Passe",
        carryAndAction: "Condução e Ação",
        carryAndShot: "Condução e Remate",
        shotFailed: "Remate Falhado",
        goal: "Golo",
        savedShot: "Remate Defendido",
        missedShot: "Remate Falhado",
        shotOnPost: "Remate ao Poste",
        headerGoal: "Golo de Cabeça",
        headerFailed: "Cabeçalho Falhado",
        failed: "falhado",
      },
      report: {
        title: "Game Report",
        maps: "Maps",
        xGRace: "xG Race",
        lineups: "Lineups",
        button: "Gerar um relatório completo do jogo em PDF",
        mobileButton: "Relatório PDF",
        most: "Mais"
      }
    },
    general: {
        create: "Criar",
        save: "Salvar",
        cancel: "Cancel",
        delete: "Apagar",
        edit: "Editar",
        go: "Ir",
        formErrors: {
            required: "Campo é necessário",
            passwordMatch: "A palavra-passe não corresponde",
            minLength: "Extensão mínimo",
            maxLength: "Extensão máxima",
            emailValid: "O e-mail deve ser válido",
            youthAge: "A idade deve estar entre 10 e 23 anos",
            seasonYear: "O ano deve estar entre 2016 e 2050",
        },
        confirmationTitle: "Tens a certeza?",
        confirmationMessage: "Por favor, confirme se quer realizar a ação",
        yes: "Sim, claro",
        no: "Não",
        1: "Um",
        2: "Dois",
        3: "Três",
        4: "Quatro",
        5: "Cinco",
        search: "Pesquisar",
        clearFilters: "Filtros claros",
        minimum: "Mínimo",
        maximum: "Máximo",
        minimumPercent: "(%)Por cento mínimo",
        period: "Período",
        exclude: "Excluir",
        team: 'Equipa',
        clear: "Claro",
        all: "Todos os",
        ground1: "Todas",
        ground2: "Casa",
        ground3: "Fora",
        filter: "Filtro",
        noData: "Não foram encontrados resultados",
        noDataGivenFilters: "No results found with given filters",
        similarityNoData: "não está incluído na ferramenta Similaridade",
        similarityMinutesWarning: "Sem dados devido a menos de 450 minutos jogados",
        close: "Fechar",
        load: "Carga",
        filters: "Filtros",
        players: "jogadores",
        teams: "teams",
        compare: "Comparar",
        seeMore: "Ver mais",
        seeLess: "Ver menos",
        request: "Pedido",
        notes: "Notas",
        closeSession: "Saída",
        settings: "Configurações",
        player: "Player",
        state: "Estado",
        updated: "Atualizado",
        file: "Arquivo",
        uploadFile: "Ficheiro de upload",
        reports: "Relatórios",
        download: "Baixar",
        new: "Novo",
        comparison: "Comparação",
        scout: "Scouting",
        favorites: "Favoritos",
        moreOptions: "Mais opções",
        lessOptions: "Menos opções",
        today: "Hoje",
        home: "Casa",
        away: "Fora",
        until: "até",
        firstHalf: "Primeira Metade",
        secondHalf: "Segunda Metade",
        firstPeriodOT: "Primeira Metade OT",
        secondPeriodOT: "Segunda Metade OT",
        postponed: "Adiado",
        stats: "Estatísticas",
        yesterday: "Ontem",
        today: "Hoje",
        last: "Último",
        startDate: "Data de Início",
        active: "Ativo",
        playerLimit: "Limite de Jogadores",
        type: "Tipo",
        successMessage: "A operação tem sido um sucesso.",
        failMessage: "A operação falhou.",
        by: "Por",
        checkYourInbox: "Verifique a sua caixa de entrada",
        faq: "Documentação",
        globalSearch: "Pesquisa Global",
        gamesLost: "Jogos Perdidos",
        outOf: "fora de",
        avgSeason: "Temporada Avg.",
        leftDays: "dias restantes",
        notifyError: "Notifique erro",
        notify: "Notificar",
        comments: "Comentários",
        searches: "Pesquisas",
        now: "Agora,",
        twoHoursAgo: "Há duas horas.",
        incomings: "Chegadas",
        departures: "Partidas",
        transferLoans: "Empréstimos",
        transfers: "Transferências",
        movements: "Movimentos",
        incomes: "Rendimentos",
        expenditures: "Despesas",
        action: "Ação",
        target: "Alvo",
        uses: "Utilizações",
        users: "Utilizadores",
        since: "desde",
        mediaMode: "Modo Media",
        white: "Branco",
        enabled: "Habilidoso",
        disabled: "Deficientes",
        left: "Esquerda",
        right: "Direito",
        both:'Ambas',
        'left-both': 'Esquerda Ambas',
        'right-both': 'Direito Ambas',
        'left foot': 'Esquerda',
        'right foot': 'Direito',
        files: "Ficheiros",
        confirm: "Confirmar",
        currentStep: "Passo atual",
        phases: "Phases",
        entries: "Entries",
        none: "None",
        times: "times",
        darkMode: "Dark Mode",
        client: "Client",
        visits: "Visits",
        lastVisit: "Last Visit",
        strong: "Strong",
        medium: "Medium",
        weak: "Fraco",
        goal: "Golo",
        list: "Lista",
        map: "Mapa",
        copiedToClipboard: "Copiado para a prancheta",
        division: "Divisão",
        many: "Mais",
        few: "Menos",
        median: "Mediana",
        topRight: "Direito superior",
        topLeft: "Esquerda superior",
        bottomRight: "Direito inferior",
        bottomLeft: "Inferior Esquerdo",
        library: "Biblioteca",
        mediaLibrary: "Biblioteca Multimédia",
        for: "Para",
        stat: "Estatística",
        position:"Posición",
        order:"Orden",
        add:"Añadir",
        visualization: "Visualización",
        basic:"Básica",
        selectAll: "Marcar Todos",
        selectAll: "Desmarcar Todos",
        distribution: "Distribution",
        end:"End",
        accuracy: "accuracy",
        opponent: "Opponent",
        center:"Center",
        line: "Line",
        live: "Live",
        unavailable: "unavailable",
        calendar: "Calendar",
        activeLeague:"League in Progress",
        similarity:"Similarity",
        emptyForSelectAll:"Empty select all",
        size:"Size",
        selectPlayersRestriction:"Seleccione entre 1 e {x} jogadores",
        group:"Group",
        alerts:"Alerts",
        shortcuts:"Shortcuts",
        share:"Share",
        dataAvailable: "Os dados estarão disponíveis em breve",
        someStatsAvailableSoon: "Algumas estatísticas estarão disponíveis em breve",
        monthGamesWarning: 'Os jogos do mês selecionado estarão disponíveis em breve',
        metrics: "Métricas",
        competition:"Competition",
        code:"Code",
        alias:"Alias",
        never: "Nunca",
        unlimited: "Ilimitado",
        user: "Utilizador",
        warning: "Aviso",
        requests: "Pedidos",
        contactSales: "Contacto com Vendas",
        comingSoon: "Em breve!",
        youth:"Youth",
        male:"Male",
        processing: "Processing",
        addNew: "Adicionar Novo",
        createdBy: "Criado por",
        downloading: "Downloading",
        displayType: "Tipo de apresentação",
        alreadyExists: 'já existe',
        aggregation:"Aggregation",
        unavailableLeagues: 'Não tem acesso a nenhuma das ligas em que o jogador jogou',
        meters:"Meters",
        quantity:"Quantity",
        allTime:"All Times",
        games:"Games",
        unit: "Unidade",
        categories: "Categorias",
        maintenanceWarning: "Manutenção em curso",
        maintenanceMessage: "Estamos a fazer algumas atualizações. As alterações que fizer agora não serão guardadas. Obrigado pela sua paciência!",
    },
    playerScout: {
      dlabDatabase: "Base de Dados Driblab",
      league: "Liga",
      top5: "Top 5",
      topCountries: "Países",
      tier: "Nível",
      division1: "Primeira Divisão",
      division2: "Segunda Divisão",
      division3: "Terceira Divisão",
      division4: "Quarta Divisão",
      division5: "Quinta Divisão",
      summary: "Resumo",
      offensive: "Of",
      defensive: "Def",
      gk: "GR",
      all: "Todos os",
      physical: "Físico",
      arrigo: "Arrigo",
      yearTooltip: "Apenas um ano permitido",
      expectedThreat: "xThreat",
      expectedThreatTooltip: "Threat added to all possessions",
      expectedThreatOP: "xThreat OP",
      expectedThreatOPTooltip: "Threat added to Open Play possessions",
      expectedThreatInTeam: "xThreat Team %",
      expectedThreatInTeamTooltip: "Pct. of Threat added by player to the team",
      ballProgression: "Progressão da Bola",
      ballProgressionTooltip: "Progressions of +10 meters",
      deepProgression: "Progressões Profundas",
      deepProgressionTooltip: "Ball Progressions to Last Fifth",
      ballRetention: "% Retenção de Bola",
      ballRetentionTooltip: "Pct. of Actions where Ball was Successfully Retained",
      ballRetentionOppHalf: "% Retenção de Bola OH",
      ballRetentionOppHalfExplicit: "Retenção de bola na metade do adversário",
      finishing: "Gols Marcados",
      finishingTooltip: "Pct. of Shots Ending in a Goal",
      scoringContribution: "Contribuição de golo",
      scoringContributionTooltip: "Assists + Goals",
      xgPerShot: "xG por remate",
      xgPerGoal: "xG por golo",
      headerPerCross: "Cabeçeamento por Cruzamento",
      completedCrosses: "Cruzamentos Concluídas",
      crossingPct: "% cruzamentos",
      crossingEfficiency: "Eficiência de cruzamentos",
      crossingEfficiencyTooltip: "Crossing Efficiency (Measures Quality and Quantity)",
      longBalls: "Bolas Longas",
      longPassing: "Bola Longa %",
      dribblingPct: "Drible %",
      throughBalls: "Através de Bolas",
      oppBoxTouches: "Opp. Toques na área",
      oppBoxTouchesTooltip: "Touches in Opponent Box",
      openPlayKeyPasses: "Passes chave OP",
      openPlayKeyPassesTooltip: "Open Play Passes ending in Shot",
      xGBuildup: "xG Buildup",
      xGBuildupTooltip: "xG de sequências terminando em remate onde o jogador esteve envolvido (excluindo xG de tiro e passe chave)",
      Assists: "Assistências",
      passPercentage: "Passe %",
      passPerLongBall: "Passe por DE",
      passPerLongBallExplicit: "Passe por Bola Longa",
      nonPenaltyGoals: "Golos sem Penaltis",
      xG: "xG",
      xGExplicit: "Golos Esperados",
      shots: "Remates",
      xGShot: "xG per Shot",
      xGChain: "xG Cadeia",
      xGChainTooltip: "xG de sequências terminando em tiro onde o jogador estava envolvido",
      chancesCreated: "Passes seguidos por um remate",
      chances: "Oportunidades",
      dribbles: "Fintas",
      dribblesSuccessfull: "Fintas bem-sucedidas",
      touches: "Toques na área do oponente",
      xA: "xA",
      xAExplicit: "Assistências Esperadas",
      xAOpenPlay: "xA OP",
      xAOpenPlayExplicit: "Jogo Aberto de Assistências Esperadas",
      passesOpponentBox: "Passes na Caixa do Oponente",
      passesOB: "Passes em OB",
      passesFinalThird: "Passes Final 1/3",
      passesFinalThirdTooltip: "Passes Terço Final",
      passesSuccessful: "Passes Succ.",
      passesSuccessfulTooltip: "Passes Com Sucesso",
      ballProgressionPassing: "BP por Passagem",
      ballProgressionPassingTooltip: "Progressão da bola por passe",
      ballProgressionDribbling: "BP by Carrying",
      ballProgressionDribblingTooltip: "Progressão da bola por condução",
      passesTotal: "Passes",
      passesTotalTooltip: "Total de passes tentados",
      shortPassesSuccessful: "Succ. SP",
      shortPassesSuccessfulTooltip: "Número de passes curtos concluídos",
      shortPassesTotal: "Total SP",
      shortPassesTotalTooltip: "Número de passes curtos tentados",
      tackles: "Abordagens *",
      adjustedTackles: "Abordagens ajustadas à posse",
      interceptions: "Interceções *",
      adjustedInterceptions: "Interceções ajustadas à Posse",
      aerials: "Aéreos",
      aerialsPercent: "Aéreos %",
      aerialEfficiency: "Aerial Eff.",
      aerialEfficiencyTooltip: "Eficiência Aérea (Mede Qualidade e Quantidade)",
      twd: "TwD",
      tacklesWasDribbled: "Cortes foi driblado",
      fouls: "Faltas",
      indPressure: "Pressão Individual",
      pressure: "Pressão",
      dispossessed: "Desalojado",
      recoveries: "Recuperações",
      primary: "Primária",
      secondary: "Secundário",
      position: "Posição",
      nationality: "Nacionalidade",
      height: "Altura (cm)",
      minHeight: "Min. Altura",
      maxHeight: "Max. Altura",
      age: "Idade",
      minAge: "Min. Idade",
      maxAge: "A Idade máxima",
      games: "Jogos",
      minGames: "Min. Jogos",
      maxGames: "Max. Jogos",
      minutes: "Minutos",
      minMinutes: "Minutos Min.",
      maxMinutes: "Max. Minutos",
      minPercentMinutes: "Min. Percent Minutes",
      dates: "Dates",
      marketValue: "(€) Valor de Mercado",
      teams: "Equipas",
      contractEnd: "Fim do Contrato",
      minValue: "Valor Min.",
      maxValue: "Max. Valor",
      excludeTeams: "Excluir equipas",
      recentSearches: "Pesquisas recentes",
      saveSearch: "Guardar pesquisa",
      loadSearch: "Pesquisa de carga",
      search: 'Pesquisar',
      searchesList: "Listas de pesquisa",
      mySearches: "As minhas pesquisas",
      mySearchesDescription: "Aqueles que salvaste anteriormente",
      recentSearchesDescription: "As últimas 10 pesquisas que fez",
      searchToLoad: "Procurar para carregar",
      recentSearch: "Pesquisa recente",
      saveSearchSuccess: "Pesquisa guardada com sucesso",
      removeSearch: "Excluir pesquisa",
      removeSearchMessage: "Tem certeza de que deseja apagar a pesquisa?",
      deleteSearchSuccess: "A pesquisa foi eliminada",
      playersFound: "jogadores encontrados",
      addAllToCollection: "Adicione tudo à coleção",
      npg: "NPG",
      goals: "Golos",
      value: "Valor",
      nationalTeams: "Seleções Nacionais",
      gbeScore: "GBE",
      dlIndex: "Pontuação",
      minGbe: "Min. GBE",
      goalsConceded: "Golos sofridos",
      npgConceded: "NPG Admitido",
      npgConcededTooltip: "Golos sem penalidade sofridos",
      xGOTConceded: "xG no alvo concedido",
      xGOTConcededTooltip: "xG de remates recebidos no alvo",
      goalsPrevented: "Golos Evitados",
      xGFacedPerShotOnTarget: "xGOT per Shot",
      xGFacedPerShotOnTargetTooltip: "xG on Target per Shot conceded",
      xGSavedPerxGFacedOnTarget: "xG Defesa",
      xGSavedPerxGFacedOnTargetTooltip: "Percentagem de defesas tendo em conta o xG",
      savesPct: "% defesas",
      savesOutOfBoxPct: "% Defender fora da área",
      savesInBoxPct: "% defesa dentro da área",
      xGFacedPerGoal: "xG Enfrentou por golo",
      xGFacedPerGoalTooltip: "xG Necessário para marcar um golo",
      catchingPct: "% defesa de bolas agarradas",
      catchingTooltip: "Por cento das defesas agarradas",
      passingOwnHalfPct: "% passe na própria metade",
      passingOwnHalfPctTooltip: "Percetange de passes bem sucedidos na própria metade",
      passingOppHalfPct: "% Passes o Opp. Metade",
      passingOppHalfPctTooltip: "Percentagem de passes bem-sucedidos na metade do adversário",
      passingContribution: "% Contribuição de Passagem",
      passingContributionTooltip: "Percentage of Passing Contribution",
      shotsPerGoal: "Remates por Golo",
      passesFinalThird: "Passes no último terço",
      passingFinalThird: "% Passe no último terço",
      claimAccuracy: "Precisão de bolas agarradas",
      claimAccuracyTooltip: "Bolas agarradas acima da média",
      highTurnovers: "Perdas Perigosas",
      highTurnoversTooltip: "Bolas perdidas a menos de 40 metros para a baliza",
      shotEndingHighTurnovers: "remates terminando em PB",
      shotEndingHighTurnoversTooltip: "Remates terminando em PBA",
      goalEndingHighTurnovers: "Golo terminando em PB ",
      goalEndingHighTurnoversTooltip: "Golos terminando altas rotatividades",
      avgCarriesProgress: "Progresso Médio",
      avgCarriesProgressTooltip: "Distância média movendo a bola verticalmente (metros)",
      carriesChance: "Opportunidade terminando em",
      carriesChanceTooltip: "Condução seguido de um passe chave",
      carriesAssist: "Assistência terminando",
      carriesAssistTooltip: "Condução seguindo de uma assistência",
      carriesShot: "Remate terminando",
      carriesShotTooltip: "Condução seguindo por um remate",
      carriesGoal: "Golo terminando ",
      carriesGoalTooltip: "Condução seguindo de um golo",
      shotEndingSequence: "Remate terminando",
      shotEndingSequenceTooltip: "Número de Sequências terminando em remate onde o jogador esteve envolvido",
      goalEndingSequence: "Golo terminando",
      goalEndingSequenceTooltip: "Número de Sequências terminando em Golo onde o jogador esteve envolvido",
      gbeScoreTooltip: "Aval do organismo dirigente da FA Football",
      goalsPreventedTooltip: "Golos sem penáltis salvos pelo guarda-redes (xG Faced - NPG Conceded)",
      freePlayers: "Jogadores Livres",
      index: "Índice",
      playerName: "Nome",
      teamName: "Equipa",
      secondPos: "Segundo Pos.",
      side: "Lado",
      dob: "Nascimento",
      countryName: "País",
      secondCountryName: "Segundo País",
      leagueName: "Liga",
      seasonYear: "Época",
      assists: "Assistência",
      placeholder: "Pode começar a adicionar alguns filtros",
      placeholder2: 'Clique no botão de pesquisa para ver os resultados',
      passesPct: "Passes %",
      passingPct: "Passes %",
      oppBoxPasses: "Passes na área opp.",
      adjustedClearances: "Cortes ajustados",
      aerialsPct: "Aéreos %",
      leagueCountryCode: "Código do País da Liga",
      shooting: "Remate no alvo %",
      xtPassing:"xT Passagem",
      xtPassingTooltip:"Threat added by passing",
      xtDribbling:"xT Conducción",
      xtDribblingTooltip:"Threat added by carrying",
      foot: "Strong Foot",
      aggressiveActions: "Acções Agressivas",
      aggressiveActionsTooltip: "Number of tackles attempted in the next two seconds after losing the possession",
      tacklesAttempted: "Tackles Attempted",
      highDefensiveActionPct: "% HD Actions",
      highDefensiveActionPctTooltip: "Percentage of Defensive Actions made 40 meters close to the opponent goal",
      individualPressureOppHalf: "Pressure Opp. Half",
      individualPressureOppHalfTooltip: "Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent in the opponent half",
      xGBuildUp5Pass: "xG Buildup 5P",
      xGBuildUp5PassTooltip: "Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)",
      chancesCreatedOpenPlay: "Chances Created OP",
      chancesCreatedOpenPlayTooltip: "Number of passes leading to a shot during open play",
      fmf: {
          "Defender": "Defesa",
          "aerial": "Aéreo",
          "goodDefender": "Bom Defesa",
          "goodPresence": "Boa Presença",
          "playmaking": "criar jogadas",
          "Fullback": "Lateral",
          "defensiveness": "Defensiva",
          "offensiveness": "Ofensiva",
          "fast": "Rápido",
          "Forward": "Para a frente",
          "goalChances": "Oportunidades de golo",
          "goodDecissions": "Boas Decisões",
          "individualTechnique": "Técnica Individual",
          "Goalkeeper": "Guarda-redes",
          "footWork": "Trabalho de pés",
          "leadership": "Liderança",
          "Midfielder": "Médio-defensivo",
          "balance": "Equilíbrio",
          "ballRetention": "% Retenção de Bola",
          "offensivePasses": "Passes ofensivos",
          "recoveries": "Recuperações",
          "shotToGoal": "Remate para a baliza",
          "Attacking-Midfielder": "Médio ofensivo",
          "defensiveGame": "Jogo Defensivo",
          "offensiveGame": "Jogo Ofensivo",
          "Winger": "Ala",
          "crossing": "Cruzamentos",
          "deepProgressions": "Progressões Profundas",
          "defendingEffort": "Esforço de Defesa",
          "facing": "Virado"
      },
      yellowCards:"Yellow Cards",
      redCards: "Red Cards",
      estIndex:"Est. Index",
      mexIndex:"Score Orlegi",
      pecIndex:"PEC Index",
      alert:"Alert",
      yearOfBirth: "Ano de nascimento",
      minYearOfBirth: "Ano mín. de nascimento",
      maxYearOfBirth: "Ano máx. de nascimento",
      women: "Mulheres",
      continental: "Continental",
      countryCup: "Taça Nacional",
      statsName: "Nome",
      abbreviation: "Abreviação",
    },
    playerComparison: {
      upTo5Players: "Comparar até 5 jogadores",
      requestReport: "Relatório de pedido",
      searchBarPlaceholder: "Para comparar um jogador, procure e selecione",
      allStats: "Todas as estatísticas",
      placeholder: "Pode começar a adicionar alguns jogadores"
    },
    reports: {
      detailedInsights: "Obter insights detalhados",
      features: "Características do relatório",
      performance: "Desempenho",
      evolution: "Evolução",
      compareWithMyTeam: "Compare com a minha equipa",
      similarPlayers: "Jogadores semelhantes",
      potentialTeams: "Equipas Potenciais",
      requestSuccess: "Pedido enviado com sucesso",
      requestAt: "Solicitado",
      reportConversation: "Reportar conversa",
      writeYourMessage: "Escreva a sua mensagem...",
      you: "Tu"
    },
    state: {
      requested: "Solicitado",
      inProgress: "Em curso",
      delivered: "Entregue",
    },
    langs: {
      es: "Espanhol",
      en: "Inglês",
      fr: "Francês",
      de: "Alemão",
      it: "Italiano",
      pt: "Portuguese",
      tr: "Turco",
      jp: "Japonês",
      cn: "Chinês",
      sa: "Árabe"
    },
    inbox: {
      subtitle: "Mantenha-se atualizado",
      new_injury_alert: "Novo alerta de lesões",
      new_contract_alert: "Novo alerta de contrato",
      new_team_alert: "Alerta de nova assinatura",
      new_marketValue_alert: "Novo alerta de valor de mercado",
      new_game_alert: "Alerta de novo jogo jogado",
      receive_mail: "Receber e-mail",
      receive_mail_subtitle: "Receba e-mails diários com jogadores que atendem aos filtros",
      receive_notifications: "Notificações",
      receive_notifications_subtitle: "Receber notificações na aplicação com os jogadores que passam o filtro",
      changedTo: "Mudado para",
      alerts: "Alertas",
      includedIn: "Incluído em",
      noContract: "Sem Contrato",
      newMessages: "Novas Mensagens",
      reply: {
        reply: "Reply",
        replyTitle: "Give feedback to the client:",
        replyPlaceholder: "The user will receive the reply along with the status update"
      }
    },
    gameAnalysis: {
      subtitle: "Obtenha informações dos últimos jogos",
      subtitle2: "Mostrando jogos nos próximos sete dias",
      subtitle3: "Obtenha informações sobre os últimos jogos e explore os próximos",
      seeDetail: "Ver detalhes"
    },
    statsNaming: {
      Possession: 'Posse',
      TimePossession: 'Tempo de Posse de Bola',
      PassesPerShots: 'Passes por remate',
      PPDA: 'PPAD',
      ExpectedPoints: 'Pontos Esperados',
      Points: 'Pontos',
      Directness: 'Objetividade',
      PassesPerLongBall: 'Passes por Bola Longa',
      CrossingPerXG: 'Cruzamento por xG',
      PenaltySavedPenaltyFaced: 'Penálti salvo/penálti enfrentado',
      Goals: "Golos",
      NonPenaltyGoals: 'Golos sem Penaltis',
      NPGOpenPlay: "GSP Jogo Aberto",
      NPGSetPiece: "GSP Bola Parada",
      Shooting: 'Rematar',
      Finishing: 'Gols Marcados',
      xGEfficiency: 'xG Eficiência.',
      HeaderPerShot: 'Cabeçeamento por Remate',
      HeaderPerCross: 'Cabeçeamento por Cruzamento',
      Assists: 'Assistências',
      ThroughBalls: 'Bolas entre Linhas',
      CrossEfficiency: 'Eficiência Cruzamento',
      ScoringContribution: 'Contribuição Golo',
      xAssistsOpenPlay: 'xAssistências Jogo Aberto',
      xAssistsSetPiece: 'xAssistências Bola Parada',
      xAssistsOpenPlayInTeam: 'xAssistências Jogo Aberto em Equipa',
      xAssistsSetPieceInTeam: 'xAssistências Bola Parada em Equipa',
      xGBuildupFinalThird: 'xG Construir o Último Terço',
      xGChainFinalThird: 'xG cadeia último terço',
      BallProgressionPassing: 'Progressão da bola por passe',
      BallProgressionDribbling: 'Progressão da bola por condução',
      TacklesWasDribbled: 'Cortes/Foi Fintado',
      TacklesSuccessful: 'Tackles bem sucedidos',
      TacklesUnsuccessful: "Ataques mal sucedidos",
      Interceptions: 'Intercepções',
      Clearances: 'Rebatidas',
      Fouls: 'Faltas',
      Recoveries: 'Recuperações',
      Shots: 'Remates',
      ShotsPerGoal: 'Remates por Golo',
      ShortPassesSuccessful: 'Passes Curtos de sucesso',
      PassingSuccessForwardPct: '% Passes com sucesso para a frente',
      PassingSuccessBackwardPct: '% Passes com sucesso para trás',
      PassingForwardBackwardPct: '% Passando para a frente por trás',
      LongBallPerPassesPct: '% Bola longa por passes',
      LongBallReceived: 'Bolas Longas Recebidas',
      LongBallReceivedOppHalf: 'Bolas longas recebidas no meio-campo adversário',
      OffensiveActions: "Ações Ofensivas",
      DribblesAttempted: 'Dribbles Tentado',
      SuccessfulDribblesPct: '% Dribbles de sucesso',
      OffensiveTouchesOutBoxPct: '% Toques Ofensivos Fora da área',
      BallRetention: '% Retenção de Bola',
      PassingPct: '% Passe',
      PassingOwnHalfPct: '% Passe na própria metade',
      PassingOppHalfPct: '% Passe na metade adversária',
      PassingFinalThird: 'Passe para o terço final',
      PassingFinalThirdPct: '% Passe para o terço final',
      LongBallSuccessful: 'Bolas Longas Completas',
      LongBallPct: '% Bolas Longas',
      SavesPct: '% Defesas',
      SavesInBoxPct: '% Defesas na área',
      SavesOutOfBoxPct: '% defesas fora da área',
      xGSavedPerXGFacedOnTarget: 'xG Defendido/xG Confrontado no Alvo',
      xGFacedOnTargetPerGoalReceived: 'xG Confrontado por Golo',
      xGFacedOnTargetEfficiency: 'Golos Evitados',
      xGFacedOnTarget: "xG Confrontado no Alvo",
      IndividualPressure: "Pressão Individual",
      AerialEfficiency: "Eficiência Aérea",
      AerialWins: 'Vitórias Aéreas',
      AerialWinsPct: '% Vitórias Aéreas',
      xG: 'Golos Esperados',
      xGPerShot: 'xG por Remate',
      ChancesCreated: 'Chances Criadas',
      CompletedCrosses:"Cruzamentos Completos",
      Crossing: '% Cruzamentos',
      OpenPlayKeyPasses: 'Passes chave de jogo aberto',
      OpenPlayKeyPassesInTeam: '% Passes chave de jogo aberto em Equipa',
      OpenPlayPassesIntoOpponentBox: 'Totais passes em jogo aberto para a área adversária',
      OpenPlayPassesIntoOpponentBoxSuccessful: "Passes em jogo aberto para a área adversária",
      xAssists: 'Assistências Esperadas',
      xGChain: 'xG Cadeia',
      xGBuildup: 'xG Construção',
      xGBuildupInTeam: 'xG Construção in Team',
      BallProgression: 'Progressão da Bola',
      SuccessfulDribbles: 'Dribbles de sucesso',
      Dispossessed: 'Desalojado',
      TouchesInOpponentBox: 'Toques na área adversária',
      xGSavedPerShot: 'xG Defesas por remate',
      BallRetentionOppHalf: '% Retenção de bola na Metade adversária',
      DeepProgression: 'Progressão funda',
      DeepProgressionFinalThird: 'Progressão profunda para o terço final',
      FoulsTaken: 'Faltas Tomadas',
      PenaltiesTaken: 'Penaltis Tomadas',
      BlockedCrosses: 'Cruzamentos bloqueados',
      BlockedShots: 'Remates bloqueados',
      Blocks: 'Bloqueios',
      NonPenaltyGoalsAgainst: 'Golos sem penaltis recebidos',
      Headers: "Cabeçeamento",
      AveragePassDistance: "Distância média do passe",
      ProgressiveRuns: "Corridas Progressivas",
      xT: "Ameaça Esperada",
      xGOT: "Golos esperados no alvo",
      BadActions: "Más Ações",
      BadActionsOwnHalf: "Más Ações na Metade",
      AerialsWonOwnBox: "Aéreos Ganhos dentro da Área",
      AerialsWonOppBox: "Aéreos Ganhos Área Adversária",
      AerialsTotalOppBox: "Total Aéreos Área Adversária",
      AerialsTotalOwnBox: "Total Aéreos dentro da Área",
      FoulsOwnHalfPct: "% Faltas Própria Metade",
      RecoveriesOppHalf: "Recupera Metade Offensiva",
      DuelsPct: "% Duelos de sucesso",
      TacklesWasDribbledFirstThird: "Cortes/Foi Fintado primeiro ⅓",
      TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
      TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
      BallProgressionFinalThird: "Progressão da Bola no último ⅓",
      DuelsTotal: "Duelos",
      QuickRecoveries: "Recuperações Rápidas",
      ShotsPerNPG: "Remates por NPG",
      ShotsOutBox: "Remates fora da área",
      GoalsOutBox: "Golos for a da área",
      ShootingOutBox: "% Remates fora da área",
      HandPassing: "% Passe Manual",
      Catching: "% Bolas Apanhadas",
      ClaimAccuracy: "Precisão da Alegação",
      HighTurnovers: "Perdas Perigosas",
      ShotEndingHighTurnovers: "Remates em zonas altas do campo",
      GoalEndingHighTurnovers: "Golo acabado em zonas altas, (perder a bola alto no campo)",
      averageCarriesProgress: "Média condução em progresso",
      ChanceEndingCarries: "Condução acabar em oportunidade ",
      AssistEndingCarries: "Condução acabar em assistência",
      ShotEndingCarries: "Condução acabar em remate",
      GoalEndingCarries: "Condução acabar em golo",
      ShotEndingSequence: "Sequência acabar em remate",
      GoalEndingSequence: "Sequência acabar em golos",
      xTOpenPlay: "xT Jogo Aberto",
      xTSetPiece: "xT Bola Parada",
      xGPerNPG: "xG por NPG",
      xGSetPiece: "xG Bola Parada",
      AerialWonOffensive: "Ofensiva Aérea Ganha",
      AerialWonDefensive: "Defensiva Aérea Ganha",
      xGAgainst: "xG Recebido",
      xGDiffAgainst: "xG Diff Recebido",
      xGPerNPGAgainst: "xG por NPG Recebido",
      xGOpenPlayAgainst: "xG Jogo Aberto Recebido",
      xGSetPieceAgainst: "xG Bola Parada Recebido",
      xGPerShotAgainst: "xG por Remates recebidos",
      ShotsAgainst: "Remates Recebidos",
      RivalPossession: "Posse rival",
      AerialDefensivePct: "% Defensiva aérea",
      HighRecoveries: "Altas Recuperações",
      HighDefensiveActionPct: "% Altas ações defensivas",
      HighDefensiveDistance: "Alta distância defensiva",
      PassesPerPossession: "Passes por Posse",
      LengthPerPossession: "Distância por Posse",
      xTNet: "Net xT",
      AvgCarriesDistance: "Média distância de condução",
      PassesForwardPct: "% Passes para a frente",
      TacklesAttempted: "Abordagens Tentadas",
      DuelsLost: "Duelos perdidos",
      Carries: "Condução",
      CarriesPct: "% Condução",
      Aerials: "Aéreos",
      ProgressivePassesReceivedIntoBox: "Passes Progressivos Recebidos Na Área",
      PassesOppHalf: "Passes Metade Adversária",
      ShotsOnTarget:"Remates no alvo",
      AggressiveActions: "Acções Agressivas",
      Crosses:"Cruzamentos",
      xGBuildup5pass: "xG Construção 5 Passes",
      DefensiveDistance: "Distância Defensiva",
      SpeedSequence: "Velocidade da Sequência",
      Touches: "Toques",
      AerialsTotalOppHalf: "Total Aéreos Metade Adversária",
      AerialsOppHalf: "Aéreos Ganhos Metade Adversária",
      AerialsWonOppHalfPct: "% Aéreos Ganhos Metade Adversária",
      AerialsPctOppBox: "% Aéreos Ganhos Área Adversária",
      AerialsPctOwnBox: "% Aéreos Ganhos dentro da Área",
      AerialDefensive: "Aéreos Defensiva",
      AerialOffensive: "Aéreos Ofensiva",
      AerialOffensivePct: "% Aéreos Ofensiva",
      IndividualPressureOppHalf: "Individual Pressure Metade Adversária",
      ChancesCreatedOP: "Chances Criadas Jogo Aberto",
      TouchesPerShot: "Toques por Remate",
      PassesFinalThirdTotalPct: "% Passes Último ⅓",
      xACrosses: "xA from Cruzamentos",
      Passes: "Passes",
      PassesSuccessful: "Passes Com Sucesso",
      TacklesWasDribbledFouls: "% Ground Duels",
      OffsidesCaught: "Fora de Jogo",
      ProgressivePassesReceivedFinalThird: "Passes Progressivos Recebidos Último ⅓",
      ProgressivePassesReceived: "Passes Progressivos Recebidos",
      Breadth: "Amplitude",
      DuelsDefTotal: "Duelos Defensivos",
      DefensiveActions: "Acções Defensivas",
      ProgressivePassesReceivedOppHalf: "Passes Progressivos Recebidos Metade Adversária",
      CompletedCrossesOP: "Cruzamentos Completos Jogo Aberto",
      CrossingOP: "% Cruzamentos Jogo Aberto",
      PassingContribution: "% Contribuição de Passagem",
    	BallProgressionOppHalfInTeam: "% Progressão da Bola Metade Adversária em Equipa",
    	PassesOPIntoBoxInTeam: "% Passes Jogo Aberto na Área em Equipa",
    	TouchesOppBoxInTeam: "% Toques Área Adversária em Equipa",
    	xGOPInTeam: "% xG Jogo Aberto em Equipa",
      DeepPasses: "Passes Profundos",
      DefensiveDuelsPct: "% Duelos Defensivos",
      QuickRecoveriesPct: "% Recuperações Rápidas",
      DiffDefensiveDistanceTeam: "Diferença de Distância Defensiva da Equipa",
      xTPassing: "xT Passagem",
      xTPassing100Passes: "xT Passagem 100 Passes",
      ProgressivePassesAccurate: "Passes Progressivos",
      PassAbility: "Habilidade de Passe",
      OPPassesIntoOppBoxPct: "% Passes Jogo Aberto na Área Adversária",
      EntriesOppBox: "Inscrições Área Adversária",
      Crosses6yardBox: "Centros al Área Pequeña",
      Cutbacks: "Cutbacks",
      xTDribbling: "xT Dribbling",
      AvgShotDistance: "Distância Média do Tiro",
      xGOnTarget: "xG on Target",
      FinishingxGOT: "Finishing xGOT",
      DribblesWonOwnHalf: "Dribbles Ganhos Própria Metade",
      DribblesOwnHalf: "Dribbles Própria Metade",
      DribblesOwnHalfPct: "% Dribbles Própria Metade",
      DribblesWonOppHalf: "Dribbles Ganhos Metade Adversária",
      DribblesOppHalf: "Dribbles Metade Adversária",
      DribblesOppHalfPct: "% Dribbles Metade Adversária",
      DribblesWonFinalThird: "Dribbles Ganhos Último ⅓",
      DribblesFinalThird: "Dribbles Último ⅓",
      DribblesFinalThirdPct: "% Dribbles Último ⅓",
      ShotEndingHighRecoveries: "Recuperações Altas com Finalização",
      PassingFinalThirdAgainst: "Passes Sofridos no terço final",
      OpenPlayPassesIntoOpponentBoxAgainst: "Total de Passes Sofridos na Área (jogo corrido)",
      EntriesOppBoxAgainst: "Entradas Sofridas na Área Adversária",
      DeepProgressionAgainst: "Progressões Profundas Sofridas",
      TouchesInOpponentBoxAgainst: "Toques Sofridos na Área Adversária",
      Score: 'Pontuação',
      PDScore: 'Pontuação Física',
      OrlegiScore: "Score Orlegi",
      SirScore: "Sirius Score",
      xTOPInTeam: "xT Jogo Aberto em Equipa",
      YellowCards: "Cartões Amarelos",
      RedCards: "Cartões Vermelhos",
      xTOpenPlayAgainst: "xT Jogo Aberto Recebido",
      xTSetPieceAgainst: "xT Bola Parada Recebido",
      NPGOpenPlayAgainst: "GSP Jogo Aberto Recebido",
      NPGSetPieceAgainst: "GSP Bola Parada Recebido",
      PassesOppHalfPerPossession: "Passes Metade Adversária por Posse",
      AverageTimeRecovery: "Tempo Médio de Recuperação",
      ExpectedPassing: "% Passagem Esperada",
      NumPossession10Passes: "Posse 10 Passes",
      PassesReceived: "Passes Recebidos",
      PassesReceivedFinalThird: "Passes Recebidos Final ⅓",
      ProgressivePassesTotalPct: "% de Passes Progressivos",
      ShortPassesPct: '% Passes Curtos',
      //Physical Stats
      TotalDistance: "Total Distance",
      DistanceTIP: "Distance TIP",
      DistanceOTIP: "Distance OTIP",
      WalkingDistance: "Distância a Pé",
      JoggingDistance: "Distância de Trote",
      RunningDistance: "Distância de Corrida",
      ExtremeAccelerations: "Acelerações Extremas",
      NumberOfRuns: "Número de Corridas",
      HsrNumber: "Quantidade de HSR",
      HsrDistance: "Distância HSR",
      HsrDistancePct: "% HSR Distance",
      SprintsNumber: "Quantidade de Sprints",
      SprintsDistance: "Sprints Distância",
      SprintNumberDeclinePct: "% Sprint Quantity Decline",
      SprintDistanceDeclinePct: "% Sprint Distance Decline",
      SprintDistancePct: "% Sprint Distance",
      Accelerations: "Accelerations Quantity",
      ExplosiveDistance: "Explosive Distance",
      MaxSpeed: "Max. Speed",
      AvgMaxSpeed: "Avg. Max. Speed",
      MaxAccelerations: "Max. Accelerations",
      //Arrigo
      BypassedPlayersByPasses: "Jogadores Superados",
      BypassedDefendersByPasses: "Defensores Superados",
      PassesBypassingPlayers: "Passes que Superam Jogadores",
      PassesBypassingDefenders: "Passes que Superam Defensores",
      BypassedPlayersPerPass: "Jogadores Superados por Passe",
      BypassedDefendersPerPass: "Defensores Superados por Passe",
      LineBreakingPasses: "Passes Quebrando Linhas",
      LineBreakingPassesMD: "Passes Quebrando Linhas MD",
      LineBreakingPassesM: "",
      LineBreakingThroughBalls: "Bolas Quebrando Linhas",
      LineBreakingPassesPerPass: "Linhas Quebradas por Passe",
      TotalPassesUnderStrongPressure: "Total de Passes sob Forte Pressão",
      TotalPassesUnderLightPressure: "Total de Passes sob Pressão",
      SuccessfulPassesUnderStrongPressure: "Passes sob Forte Pressão Completas",
      SuccessfulPassesUnderLightPressure: "Passes sob Pressão Completas",
      PassingUnderStrongPressure: "% Passes Realizados sob Forte Pressão",
      PassingUnderLightPressure: "% Passes Realizados sob Pressão",
      PassReceiptsInSpaceCompleted: "Passes Recebidos no Espaço Completadas",
      PassReceiptsInSpace: "Passes Recebidos no Espaço",
      TotalStrongOnBallPressures: "Total de Pressões Fortes na Bola",
      TotalLightOnBallPressures: "Total de Pressões na Bola",
      SuccessfulStrongOnBallPressures: "Pressões Fortes na Bola Completas",
      SuccessfulLightOnBallPressures: "Pressões na Bola Completas",
      StrongOnBallPressuresPct: "% de Pressões Fortes na Bola",
      LightOnBallPressuresPct: "% de Pressões na Bola",
      TimesBypassedByPasses: "Superado por Passes",
      TimesBypassedByCarries: "Superado por Conduções",
      TimesBypassedByActions: "Superado por Ações",
      BypassedPlayersByCarries: "Jogadores Superados por Conduções",
      BypassedDefendersByCarries: "Defesas Superados por Conduções",
      BypassedPlayersByActions: "Jogadores Superados por Ações",
      BypassedDefendersByActions: "Defesas Superados por Ações",
      CarriesBypassingPlayers: "Conduções que Superam Jogadores",
      CarriesBypassingDefenders: "Conduções que Superam Defesas",
      BypassedPlayersPerCarry: "Jogadores Superados por Condução",
      BypassedDefendersPerCarry: "Defesas Superados por Condução",
      LineBreakingCarries: "Conduções entre Linhas",
      LineBreakingCarriesMD: "Conduções entre Linhas Defesas e Médios",
      LineBreakingCarriesM: "Conduções entre Linha dos Médios",
      LineBreakingCarriesD: "Conduções entre Linha dos Defesas",
      LineBreakingCarriesPerCarry: "Conduções entre Linhas por Condução",
      LineBreakingActions: "Ações entre Linhas",
      LineBreakingActionsMD: "Ações entre Linhas Defesas e Médios",
      LineBreakingActionsM: "Ações entre Linha dos Médios",
      LineBreakingActionsD: "Ações entre Linha dos Defesas",
      PassesPerLineBreakingPass: "Passes por Passe entre Linhas",
      CarriesPerLineBreakingCarry: "Conduções por Condução entre Linhas",
      LinesBrokenByPasses: "Linhas Quebradas por Passes",
      LinesBrokenByCarries: "Linhas Quebradas por Conduções",
      LinesBrokenByActions: "Linhas Quebradas por Ações",
      LinesBrokenPerPass: "Linhas Quebradas por Passe",
      LinesBrokenPerCarry: "Linhas Quebradas por Condução",
      //End Physical
      description: {
        Possession: "Percentagem de posse de bola da equipa",
        TimePossession: 'Tempo de posse de bola da equipe',
        PassesPerShots: "Número médio de passes dado por remate",
        PPDA: "Passes Por Ação Defensiva. PPDA mede a pressão que a equipa coloca sobre os jogadores da oposição quando estão na posse da bola. O valor corresponde ao número médio de passes numa linha que o adversário conseguiu completar antes de ser interrompido. Quanto maior for o valor, mais passes o adversário foi autorizado a completar",
        Directness: "Mede o quão direta é uma equipa. Um elevado valor de objetividade está relacionado com uma maior quantidade de passes para a frente no que diz respeito aos passes laterais",
        ExpectedPoints: "Número de pontos esperados por uma equipa, calculado com base nos Golos Esperados gerados e sofridos. Esta métrica permite-nos avaliar melhor o desempenho de uma equipa durante um jogo (ou um conjunto de jogos) quando comparado com o número de pontos realmente alcançados",
        PassesPerLongBall: "Percentagem de passes longos bem-sucedidos do número total de passes concluídos",
        CrossingPerXG: "Percentagem de golos Esperados vindos de cruzamentos",
        PenaltySavedPenaltyFaced: "Percentagem de penáltis salvos de todos os penáltis guardados",
        Goals: "Number of goals scored per 90 minutes of play",
        NonPenaltyGoals: "Número de golos marcados por 90 minutos, excluindo os golos de penálti",
        NPGOpenPlay: "Número de golos marcados durante o jogo aberto, excluindo os golos de penálti",
        NPGSetPiece: "Número de golos marcados durante bola parada, excluindo os golos de penálti",
        Shooting: "Percentagem de remates no alvo",
        Finishing: "Percentagem de remates que acabam na baliza",
        xGEfficiency: "Quantidade de golos esperados necessários para um jogador marcar um golo",
        HeaderPerShot: "Número de cabeceamentos feitos por 90 minutos",
        HeaderPerCross: "Percentagem de cruzamentos cabeceados pelo jogador do número total de cruzamentos completados pela equipa",
        Assists: "Número de assistências por 90 minutos",
        ThroughBalls: "Número de bolas jogadas para o jogador fazer uma corrida ofensiva para criar uma mudança na baliza por 90 minutos",
        CrossEfficiency: "Número de cruzamentos que tenham sido concluídas/cruzamentos tentados",
        ScoringContribution: "Número de assistências e golos por 90 minutos",
        xAssistsOpenPlay: "Número de assistências esperadas durante o jogo aberto por 90 minutos",
        xAssistsSetPiece: "Número de assistências esperadas durante o jogo definido por 90 minutos",
        xAssistsOpenPlayInTeam: 'Número de assistências esperadas durante o jogo aberto em Equipa',
        xAssistsSetPieceInTeam: 'Número de assistências esperadas durante o jogo definido em Equipa',
        xGChainFinalThird: "Quantidade de xG um jogador participou no terço final",
        xGBuildupFinalThird: "Quantidade de xG um jogador participou no último terço (excluindo tiros e passes antes de um tiro)",
        BallProgressionPassing: "Número de vezes que o jogador avança a bola a 10 metros ou mais ao passar a bola",
        BallProgressionDribbling: "Número de vezes que o jogador avança a bola a 10 metros ou mais conduzindo a bola",
        BallProgression: "Número de vezes que o jogador avança 10 ou mais metros, quer por passagem, carregando a bola ou uma combinação de ambos (por 90 minutos)",
        TacklesWasDribbled: "Métrica que tem em conta a percentagem de vezes que o jogador recupera a bola através de um corte vs. as vezes que foi passada/executada. Quanto maior o indicador, melhor",
        TacklesSuccessful: "Número de tackles bem-sucedidos feitos pelo jogador",
        Interceptions: "Número de vezes que o jogador interceda um passe para evitar que a bola atinja o seu alvo por 90 minutos",
        Clearances: "Número de vezes que o jogador bate a bola fora da zona defensiva por 90 minutos.",
        Fouls: "Número de faltas cometidas pelo jogador por 90 minutos",
        Recoveries: "Número de bolas recuperadas por um jogador por 90 minutos",
        Shots: "Número total de remates feitos por 90 minutos",
        ShotsPerGoal: "Número de remates à baliza necessário para marcar um golo de grande penalidade para o Guarda-redes.",
        ShortPassesSuccessful: "Número de passes curtos (menos de 12 metros) concluídos por 90 minutos",
        PassingSuccessForwardPct: "Percentagem de passes bem-sucedidos na direção da frente",
        PassingSuccessBackwardPct: "Percentagem de passes bem-sucedidos para trás",
        PassingForwardBackwardPct: "Relação de passes na direção dianteira contra passes para trás",
        LongBallPerPassesPct: "Percentagem de passes longos concluídos (>32 metros) de todos os passes concluídos pelo jogador.",
        LongBallReceived: "Número de passes longos (>32 metros) recebidos pelo jogo",
        LongBallReceivedOppHalf: "Número de passes longos (>32 metros) recebidos pelo jogado na metade do adversário",
        DribblesAttempted: "Número de dribles tentados por 90 minutos",
        SuccessfulDribblesPct: "Dribles/total de tentativas de dribles com sucesso",
        BallRetention: "Percentagem de vezes que tem a posse da bola e não acaba por a perder",
        PassingPct: "Percentagem de passes preenchidos de todos os passes dados pelo jogador",
        PassingOwnHalfPct: "Percentagem de passes concluídos de todos os passes dados pelo jogador (apenas passa na própria metade)",
        PassingOppHalfPct: "Percentagem de passes concluídos de todos os passes dados pelo jogador (só passa para a metade do adversário)",
        PassingFinalThird: "Passes completos para o último terço por 90 minutos",
        PassingFinalThirdPct: "Percentagem de passes concluídos de todos os passes dados pelo jogador (apenas passa para o terço final)",
        LongBallSuccessful: "Número de passes completos acima de 32 metros",
        LongBallPct: "Número de passes completos acima de 32 metros/ Total passa acima de 32 tentativas.",
        SavesPct: "Percentagem de defesas do número total de remates sofridos",
        SavesInBoxPct: "Percentagem de remates defendidos entrando na caixa",
        SavesOutOfBoxPct: "Percentagem de remates defendidos vindo de fora da área",
        xGSavedPerXGFacedOnTarget: "Coeficiente que indica a percentagem do xG esperado que é defendido pelo Guarda-Redes. Um valor de 1 nesta métrica significaria que o guarda-redes, guarda-redes salva todos os golos esperados dos remates sofridos pela equipa, enquanto um valor de 0 significaria que todos os golos esperados gerados pelo adversário acabam na baliza.",
        xGFacedOnTargetPerGoalReceived: "Métrica que indica quantos Golos Esperados são necessários para marcar um golo a um certo Guarda-Redes. Uma pontuação elevada nesta métrica significa que para converter um golo a este Guarda-redes é necessário criar um elevado número de xG",
        xGFacedOnTargetEfficiency: "Número de golos de não-penálti impedidos pelo Guarda-redes. Este é o número de golos esperados no alvo recebido pelo Guarda-redes menos o número de golos sofridos (não penálti). Indica o número de golos que não foram marcados pelo adversário graças ao guarda-redes",
        xGFacedOnTarget: "Total xG (guardado e marcado) enfrentado pelo guarda-redes",
        IndividualPressure: "Métrica que mede objetivamente a pressão que um jogador coloca",
        AerialEfficiency: "Combinação entre a sua percentagem de sucesso em duelos aéreos, juntamente com o volume de duelos aéreos ganhos.",
        AerialWins: "Número de aéreos que o jogador ganha por 90 minutos",
        AerialWinsPct: "Número de aéreos que o jogador ganha do número total de duelos aéreos em que o jogador esteve envolvido",
        xG: "Golos esperados gerados por 90 minutos. Esta métrica mede a probabilidade de um remate terminar num golo baseado em diferentes variáveis (distância, ângulo, tipo de jogo, parte do corpo, ...) de tal ação. Pode aprender mais na <b><a href='https://www.driblab.com/analysis-team/expected-goals-xg-what-it-is-and-how-it-works'>Expected Goals: What it is and how it works</a></b>",
        xGPerShot: "XG médio dos remates feitos por um jogador. Esta métrica mede a perigosidade média dos remates tomados. Quanto maior, mais provável é que os teus tiros acabem na baliza. Um xG por tiro alto significa que o jogador escolhe bem os seus tiros.",
        ChancesCreated: "Número de passes que precedem um remate",
        CompletedCrosses:"Número de cruzamentos concluídos por 90 minutos",
        Crossing: "Percentagem de cruzamentos que foram concluídas a partir de cruzamentos tentadas",
        OpenPlayKeyPasses: "Número de passes preenchidos pelo jogador durante o jogo aberto por 90 minutos",
        OpenPlayKeyPassesInTeam: 'Percentagem de passes preenchidos pelo jogador durante o jogo aberto em Equipa',
        OpenPlayPassesIntoOpponentBox: "Totais número de passes preenchidos pelo jogador na caixa do adversário durante o jogo aberto por 90 minutos",
        OpenPlayPassesIntoOpponentBoxSuccessful: "Número de passes preenchidos pelo jogador na caixa do adversário durante o jogo aberto por 90 minutos",
        xAssists: "É uma métrica que analisa a qualidade das oportunidades criadas que ocorrem numa partida. Cada assistência de remate tem um valor baseado na probabilidade de que o remate acaba por ser marcado. Este valor é atribuído de acordo com o local do passe o tipo (peça transversal...) estado do jogo etc. Ao contrário do x-XA xA é uma métrica que idealmente um jogador teria mais do que os seus números de assistência, uma vez que um criador só pode controlar os seus passes de qualidade (xA), enquanto o seu número de assistência depende do finalizador",
        xGChain: "Indica em que xG os movimentos ofensivos em que o jogador participa terminam",
        xGBuildup: "Semelhante à cadeia xG, mas sem ter em conta os últimos 2 jogadores da sequência (último transeunte e atirador)",
        xGBuildupInTeam: 'xG Construção in Team',
        BallProgression: "Número de vezes que o jogador avança 10 ou mais metros, quer por passe, quer por uma combinação de ambos (para 90 min) ",
        SuccessfulDribbles: "Número de dribles concluídos com sucesso por 90 minutos",
        Dispossessed: "Número de vezes que um jogador é abordado e perde a posse da bola por 90 minutos",
        TouchesInOpponentBox: "Número de vezes que um jogador tem posse de bola na área do adversário por 90 minutos",
        xGSavedPerShot: "Probabilidade média de golo sofrido no alvo",
        BallRetentionOppHalf: "Percentagem de vezes que se tem a posse da bola e não se acaba por perdê-la dentro da metade do adversário",
        DeepProgression: "Número de vezes que um jogador atinge o último quinto do campo carregando a bola, mais o número de vezes que o jogador tem posse de bola no último quinto",
        DeepProgressionFinalThird: "Number of times a player reaches the final third of the pitch by carrying the ball, plus the number of times the player has possession of the ball in the final third",
        FoulsTaken: "Number of times the player was fouled per 90 minutes of play",
        PenaltiesTaken: "Número de vezes que o jogador foi derrubado na área do adversário por 90 minutos",
        BlockedCrosses: "Número de cruzamentos bloqueados pelo jogador por 90 minutos",
        BlockedShots: "Número de remates bloqueados pelo jogador por 90 minutos",
        NonPenaltyGoalsAgainst: "Número de golos não penálti sofridos por 90 minutos",
        Headers: "Cabeceamentos",
        AveragePassDistance: "Distância média do passe",
        ProgressiveRuns: "Corridas Progressivas",
        xT: "A Ameaça Esperada (xT) é uma métrica que mede a ameaça que um jogador cria ao adversário, carregando ou passando a bola para áreas onde a probabilidade de a posse de bola terminar num golo é maior",
        xGOT: "Golos esperados no alvo. Número de golos esperados enfrentados pelo Guarda-redes. Esta métrica só tem em conta os remates no alvo (remates falhados e remates no poste são excluídos)",
        BadActions: "Más Ações",
        BadActionsOwnHalf: "Más Ações na Metade",
        AerialsWonOwnBox: "Duelos Aéreos Ganados en Área Propia",
        AerialsWonOppBox: "Aerials Won Opp Box",
        AerialsTotalOppBox: "Aerials Total Opp Box",
        AerialsTotalOwnBox: "Aerials Total Own Box",
        FoulsOwnHalfPct: "% Faltas en Campo Propio",
        RecoveriesOppHalf: "Número de bolas recuperadas por um jogador em metade offensiva por 90 minutos",
        DuelsPct: "% Duelos Existosos",
        TacklesWasDribbledFirstThird: "Tackles/Fue regateado en el último tercio",
        TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
        TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
        BallProgressionFinalThird: "Progresiones de Balón en el Último tercio",
        DuelsTotal: "Número total de Desarmes, Jogadas Aéreas, Toques de Bola, Dribles e Faltas cometidas por 90 minutos",
        QuickRecoveries: "Recuperaciones a 40 metros o más de la propia portería en los siguientes 5 segundos después de pérdida",
        ShotsPerNPG: "Número de Remates por Gol sin Penaltis",
        ShotsOutBox: "Remates desde Fuera del Área por 90 minutos",
        GoalsOutBox: "Goles desde Fuera del Área por 90 minutos",
        ShootingOutBox: "Percentagem de Remates a Puerta  de tiros desde Fuera del Área",
        HandPassing: "Percentagem de Pases completados con la Mano",
        Catching: "Percentagem de paragens presas",
        ClaimAccuracy: "Mede o quão bom é um Guarda-redes a apanhar/bloquear bolas aéreas. Um número acima de 1 indica que o Guarda-Redes apanha mais bolas aéreas do que o esperado",
        HighTurnovers: "Rotatividade a menos de 40 metros da própria baliza",
        ShotEndingHighTurnovers: "Rotatividade elevada (rotatividade a menos de 40 metros da própria baliza) que acabam num remate da equipa adversária",
        GoalEndingHighTurnovers: "Altas rotatividades (rotatividade a menos de 40 metros da própria baliza) que acabam num golo da equipa adversária",
        AverageCarriesProgress: "Distância média que um jogador move a bola verticalmente por transporte (metros)",
        ChanceEndingCarries: "Carrega pelo menos 7 metros que acabam num passe que se segue a um tiro",
        AssistEndingCarries: "Carrega pelo menos 7 metros que acabam num passe que se segue a um golo",
        ShotEndingCarries: "Carrega pelo menos 7 metros que acabam num remate",
        GoalEndingCarries: "Carrega pelo menos 7 metros que acabam numa baliza",
        ShotEndingSequence: "Número de Sequências terminando em remate onde o jogador esteve envolvido",
        GoalEndingSequence: "Número de Sequências terminando em golo onde o jogador esteve envolvido",
        xTOpenPlay: "Ameaça esperada gerada durante o jogo aberto por 90 minutos",
        xTSetPiece: "Ameaça esperada gerada durante o bola parada por 90 minutos",
        xGPerNPG: "xG por NPG",
        xGSetPiece: "xG bola parada",
        AerialWonOffensive: "Ofensiva Aérea Ganha",
        AerialWonDefensive: "Defensiva Aérea Ganha",
        xGAgainst: "xG Recebido",
        xGDiffAgainst: "xG Diff Recebido",
        xGPerNPGAgainst: "xG por NPG Recebido",
        xGOpenPlayAgainst: "xG jogo aberto recebido",
        xGSetPieceAgainst: "xG Bola Parada recebidos",
        xGPerShotAgainst: "xG por remate recebido",
        ShotsAgainst: "Remates recebidos",
        RivalPossession: "Posse Rival",
        AerialDefensivePct: "% Defensivo aéreo",
        HighRecoveries: "Altas Recuperações",
        HighDefensiveActionPct: "Percentagem de Acções Defensivas (Tackles, Intercepções, Blocos, Faltas e 1vs1) feitas a 40 metros acima da própria linha de base",
        HighDefensiveDistance: "Distância média do próprio objectivo de todas as acções defensivas",
        PassesPerPossession: "Passes por Posse",
        LengthPerPossession: "Distância por Posse",
        xTNet: "Ameaça Esperada Líquida",
        AvgCarriesDistance: "média condução distância",
        PassesForwardPct: "% Passes Vão para a frente",
        TacklesAttempted: "Cortes Tentadas",
        DuelsLost: "Duelos perdidos",
        Carries: "Condução",
        CarriesPct: "% Condução",
        Aerials: "Aéreos",
        ProgressivePassesReceivedIntoBox: "Passes Progressivos Recebidos na área",
        PassesOppHalf: "Passes Opp. Half",
        ShotsOnTarget:"Remates no alvo",
        AggressiveActions: "Acções Agressivas",
        Crosses:"Cruzamentos",
        xGBuildup5pass: "Quantidade de xG em que um jogador participou, apenas os últimos 5 passes (excluindo tiros e passes que levam a um tiro)",
        DefensiveDistance: "Distância média até à meta própria dos duelos defensivos realizados",
        SpeedSequence: "Velocidade média (metros cobertos pelo tempo gasto) de todos os pertences de uma equipa",
        Touches: "Toques",
        AerialsTotalOppHalf: "Total Aéreos Metade Adversária",
        AerialsOppHalf: "Aéreos Ganhos Metade Adversária",
        AerialsWonOppHalfPct: "% Aéreos Ganhos Metade Adversária",
        AerialsPctOppBox: "Percentagem de duels aéreos ganhos área adversária",
        AerialsPctOwnBox: "Percentagem de duels aéreos ganhos dentro da área",
        AerialDefensive: "Número total de duelos aéreos quando a própria equipa tem a posse de bola",
        AerialOffensive: "Número total de duelos aéreos quando a equipa adversária tem a posse de bola",
        AerialOffensivePct: "Percentagem de duelos aéreos ganhos quando a própria equipa tem a posse de bola",
        IndividualPressureOppHalf: "Posse recuperada por um jogador quando pressiona o adversário na metade adversária",
        ChancesCreatedOP: "Número de passes em jogo que precedem um remate",
        TouchesPerShot: "Toques por Remate",
        PassesFinalThirdTotalPct: "Percentagem de passes no último ⅓",
        xACrosses: "xA from cruzamentos",
        Passes: "Passes",
        PassesSuccessful: "Passes com sucesso",
        TacklesWasDribbledFouls: "Percentagem de golpes ganhos como percentagem do total de golpes e faltas cometidas",
        OffsidesCaught: "Fora de Jogo",
        ProgressivePassesReceivedFinalThird: "Passes Progressivos Recebidos Último ⅓",
        ProgressivePassesReceived: "Passes Progressivos Recebidos",
        Breadth: "Soma de Tackles, Desafios, Intercepções e Faltas cometidas, nos lados do campo",
        DuelsDefTotal: "Soma do total de golpes, duelos aéreos defensivos e faltas cometidas",
        DefensiveActions: "Acções defensivas quando um oponente tenta driblar (Tackles, Desafios e Faltas)",
        ProgressivePassesReceivedOppHalf: "Passes Progressivos Recebidos Metade Adversária",
        CompletedCrossesOP: "Número de cruzamentos concluídos em jogo aberto",
        CrossingOP: "Percentagem de cruzes completadas de todas as cruzes tentadas em jogo aberto",
        PassingContribution: "Percentagem que mede a ameaça de passes tendo em conta a posição do receptor",
        BallProgressionOppHalfInTeam: "% Progressão da Bola Metade Adversária em Equipa",
        PassesOPIntoBoxInTeam: "% Passes Jogo Aberto na Área em Equipa",
        TouchesOppBoxInTeam: "% Toques Área Adversária em Equipa",
        xGOPInTeam: "% xG Jogo Aberto em Equipa",
        DeepPasses: "Passa de fora de um raio de 20 metros da baliza adversária que termina dentro daquela área",
        DefensiveDuelsPct: "Percentagem de duelos defensivos ganhos em relação ao total de duelos defensivos",
        QuickRecoveriesPct: "Percentagem de recuperações rápidas para intercepções e tentativas de abordagem",
        DiffDefensiveDistanceTeam: "Diferença entre a distância defensiva do jogador e a distância defensiva da sua equipa",
        xTPassing: "Ameaça esperada gerada apenas a partir de passes",
        xTPassing100Passes: "Ameaça esperada gerada apenas a partir de passes e por 100 passes",
        ProgressivePassesAccurate: "Passes completados de 10 metros ou mais no eixo X",
        PassAbility: "Relação de passes concluídos em relação aos passes esperados (xP)",
        OPPassesIntoOppBoxPct: "Percentagem de jogo aberto concluído passa para a caixa adversária e o jogo aberto tenta passar para a área adversária",
        EntriesOppBox: "Número de passes e carrega para a área adversária",
        Crosses6yardBox: "Número total de cruzes que terminam na área pequeña",
        Cutbacks: "Passar da linha de base para trás e dentro da área adversária",
        xTDribbling: "Ameaça esperada gerada apenas por dribbles",
        AvgShotDistance: "Distância média do número total de tiros",
        xGOnTarget: "Golos esperados dos tiros feitos no alvo",
        FinishingxGOT: "Percentagem de remates no alvo terminando num golo",
        DribblesWonOwnHalf: "Número de dribbles bem sucedidos feitos na própria metade",
        DribblesOwnHalf: "Número de tentativas de dribbles feitas na própria metade",
        DribblesOwnHalfPct: "Percentagem de dribbles bem sucedidos e tentativas de dribbles feitos na própria metade",
        DribblesWonOppHalf: "Número de dribbles bem sucedidos feitos na metade adversária",
        DribblesOppHalf: "Número de tentativas de dribbles feitos na metade adversária",
        DribblesOppHalfPct: "Percentagem de dribbles bem sucedidos e tentativas de dribbles feitos na metade adversária",
        DribblesWonFinalThird: "Número de dribbles bem sucedidos feitos no terço final",
        DribblesFinalThird: "Número de tentativas de dribbles feitas no terço final",
        DribblesFinalThirdPct: "Percentagem de dribbles bem sucedidos e tentativas de dribbles feitos no terço final",
        ShotEndingHighRecoveries: "Recuperações altas (feitas a 40 metros ou menos do gol adversário) que terminam em finalização",
        PassingFinalThirdAgainst: "Passes bem-sucedidos do adversário para o terço final",
        OpenPlayPassesIntoOpponentBoxAgainst: "Número total de passes do adversário para dentro da nossa área em jogo corrido",
        EntriesOppBoxAgainst: "Número de passes e conduções do adversário para dentro da nossa área",
        DeepProgressionAgainst: "Número de vezes que o adversário chega ao último quinto do campo com a bola, mais a posse no nosso primeiro quinto",
        TouchesInOpponentBoxAgainst: "Número de vezes que o adversário teve a posse na nossa área",
        Score: 'Desempenho do jogador com base em diferentes métricas',
        PDScore: 'Desempenho físico do jogador com base em diferentes métricas físicas',
        OrlegiScore: "Desempenho do jogador com base em diferentes métricas",
        SirScore: "Desempenho do jogador com base em diferentes métricas",
        xTOPInTeam: "Perigo esperado (xT) gerado no jogo em relação ao total da sua equipa",
        YellowCards: "Yellow Cards",
        RedCards: "Red Cards",
        xTOpenPlayAgainst: "Ameaça esperada concedida durante jogo aberto",
        xTSetPieceAgainst: "Ameaça esperada concedida durante o bola parada",
        NPGOpenPlayAgainst: "GSP Jogo Aberto Recebido",
        NPGSetPieceAgainst: "GSP Bola Parada Recebido",
        PassesOppHalfPerPossession: "Passes Metade Adversária por Posse",
        AverageTimeRecovery: "Tempo Médio de Recuperação",
        ExpectedPassing: "Porcentagem de passes que deveriam ter sido concluídos",
        NumPossession10Passes: "Posse 10 Passes",
        PassesReceived: "Passes Recebidos",
        PassesReceivedFinalThird: "Passes Recebidos Final ⅓",
        ProgressivePassesTotalPct: "% de Passes Progressivos",
        ShortPassesPct: '% Passes Curtos',
        //Physical Stats
        TotalDistance: "Distância total percorrida pelo jogador durante uma partida",
        WalkingDistance: "Distância total percorrida pelo jogador durante uma partida a uma velocidade inferior a 2 m/s (7,2 km/h)",
        JoggingDistance: "Distância total percorrida pelo jogador durante uma partida a uma velocidade entre 2 m/s (7,2 km/h) e 4 m/s (14,4 km/h)",
        RunningDistance: "Distância total percorrida pelo jogador durante uma partida a uma velocidade entre 4 m/s (14,4 km/h) e 5,5 m/s (19,8 km/h)",
        NumberOfRuns: "Número de corridas completadas a uma velocidade entre 4 m/s (14,4 km/h) e 5,5 m/s (19,8 km/h)",
        ExtremeAccelerations: "Número de vezes que o jogador acelera mais de 3 m/s²",
        DistanceTIP: "Distância (Equipa em Posse) que o jogador percorreu durante uma partida com posse",
        DistanceOTIP: "Distância OTIP (Equipa Oponente em Posse) que o jogador percorreu durante uma partida sem posse",
        HsrNumber: "Número de vezes que o jogador se move a uma velocidade igual ou superior a 5,5 m/s (19,8 km/h) mas inferior a 7 m/s (25,2 km/h) por um período de pelo menos 1 segundo",
        HsrDistance: "Distância total percorrida pelo jogador durante uma partida a uma velocidade igual ou superior a 5,5 m/s (19,8 km/h) mas inferior a 7 m/s (25,2 km/h)",
        HsrDistancePct: "Percentagem da distância HSR (corrida de alta velocidade) em relação à distância total percorrida",
        SprintsNumber: "Número de vezes que o jogador se move a uma velocidade igual ou superior a 7 m/s (25,2 km/h) por um período de pelo menos 1 segundo",
        SprintsDistance: "Distância total percorrida pelo jogador durante uma partida a uma velocidade igual ou superior a 7 m/s (25,2 km/h)",
        SprintNumberDeclinePct: "Porcentagem de diminuição no número de sprints realizados em comparação com o segundo tempo da partida",
        SprintDistanceDeclinePct: "Porcentagem de diminuição na distância percorrida durante sprints em comparação com o segundo tempo da partida",
        SprintDistancePct: "Percentagem da distância de sprint em relação à distância total percorrida",
        Accelerations: "Número de vezes que o jogador acelera entre 1,5 m/s² e 3 m/s²",
        ExplosiveDistance: "Distância explosiva",
        MaxSpeed: "Velocidade máxima alcançada pelo jogador",
        AvgMaxSpeed: "Velocidade máxima média alcançada pelo jogador",
        MaxAccelerations: "Aceleração máxima em metros/segundo² alcançada pelo jogador",
        BypassedPlayersByPasses: "Número de jogadores no lado do golo do portador da bola no início do evento de toque, menos o número de jogadores no lado do golo no final do evento",
        BypassedDefendersByPasses: "Número de defesas no lado do golo do portador da bola no início do evento de toque, menos o número de defesas no lado do golo no final do evento",
        PassesBypassingPlayers: "Número de passes que ultrapassaram jogadores",
        PassesBypassingDefenders: "Número de passes que ultrapassaram defesas",
        BypassedPlayersPerPass: "Número total de jogadores ultrapassados por passe",
        BypassedDefendersPerPass: "Número total de defesas ultrapassados por passe",
        LineBreakingPasses: "Passes completos que avançam a bola pelo menos 10% mais próximo do golo adversário e cruzam uma dupla de defesas em proximidade ou passam atrás da linha defensiva",
        LineBreakingPassesMD: "Número de passes linha-quebra dos defesas para meio-campistas",
        LineBreakingPassesM: "",
        LineBreakingThroughBalls: "Passes em profundidade que quebram linhas",
        LineBreakingPassesPerPass: "Número de linhas quebradas por passe",
        TotalPassesUnderStrongPressure: "Número total de passes realizados sob forte pressão (a 0-2 metros do adversário mais próximo)",
        TotalPassesUnderLightPressure: "Número total de passes realizados sob pressão (a 2-4 metros do adversário mais próximo)",
        SuccessfulPassesUnderStrongPressure: "Número de passes bem-sucedidos sob forte pressão (a 0-2 metros do adversário mais próximo)",
        SuccessfulPassesUnderLightPressure: "Número de passes bem-sucedidos sob pressão (a 2-4 metros do adversário mais próximo)",
        PassingUnderStrongPressure: "Percentagem de passes bem-sucedidos e totais realizados sob forte pressão (a 0-2 metros do adversário mais próximo)",
        PassingUnderLightPressure: "Percentagem de passes bem-sucedidos e totais realizados sob pressão (a 2-4 metros do adversário mais próximo)",
        PassReceiptsInSpaceCompleted: "Passes realizados onde o receptor está na metade ofensiva sem defesas num raio de 5 metros na direção do golo",
        PassReceiptsInSpace: "Passes recebidos na metade ofensiva sem defesas num raio de 5 metros na direção do golo",
        TotalStrongOnBallPressures: "Número de pressões fortes sobre o portador da bola (a 0-2 metros)",
        TotalLightOnBallPressures: "Número de pressões sobre o portador da bola (a 2-4 metros)",
        SuccessfulStrongOnBallPressures: "Número de pressões fortes bem-sucedidas sobre o portador da bola (a 0-2 metros)",
        SuccessfulLightOnBallPressures: "Número de pressões bem-sucedidas sobre o portador da bola (a 2-4 metros)",
        StrongOnBallPressuresPct: "Percentagem de pressões fortes bem-sucedidas e totais sobre o portador da bola (a 0-2 metros)",
        LightOnBallPressuresPct: "Percentagem de pressões bem-sucedidas e totais sobre o portador da bola (a 2-4 metros)",
        TimesBypassedByPasses: "Número total de vezes superado por passe",
        TimesBypassedByCarries: "Número total de vezes superado por condução",
        TimesBypassedByActions: "Número total de vezes superado por passes e conduções combinados",
        BypassedPlayersByCarries: "Número total de adversários (defensores e meio-campistas) superados por conduções",
        BypassedDefendersByCarries: "Número total de adversários (defensores) superados por conduções",
        BypassedPlayersByActions: "Número total de adversários (defensores e meio-campistas) superados por passes e conduções combinados",
        BypassedDefendersByActions: "Número total de adversários (defensores) superados por passes e conduções combinados",
        CarriesBypassingPlayers: "Número de conduções que superaram jogadores",
        CarriesBypassingDefenders: "Número de conduções que superaram defensores",
        BypassedPlayersPerCarry: "Média de adversários superados por condução",
        BypassedDefendersPerCarry: "Média de defensores superados por condução",
        LineBreakingCarries: "Número de conduções que quebraram uma ou mais linhas defensivas",
        LineBreakingCarriesMD: "Número de conduções que quebraram as linhas de meio-campo e defesa",
        LineBreakingCarriesM: "Número de conduções que quebraram a linha de meio-campo",
        LineBreakingCarriesD: "Número de conduções que quebraram a linha defensiva",
        LineBreakingCarriesPerCarry: "Percentual de conduções entre linhas por condução",
        LineBreakingActions: "Número de passes e conduções combinados que quebraram uma ou mais linhas defensivas",
        LineBreakingActionsMD: "Número de passes e conduções combinados que quebraram as linhas de meio-campo e defesa",
        LineBreakingActionsM: "Número de passes e conduções combinados que quebraram a linha de meio-campo",
        LineBreakingActionsD: "Número de passes e conduções combinados que quebraram a linha defensiva",
        PassesPerLineBreakingPass: "Relação entre o número total de passes por passe entre linhas",
        CarriesPerLineBreakingCarry: "Relação entre o número total de conduções por condução entre linhas",
        LinesBrokenByPasses: "Número total de linhas quebradas por passes",
        LinesBrokenByCarries: "Número total de linhas quebradas por conduções",
        LinesBrokenByActions: "Número total de linhas quebradas por passes e conduções combinados",
        LinesBrokenPerPass: "Relação entre o número total de linhas quebradas por passe",
        LinesBrokenPerCarry: "Relação entre o número total de linhas quebradas por condução",
      },
      subtitles: {
        Possession: "Percentagem de posse de bola da equipa",
        TimePossession: 'Tempo de posse de bola da equipe',
        PassesPerShots: "Número médio de passes dado por remate",
        PPDA: "Passes Por Ação Defensiva",
        Directness: "Mede o quão direta é uma equipa",
        AerialWins: "Duelos aéreos ganhos por 90 minutos",
        AerialEfficiency: "Modelo que combina duelos aéreos ganhos com duelos aéreos totais por 90 minutos",
        AerialWinsPct: "Percentagem de duelos aéreos ganhos",
        Assists: "Assistências por 90 minutos",
        BallProgression: "Progressão através do passe ou condução da bola pelo menos 10 metros por 90 minutos",
        Catching: "Percentagem de paragens presas",
        ChancesCreated: "Número de passes que precede a remate por 90 minutos",
        ClaimAccuracy: "Eficiência na abordagem dos centros de entrada",
        CompletedCrosses: "Número de cruzamentos concluídos por 90 minutos",
        Crossing: "Percentagem de cruzamentos bem-sucedidos",
        Dispossessed: "Perdas de bola por 90 minutos",
        Finishing: "Percentagem De remates que acabam em golo",
        xGEfficiency: "Quantity of expected goals needed for a player to score a goal",
        Fouls: "Número de faltas cometidas pelo jogador por 90 minutos",
        FoulsTaken: 'Faltas tomadas por 90 minutos',
        IndividualPressure: "Número de pressão bem-sucedida por 90 minutos",
        Interceptions: "Interceções por 90 minutos",
        LongBallPct: "Percentagem de passes completos de pelo menos 32 metros",
        LongBallSuccessful: "Número de passes completos acima de 32 metros",
        Goals: "Number of goals scored per 90 minutes of play",
        NonPenaltyGoals: "Golos (excluindo penaltis) por 90 minutos",
        NPGOpenPlay: "Número de golos marcados por 90 minutos durante o jogo aberto, excluindo os golos de penálti",
        NPGSetPiece: "Número de golos marcados por 90 minutos durante bola parada, excluindo os golos de penálti",
        OpenPlayKeyPasses: "Passes que acabam em remate (excluindo assistências) em jogo durante 90 minutos",
        OpenPlayKeyPassesInTeam: 'Percentagem de passes que acabam em remate (excluindo assistências) em jogo em Equipa',
        PassingFinalThird: "Passes bem-sucedidos no último terço por 90 minutos",
        PassingFinalThirdPct: "Passes bem-sucedidos no último terço",
        PassingOppHalfPct: "Percentagem de passes bem-sucedidos para o meio-campo ofensivo",
        PassingOwnHalfPct: "Percentagem de passes bem-sucedidos para o meio-campo defensivo",
        PassingPct: "Percentagem de passes bem-sucedidos",
        Recoveries: "Número de bolas recuperadas por um jogador por 90 minutos",
        SavesInBoxPct: "Percentagem de remates dentro da área por 90 minutos",
        SavesOutOfBoxPct: "Percentagem de remates fora da área por 90 minutos",
        SavesPct: "Percentagem de defesas ",
        ScoringContribution: "Numero de assistências e golos por 90 minutos",
        xAssistsOpenPlay: "Número de assistências esperadas durante o jogo aberto por 90 minutos",
        xAssistsSetPiece: "Número de assistências esperadas durante o jogo definido por 90 minutos",
        xAssistsOpenPlayInTeam: 'Número de assistências esperadas durante o jogo aberto em Equipa',
        xAssistsSetPieceInTeam: 'Número de assistências esperadas durante o jogo definido em Equipa',
        xGChainFinalThird: "Quantidade de xG um jogador participou no terço final",
        xGBuildupFinalThird: "Quantidade de xG um jogador participou no terço final (excluindo remates e passes antes de um remate)",
        BallProgressionPassing: "Vezes que o jogador avança a bola 10 metros ou mais ao passar a bola",
        BallProgressionDribbling: "Vezes que o jogador avança a bola a 10 metros ou mais conduzindo a bola",
        Shooting: "Percentagem de remates (excluídos penaltis) enquadrados com a baliza",
        Shots: "Número de remates por 90 minutos",
        ShotsPerGoal: "Média de remates concretizados para marcar golo",
        ShortPassesSuccessful: "Número de passes curtos (menos de 12 metros) concluídos por 90 minutos",
        PassingSuccessForwardPct: "Percentagem de passes bem-sucedidos na direção da frente",
        PassingSuccessBackwardPct: "Percentagem de passes bem-sucedidos para trás",
        PassingForwardBackwardPct: "Relação de passes na direção dianteira contra passes para trás",
        LongBallPerPassesPct: "Percentagem de passes longos concluídos (>32 metros) de todos os passes concluídos pelo jogador.",
        LongBallReceived: "Número de passes longos (>32 metros) recebidos pelo jogo",
        LongBallReceivedOppHalf: "Número de passes longos (>32 metros) recebidos pelo jogado na metade do adversário",
        DribblesAttempted: "Número de dribles tentados por 90 minutos",
        SuccessfulDribblesPct: "Dribles/total de tentativas de dribles com sucesso",
        SuccessfulDribbles: "Fintas bem-sucedidas por 90 minutos",
        TacklesSuccessful: "Número de cortes feitos pelo jogador por 90 minutos",
        TacklesWasDribbled: "Percentagem de duelos ganhos através do corte",
        ThroughBalls: "Numero de passes que quebram linhas defensivas por 90 minutos",
        TouchesInOpponentBox: "Numero de receções de bola na área adversária por 90 minutos",
        xAssists: "Assistências expectáveis geradas por 90 minutos",
        xG: "Golos expectáveis gerados",
        xGBuildup: "Envolvimento em xG construídos por 90 minutos",
        xGBuildupInTeam: 'xG Construção in Team',
        xGChain: "Envolvimento em xG Cadeia por 90 minutes",
        xGPerNPG: "Média xG por golos sem ser penâltis",
        xGPerShot: "Média xG por remate",
        xGSavedPerShot: "Média xG defendido por remate sofrido",
        xGSavedPerXGFacedOnTarget: "Média xG defendido por xG enquadrado na baliza",
        xGFacedOnTargetPerGoalReceived: "Golos Esperados são necessários para marcar um golo a um certo Guarda-Redes",
        xGFacedOnTargetEfficiency: "Número de golos de não-penálti impedidos pelo Guarda-redes por 90 minutos",
        xGFacedOnTarget: "Total xG (guardado e marcado) enfrentado pelo guarda-redes por 90 minutos",
        HighTurnovers: "Rotatividade a menos de 40 metros da própria baliza",
        OpenPlayPassesIntoOpponentBox: "Jogo aberto totais passa pelo jogador para a caixa adversária por 90",
        OpenPlayPassesIntoOpponentBoxSuccessful: "Jogo aberto concluído passa pelo jogador para a caixa adversária por 90",
        DeepProgressionFinalThird: "Vezes em que o jogador tem a posse no terço final por 90 minutos",
        ChancesCreatedOP: "Número de passes em jogo que precede a remate por 90 minutos",
        PenaltiesTaken: "Número de vezes que o jogador foi derrubado na área do adversário por 90 minutos",
        BlockedCrosses: "Número de cruzamentos bloqueados pelo jogador por 90 minutos",
        BlockedShots: "Número de remates bloqueados pelo jogador por 90 minutos",
        NonPenaltyGoalsAgainst: "Número de golos não penálti sofridos por 90 minutos",
        Headers: "Cabeceamentos",
        AveragePassDistance: "Distância média do passe",
        ProgressiveRuns: "Corridas Progressivas",
        xT: "Perigo Gerado através de movimentos de bola para zonas perigosas por 90 minutos",
        xGOT: "Golos esperados no alvo. Número de golos esperados enfrentados pelo Guarda-redes. Esta métrica só tem em conta os remates no alvo (remates falhados e remates no poste são excluídos)",
        BadActions: "Más Ações",
        BadActionsOwnHalf: "Más Ações na Metade",
        AerialsWonOwnBox: "Duelos Aéreos Ganados en Área Propia",
        AerialsWonOppBox: "Aerials Won Opp Box",
        AerialsTotalOppBox: "Aerials Total Opp Box",
        AerialsTotalOwnBox: "Aerials Total Own Box",
        FoulsOwnHalfPct: "% Faltas en Campo Propio",
        RecoveriesOppHalf: "Número de bolas recuperadas por um jogador em metade offensiva por 90 minutos",
        DuelsPct: "% Duelos Existosos",
        TacklesWasDribbledFirstThird: "Tackles/Fue regateado en el último tercio",
        TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
        TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
        BallProgressionFinalThird: "Progresiones de Balón en el Último tercio",
        DuelsTotal: "Número total de desarmes, jogadas aéreas, toques de bola, dribles e faltas cometidas por 90 minutos",
        QuickRecoveries: "Recuperaciones a 40 metros o más de la propia portería en los siguientes 5 segundos después de pérdida",
        ShotsPerNPG: "Número de Remates por Gol sin Penaltis",
        ShotsOutBox: "Remates desde Fuera del Área por 90 minutos",
        GoalsOutBox: "Goles desde Fuera del Área por 90 minutos",
        ShootingOutBox: "Percentagem de Remates a Puerta  de tiros desde Fuera del Área",
        HandPassing: "Percentagem de Pases completados con la Mano",
        ShotEndingHighTurnovers: "Rotatividade elevada (rotatividade a menos de 40 metros da própria baliza) que acabam num remate da equipa adversária",
        GoalEndingHighTurnovers: "Altas rotatividades (rotatividade a menos de 40 metros da própria baliza) que acabam num golo da equipa adversária",
        AverageCarriesProgress: "Distância média que um jogador move a bola verticalmente por transporte (metros)",
        ChanceEndingCarries: "Carrega pelo menos 7 metros que acabam num passe que se segue a um tiro",
        AssistEndingCarries: "Carrega pelo menos 7 metros que acabam num passe que se segue a um golo",
        ShotEndingCarries: "Carrega pelo menos 7 metros que acabam num remate",
        GoalEndingCarries: "Carrega pelo menos 7 metros que acabam numa baliza",
        ShotEndingSequence: "Número de Sequências terminando em remate onde o jogador esteve envolvido",
        GoalEndingSequence: "Número de Sequências terminando em golo onde o jogador esteve envolvido",
        xTOpenPlay: "Ameaça esperada gerada durante o jogo aberto por 90 minutos",
        xTSetPiece: "Ameaça esperada gerada durante o bola parada por 90 minutos",
        xGSetPiece: "xG bola parada",
        AerialWonOffensive: "Ofensiva aérea ganha por 90 minutos",
        AerialWonDefensive: "Defensiva aérea ganha por 90 minutos",
        xGAgainst: "xG Recebido",
        xGDiffAgainst: "xG Diff Recebido",
        xGPerNPGAgainst: "xG por NPG Recebido",
        xGOpenPlayAgainst: "xG jogo aberto recebido por 90 minutos",
        xGSetPieceAgainst: "xG Bola Parada recebidos por 90 minutos",
        xGPerShotAgainst: "xG por remate recebido",
        ShotsAgainst: "Remates recebidos",
        RivalPossession: "Posse Rival",
        AerialDefensivePct: "% Defensivo aéreo",
        HighRecoveries: "Altas Recuperações",
        HighDefensiveActionPct: "Percentagem de Acções Defensivas (Tackles, Intercepções, Blocos, Faltas e 1vs1) feitas a 40 metros acima da própria linha de base",
        HighDefensiveDistance: "Distância média do próprio objectivo de todas as acções defensivas",
        PassesPerPossession: "Passes por Posse",
        LengthPerPossession: "Distância por Posse",
        xTNet: "Ameaça Esperada Líquida",
        AvgCarriesDistance: "média condução distância",
        PassesForwardPct: "% Passes Vão para a frente",
        TacklesAttempted: "Cortes Tentadas",
        DuelsLost: "Duelos perdidos",
        Carries: "Condução",
        CarriesPct: "% Condução",
        Aerials: "Aéreos",
        ProgressivePassesReceivedIntoBox: "Passes Progressivos Recebidos na área",
        PassesOppHalf: "Passes Opp. Half",
        ShotsOnTarget:"Remates no alvo",
        AggressiveActions: "Acções Agressivas",
        Crosses:"Cruzamentos",
        xGBuildup5pass: "xG em que um jogador participou, apenas os últimos 5 passes (excluindo tiros e passes)",
        DefensiveDistance: "Distância média até à meta própria dos duelos defensivos realizados",
        SpeedSequence: "Velocidade média (metros cobertos pelo tempo gasto) de todos os pertences de uma equipa",
        Touches: "Toques",
        AerialsTotalOppHalf: "Total Aéreos Metade Adversária",
        AerialsOppHalf: "Aéreos Ganhos Metade Adversária",
        AerialsWonOppHalfPct: "% Aéreos Ganhos Metade Adversária",
        AerialsPctOppBox: "Percentagem de duels aéreos ganhos área adversária",
        AerialsPctOwnBox: "Percentagem de duels aéreos ganhos dentro da área",
        AerialDefensive: "Número total de duelos aéreos quando a própria equipa tem a posse de bola",
        AerialOffensive: "Número total de duelos aéreos quando a equipa adversária tem a posse de bola",
        AerialOffensivePct: "Percentagem de duelos aéreos ganhos quando a própria equipa tem a posse de bola",
        IndividualPressureOppHalf: "Posse recuperada por um jogador quando pressiona o adversário na metade adversária",
        TouchesPerShot: "Toques por Remate",
        PassesFinalThirdTotalPct: "Percentagem de passes no último ⅓",
        xACrosses: "xA from cruzamentos",
        Passes: "Passes",
        PassesSuccessful: "Passes com sucesso",
        TacklesWasDribbledFouls: "Percentagem de golpes ganhos como percentagem do total de golpes e faltas cometidas",
        OffsidesCaught: "Fora de Jogo",
        ProgressivePassesReceivedFinalThird: "Passes Progressivos Recebidos Último ⅓",
        ProgressivePassesReceived: "Passes Progressivos Recebidos",
        Breadth: "Soma de Tackles, Desafios, Intercepções e Faltas cometidas, nos lados do campo",
        DuelsDefTotal: "Soma do total de golpes, duelos aéreos defensivos e faltas cometidas",
        DefensiveActions: "Acções defensivas quando um oponente tenta driblar (Tackles, Desafios e Faltas)",
        ProgressivePassesReceivedOppHalf: "Passes Progressivos Recebidos Metade Adversária",
        CompletedCrossesOP: "Número de cruzamentos concluídos em jogo aberto por 90 minutos",
        CrossingOP: "Percentagem de cruzes completadas de todas as cruzes tentadas em jogo aberto",
        CrossingPerXG: "Percentagem de golos Esperados vindos de cruzamentos",
        PassesPerLongBall: "Percentagem de passes longos bem-sucedidos do número total de passes concluídos",
        PassingContribution: "Percentagem que mede a ameaça de passes tendo em conta a posição do receptor",
        BallProgressionOppHalfInTeam: "% Progressão da bola na metade adversária em equipa",
        PassesOPIntoBoxInTeam: "% Passes Jogo Aberto na Área em Equipa",
        TouchesOppBoxInTeam: "% Toques Área Adversária em Equipa",
        xGOPInTeam: "% xG Jogo Aberto em Equipa",
        DeepPasses: "Passa de fora de um raio de 20 metros da baliza adversária que termina dentro daquela área",
        DefensiveDuelsPct: "Percentagem de duelos defensivos ganhos em relação ao total de duelos defensivos",
        QuickRecoveriesPct: "Percentagem de recuperações rápidas para intercepções e tentativas de abordagem",
        DiffDefensiveDistanceTeam: "Diferença entre a distância defensiva do jogador e a distância defensiva da sua equipa",
        xTPassing: "Ameaça esperada gerada apenas a partir de passes",
        xTPassing100Passes: "Ameaça esperada gerada apenas a partir de passes e por 100 passes",
        ProgressivePassesAccurate: "Passes completados de 10 metros ou mais no eixo X",
        PassAbility: "Relação de passes concluídos em relação aos passes esperados (xP)",
        OPPassesIntoOppBoxPct: "Percentagem de jogo aberto concluído passa para a caixa adversária e o jogo aberto tenta passar para a área adversária",
        EntriesOppBox: "Número de passes e carrega para a área adversária",
        Crosses6yardBox: "Número total de cruzes que terminam na área pequeña",
        Cutbacks: "Passar da linha de base para trás e dentro da área adversária",
        xTDribbling: "Ameaça esperada gerada apenas por dribbles",
        AvgShotDistance: "Distância média do número total de tiros",
        xGOnTarget: "Golos esperados dos tiros feitos no alvo",
        FinishingxGOT: "Percentagem de remates no alvo terminando num golo",
        DribblesWonOwnHalf: "Número de dribbles bem sucedidos feitos na própria metade",
        DribblesOwnHalf: "Número de tentativas de dribbles feitas na própria metade",
        DribblesOwnHalfPct: "Percentagem de dribbles bem sucedidos e tentativas de dribbles feitos na própria metade",
        DribblesWonOppHalf: "Número de dribbles bem sucedidos feitos na metade adversária",
        DribblesOppHalf: "Número de tentativas de dribbles feitos na metade adversária",
        DribblesOppHalfPct: "Percentagem de dribbles bem sucedidos e tentativas de dribbles feitos na metade adversária",
        DribblesWonFinalThird: "Número de dribbles bem sucedidos feitos no terço final",
        DribblesFinalThird: "Número de tentativas de dribbles feitas no terço final",
        DribblesFinalThirdPct: "Percentagem de dribbles bem sucedidos e tentativas de dribbles feitos no terço final",
        ShotEndingHighRecoveries: "Recuperações altas (feitas a 40 metros ou menos do gol adversário) que terminam em finalização",
        PassingFinalThirdAgainst: "Passes bem-sucedidos do adversário para o terço final",
        OpenPlayPassesIntoOpponentBoxAgainst: "Número total de passes do adversário para dentro da nossa área em jogo corrido",
        EntriesOppBoxAgainst: "Número de passes e conduções do adversário para dentro da nossa área",
        DeepProgressionAgainst: "Número de vezes que o adversário chega ao último quinto do campo com a bola, mais a posse no nosso primeiro quinto",
        TouchesInOpponentBoxAgainst: "Número de vezes que o adversário teve a posse na nossa área",
        Score: 'Desempenho do jogador com base em diferentes métricas',
        PDScore: 'Desempenho físico do jogador com base em diferentes métricas físicas',
        OrlegiScore: "Desempenho do jogador com base em diferentes métricas",
        SirScore: "Desempenho do jogador com base em diferentes métricas",
        xTOPInTeam: "Perigo esperado (xT) gerado no jogo em relação ao total da sua equipa",
        YellowCards: "Yellow Cards",
        RedCards: "Red Cards",
        xTOpenPlayAgainst: "Ameaça esperada concedida durante jogo aberto por 90 minutos de jogo",
        xTSetPieceAgainst: "Ameaça esperada concedida durante o bola parada por 90 minutos de jogo",
        NPGOpenPlayAgainst: "GSP Jogo Aberto Recebido",
        NPGSetPieceAgainst: "GSP Bola Parada Recebido",
        PassesOppHalfPerPossession: "Passes Metade Adversária por Posse",
        AverageTimeRecovery: "Tempo Médio de Recuperação",
        ExpectedPassing: "Porcentagem de passes que deveriam ter sido concluídos",
        NumPossession10Passes: "Posse 10 Passes",
        PassesReceived: "Passes Recebidos",
        PassesReceivedFinalThird: "Passes Recebidos Final ⅓",
        ProgressivePassesTotalPct: "% de Passes Progressivos",
        ShortPassesPct: '% Passes Curtos',
        //Physical Stats
        TotalDistance: "Total Distance",
        HsrDistance: "Sprints Distance >19.8 km/h",
        HsrNumber: "Sprints Quantity >19.8 km/h",
        HsrDistancePct: "% HSR Distance",
        SprintsNumber: "Sprints Quantity >25.2 km/h",
        SprintsDistance: "Sprints Distance >25.2 km/h",
        SprintNumberDeclinePct: "% Sprint Quantity Decline",
        SprintDistanceDeclinePct: "% Sprint Distance Decline",
        SprintDistancePct: "% Sprint Distance",
        Accelerations: "Accelerations Quantity",
        MaxSpeed: "Max. Speed",
        AvgMaxSpeed: "Velocidade máxima média alcançada pelo jogador",
        MaxAccelerations: "Aceleração máxima em metros/segundo² alcançada pelo jogador",
        BypassedPlayersByPasses: "Número de jogadores no lado do golo do portador da bola no início do evento de toque, menos o número de jogadores no lado do golo no final do evento",
        BypassedDefendersByPasses: "Número de defesas no lado do golo do portador da bola no início do evento de toque, menos o número de defesas no lado do golo no final do evento",
        PassesBypassingPlayers: "Número de passes que ultrapassaram jogadores",
        PassesBypassingDefenders: "Número de passes que ultrapassaram defesas",
        BypassedPlayersPerPass: "Número total de jogadores ultrapassados por passe",
        BypassedDefendersPerPass: "Número total de defesas ultrapassados por passe",
        LineBreakingPasses: "Passes completos que avançam a bola pelo menos 10% mais próximo do golo adversário e cruzam uma dupla de defesas em proximidade ou passam atrás da linha defensiva",
        LineBreakingPassesMD: "Número de passes linha-quebra dos defesas para meio-campistas",
        LineBreakingPassesM: "",
        LineBreakingThroughBalls: "Passes em profundidade que quebram linhas",
        LineBreakingPassesPerPass: "Número de linhas quebradas por passe",
        TotalPassesUnderStrongPressure: "Número total de passes realizados sob forte pressão (a 0-2 metros do adversário mais próximo)",
        TotalPassesUnderLightPressure: "Número total de passes realizados sob pressão (a 2-4 metros do adversário mais próximo)",
        SuccessfulPassesUnderStrongPressure: "Número de passes bem-sucedidos sob forte pressão (a 0-2 metros do adversário mais próximo)",
        SuccessfulPassesUnderLightPressure: "Número de passes bem-sucedidos sob pressão (a 2-4 metros do adversário mais próximo)",
        PassingUnderStrongPressure: "Percentagem de passes bem-sucedidos e totais realizados sob forte pressão (a 0-2 metros do adversário mais próximo)",
        PassingUnderLightPressure: "Percentagem de passes bem-sucedidos e totais realizados sob pressão (a 2-4 metros do adversário mais próximo)",
        PassReceiptsInSpaceCompleted: "Passes realizados onde o receptor está na metade ofensiva sem defesas num raio de 5 metros na direção do golo",
        PassReceiptsInSpace: "Passes recebidos na metade ofensiva sem defesas num raio de 5 metros na direção do golo",
        TotalStrongOnBallPressures: "Número de pressões fortes sobre o portador da bola (a 0-2 metros)",
        TotalLightOnBallPressures: "Número de pressões sobre o portador da bola (a 2-4 metros)",
        SuccessfulStrongOnBallPressures: "Número de pressões fortes bem-sucedidas sobre o portador da bola (a 0-2 metros)",
        SuccessfulLightOnBallPressures: "Número de pressões bem-sucedidas sobre o portador da bola (a 2-4 metros)",
        StrongOnBallPressuresPct: "Percentagem de pressões fortes bem-sucedidas e totais sobre o portador da bola (a 0-2 metros)",
        LightOnBallPressuresPct: "Percentagem de pressões bem-sucedidas e totais sobre o portador da bola (a 2-4 metros)",
        TimesBypassedByPasses: "Número total de vezes superado por passe",
        TimesBypassedByCarries: "Número total de vezes superado por condução",
        TimesBypassedByActions: "Número total de vezes superado por passes e conduções combinados",
        BypassedPlayersByCarries: "Número total de adversários (defensores e meio-campistas) superados por conduções",
        BypassedDefendersByCarries: "Número total de adversários (defensores) superados por conduções",
        BypassedPlayersByActions: "Número total de adversários (defensores e meio-campistas) superados por passes e conduções combinados",
        BypassedDefendersByActions: "Número total de adversários (defensores) superados por passes e conduções combinados",
        CarriesBypassingPlayers: "Número de conduções que superaram jogadores",
        CarriesBypassingDefenders: "Número de conduções que superaram defensores",
        BypassedPlayersPerCarry: "Média de adversários superados por condução",
        BypassedDefendersPerCarry: "Média de defensores superados por condução",
        LineBreakingCarries: "Número de conduções que quebraram uma ou mais linhas defensivas",
        LineBreakingCarriesMD: "Número de conduções que quebraram as linhas de meio-campo e defesa",
        LineBreakingCarriesM: "Número de conduções que quebraram a linha de meio-campo",
        LineBreakingCarriesD: "Número de conduções que quebraram a linha defensiva",
        LineBreakingCarriesPerCarry: "Percentual de conduções entre linhas por condução",
        LineBreakingActions: "Número de passes e conduções combinados que quebraram uma ou mais linhas defensivas",
        LineBreakingActionsMD: "Número de passes e conduções combinados que quebraram as linhas de meio-campo e defesa",
        LineBreakingActionsM: "Número de passes e conduções combinados que quebraram a linha de meio-campo",
        LineBreakingActionsD: "Número de passes e conduções combinados que quebraram a linha defensiva",
        PassesPerLineBreakingPass: "Relação entre o número total de passes por passe entre linhas",
        CarriesPerLineBreakingCarry: "Relação entre o número total de conduções por condução entre linhas",
        LinesBrokenByPasses: "Número total de linhas quebradas por passes",
        LinesBrokenByCarries: "Número total de linhas quebradas por conduções",
        LinesBrokenByActions: "Número total de linhas quebradas por passes e conduções combinados",
        LinesBrokenPerPass: "Relação entre o número total de linhas quebradas por passe",
        LinesBrokenPerCarry: "Relação entre o número total de linhas quebradas por condução",
      },
      abbr:{
        Possession: "POS%",
        TimePossession: "TP",
        PassesPerShots: "PPS",
        PPDA: "PPDA",
        ExpectedPoints: "xP",
        Points: "P",
        Directness: "DIR",
        PassesPerLongBall: "PPLB",
        CrossingPerXG: "CPxG",
        PenaltySavedPenaltyFaced: "PSPF",
        Goals: "GOA",
        NonPenaltyGoals: "NPG",
        NPGOpenPlay: "NPGOP",
        NPGSetPiece: "NPGSP",
        Shooting: "SHO%",
        Finishing: "FIN%",
        xGEfficiency: "xGE",
        HeaderPerShot: "HPS",
        HeaderPerCross: "HPC",
        Assists: "ASS",
        ThroughBalls: "TB",
        CrossEfficiency: "CE",
        ScoringContribution: "SC",
        xAssistsOpenPlay: "xAOP",
        xAssistsSetPiece: "xASP",
        xAssistsOpenPlayInTeam: "xAOPiT",
        xAssistsSetPieceInTeam: "xASPiT",
        xGBuildupFinalThird: "xGBUPFT",
        xGChainFinalThird: "xGCFT",
        BallProgressionPassing: "BPP",
        BallProgressionDribbling: "BPD",
        TacklesWasDribbled: "TWD%",
        TacklesSuccessful: "STA",
        Interceptions: "INT",
        Clearances: "CLE",
        Fouls: "FOU",
        Recoveries: "REC",
        Shots: "SHO",
        ShotsPerGoal: "SPG",
        ShortPassesSuccessful: "SPS",
        PassingSuccessForwardPct: "PSF%",
        PassingSuccessBackwardPct: "PSB%",
        PassingForwardBackwardPct: "PFB%",
        LongBallPerPassesPct: "LBP%",
        LongBallReceived: "LBR",
        LongBallReceivedOppHalf: "LBROH",
        OffensiveActions: "OA",
        DribblesAttempted: "DAT",
        SuccessfulDribblesPct: "SD%",
        OffensiveTouchesOutBoxPct: "OTOB%",
        BallRetention: "BR",
        PassingPct: "PA%",
        PassingOwnHalfPct: "POH%",
        PassingOppHalfPct: "POPH%",
        PassingFinalThird: "PFT",
        PassingFinalThirdPct: "PT%",
        LongBallSuccessful: "LBS",
        LongBallPct: "LB%",
        SavesPct: "S%",
        SavesInBoxPct: "SIB%",
        SavesOutOfBoxPct: "SOOB%",
        xGSavedPerXGFacedOnTarget: "xGSPFOT",
        xGFacedOnTargetPerGoalReceived: "xGFOTPGR",
        xGFacedOnTargetEfficiency: "xGFOTE",
        xGFacedOnTarget: "xGFOT",
        IndividualPressure: "IP",
        AerialEfficiency: "AE",
        AerialWins: "AEW",
        AerialWinsPct: "AE%",
        xG: "xG",
        xGDiff: "xGD",
        xGOpenPlay: "xGOP",
        xGSetPiece: "xGSP",
        xGPerShot: "xGPS",
        ChancesCreated: "CC",
        CompletedCrosses:"SCR",
        Crossing: "CR%",
        OpenPlayKeyPasses: "OPKP",
        OpenPlayKeyPassesInTeam: "OPKPiT%",
        OpenPlayPassesIntoOpponentBox: "OPPOPPB",
        OpenPlayPassesIntoOpponentBoxSuccessful: "OPPOPPBS",
        xAssists: "xA",
        xGChain: "xGC",
        xGBuildup: "xGBUP",
        xGBuildupInTeam: "xGBUPiT",
        BallProgression: "BP",
        SuccessfulDribbles: "SDR",
        Dispossessed: "TOV",
        TouchesInOpponentBox: "TOB",
        xGSavedPerShot: "xGSS",
        BallRetentionOppHalf: "BROPPH",
        DeepProgression: "DP",
        DeepProgressionFinalThird: "DPFT",
        FoulsTaken: "FOUR",
        PenaltiesTaken: "PT",
        BlockedCrosses: "BC",
        BlockedShots: "BS",
        Blocks: "BLO",
        NonPenaltyGoalsAgainst: "NPGC",
        Headers: "HEA",
        AveragePassDistance: "APD",
        ProgressiveRuns: "PRC",
        xT: "xT",
        xTOpenPlay: "xTOP",
        xTSetPiece: "xTSP",
        xGOT: "xGOT",
        BadActions: "BA",
        BadActionsOwnHalf: "BAOH",
        AerialsWonOwnBox: "AWOB",
        AerialsWonOppBox: "AWOPPB",
        AerialsTotalOppBox: "ATOPPB",
        AerialsTotalOwnBox: "ATOB",
        FoulsOwnHalfPct: "FOH%",
        RecoveriesOppHalf: "ROH",
        DuelsPct: "D%",
        TacklesUnsuccessful: "UTA",
        LongBallSuccessful: "SLB",
        TacklesWasDribbledFirstThird: "TWDFT",
        TacklesWasDribbledSecondThird: "TWDST",
        TacklesWasDribbledFinalThird: "TWDFT",
        BallProgressionFinalThird: "BPFT",
        DuelsTotal: "DT",
        QuickRecoveries: "QR",
        ShotsPerNPG: "SPNPG",
        ShotsOutBox: "SOB",
        GoalsOutBox: "GOB",
        ShootingOutBox: "SOB%",
        HandPassing: "HP",
        Catching: "CAT",
        ClaimAccuracy: "CA",
        HighTurnovers: "HTOV",
        ShotEndingHighTurnovers: "SEHT",
        GoalEndingHighTurnovers: "GEHT",
        AverageCarriesProgress: "ACP",
        ChanceEndingCarries: "CEC",
        AssistEndingCarries: "AEC",
        ShotEndingCarries: "SEC",
        GoalEndingCarries: "GEC",
        ShotEndingSequence: "SES",
        GoalEndingSequence: "GES",
        xGPerNPG: "xGPNPG",
        AerialWonOffensive: "AWO",
        AerialWonDefensive: "AWD",
        xGAgainst: "xGC",
        xGDiffAgainst: "xGDC",
        xGPerNPGAgainst: "xGPNPGA",
        xGOpenPlayAgainst: "xGOPC",
        xGSetPieceAgainst: "xGSPC",
        xGPerShotAgainst: "xGSC",
        ShotsAgainst: "STC",
        ShotsOnTargetAgainst: "SOTC",
        RivalPossession: "RP",
        AerialDefensivePct: "AD%",
        HighRecoveries: "HR",
        HighDefensiveActionPct: "HDA%",
        HighDefensiveDistance: "HDD",
        PassesPerPossession: "PPP",
        LengthPerPossession: "LPP",
        xTNet: "xTN",
        AvgCarriesDistance: "ACD",
        PassesForwardPct: "PF%",
        TacklesAttempted: "ATA",
        DuelsLost: "DL",
        Carries: "CARR",
        CarriesPct: "CARR%",
        Aerials: "AER",
        ProgressivePassesReceivedIntoBox: "PPRIB",
        PassesOppHalf: "POPH",
        ShotsOnTarget: "SOT",
        AggressiveActions: "AA",
        Crosses: "CRO",
        xGBuildup5pass: "xGBUP5",
        DefensiveDistance: "DD",
        SpeedSequence: "SS",
        Touches: "TOU",
        AerialsTotalOppHalf: "ATOPPH",
        AerialsOppHalf: "AOPPH",
        AerialsWonOppHalfPct: "AWOH%",
        AerialsPctOppBox: "AOPPB%",
        AerialsPctOwnBox: "AOB%",
        AerialDefensive: "AD",
        AerialOffensive: "AO",
        AerialOffensivePct: "AO%",
        IndividualPressureOppHalf: "IPOPPH",
        ChancesCreatedOP: "CCOP",
        TouchesPerShot: "TPS",
        PassesFinalThirdTotalPct: "PFT%",
        xACrosses: "xAC",
        Passes: "PAS",
        PassesSuccessful: "SPA",
        TacklesWasDribbledFouls: "TWDF",
        OffsidesCaught: "OC",
        ProgressivePassesReceivedFinalThird: "PPRFT",
        ProgressivePassesReceived: "PPR",
        Breadth: "BRD",
        DuelsDefTotal: "DDT",
        DefensiveActions: "DA",
        ProgressivePassesReceivedOppHalf: "PPROH",
        CompletedCrossesOP: "CCOP",
        CrossingOP: "COP",
        PassingContribution: "PC",
        BallProgressionOppHalfInTeam: "BPOPPHiT",
        PassesOPIntoBoxInTeam: "POBIT",
        TouchesOppBoxInTeam: "TOBIT",
        xGOPInTeam: "xGOPiT",
        DeepPasses: "DP",
        DefensiveDuelsPct: "DD%",
        DefensiveDistance: "DD",
        QuickRecoveriesPct: "QR%",
        DiffDefensiveDistanceTeam: "DDDT",
        xTPassing: "xTP",
        xTPassing100Passes: "xTP100",
        ProgressivePassesAccurate: "APP",
        xP: "xP",
        PassAbility: "PA",
        OPPassesIntoOppBoxPct: "OPPIOB%",
        EntriesOppBox: "EOPPB",
        Crosses6yardBox: "C6YB",
        Cutbacks: "CUT",
        xTDribbling: "xTD",
        AvgShotDistance: "ASD",
        xGOnTarget: "xGOT",
        FinishingxGOT: "FxGOT",
        DribblesWonOwnHalf: "DWOH",
        DribblesOwnHalf: "DOH",
        DribblesOwnHalfPct: "DOH%",
        DribblesWonOppHalf: "DWOPH",
        DribblesOppHalf: "DOPH",
        DribblesOppHalfPct: "DOPH%",
        DribblesWonFinalThird: "DWFT",
        DribblesFinalThird: "DFT",
        DribblesFinalThirdPct: "DFT%",
        ShotEndingHighRecoveries: "SEHR",
        PassingFinalThirdAgainst: "PFTC",
        OpenPlayPassesIntoOpponentBoxAgainst: "OPPOBC",
        EntriesOppBoxAgainst: "EOBC",
        DeepProgressionAgainst: "DPC",
        TouchesInOpponentBoxAgainst: "TOBC",
        Score: "SCO",
        PDScore: "SCO",
        OrlegiScore: "SCO",
        SirScore: "SCO",
        xTOPInTeam: "xTOPiT",
        YellowCards: "YC",
        RedCards: "RC",
        xTOpenPlayAgainst: "xTOPC",
        xTSetPieceAgainst: "xTSPC",
        NPGOpenPlayAgainst: "NPG OPC",
        NPGSetPieceAgainst: "NPG SPC",
        PassesOppHalfPerPossession: "POHP",
        AverageTimeRecovery: "ATR",
        ExpectedPassing: "xP%",
        NumPossession10Passes: "P10P",
        PassesReceived: "PR",
        PassesReceivedFinalThird: "PRLFT",
        ProgressivePassesTotalPct: "PP%",
        ShortPassesPct: "SP%",
        TotalDistance: "DST",
        WalkingDistance: "WLKD",
        JoggingDistance: "JOGD",
        RunningDistance: "RUND",
        ExtremeAccelerations: "XACC",
        NumberOfRuns: "RUNQ",
        HsrDistance: "HSRD",
        HsrNumber: "HSRQ",
        HsrDistancePct: "HSRD%",
        SprintsNumber: "SPRQ",
        SprintsDistance: "SPRD",
        SprintNumberDeclinePct: "SQD%",
        SprintDistanceDeclinePct: "SDD%",
        SprintDistancePct: "SPRD%",
        Accelerations: "ACC",
        MaxSpeed: "MS",
        AvgMaxSpeed: "AvgMS",
        MaxAccelerations: "MACC",
        BypassedPlayersByPasses: "ByPP",
        BypassedDefendersByPasses: "ByPD",
        PassesBypassingPlayers: "PByPP",
        PassesBypassingDefenders: "PByPD",
        BypassedPlayersPerPass: "ByPPPP",
        BypassedDefendersPerPass: "ByPDPP",
        LineBreakingPasses: "LBP",
        LineBreakingPassesMD: "LBPMD",
        LineBreakingPassesM: "LBPM",
        LineBreakingThroughBalls: "LBTB",
        LineBreakingPassesPerPass: "LBPP",
        TotalPassesUnderStrongPressure: "TPUSP",
        TotalPassesUnderLightPressure: "TPUP",
        SuccessfulPassesUnderStrongPressure: "SPUSP",
        SuccessfulPassesUnderLightPressure: "SPULP",
        PassingUnderStrongPressure: "PUSP%",
        PassingUnderLightPressure: "PULP%",
        PassReceiptsInSpaceCompleted: "PRMS",
        PassReceiptsInSpace: "PRS",
        TotalStrongOnBallPressures: "TSBP",
        TotalLightOnBallPressures: "TBP",
        SuccessfulStrongOnBallPressures: "SSBP",
        SuccessfulLightOnBallPressures: "SLBP",
        StrongOnBallPressuresPct: "SBP%",
        LightOnBallPressuresPct: "BP%",
        TimesBypassedByPasses: "ByPPAS",
        TimesBypassedByCarries: "ByPC",
        TimesBypassedByActions: "ByPA",
        BypassedPlayersByCarries: "ByPPC",
        BypassedDefendersByCarries: "ByPDC",
        BypassedPlayersByActions: "ByPPA",
        BypassedDefendersByActions: "ByPDA",
        CarriesBypassingPlayers: "CByPP",
        CarriesBypassingDefenders: "CByPD",
        BypassedPlayersPerCarry: "ByPPPC",
        BypassedDefendersPerCarry: "ByPDPC",
        LineBreakingCarries: "LBC",
        LineBreakingCarriesMD: "LBCMD",
        LineBreakingCarriesM: "LBCM",
        LineBreakingCarriesD: "LBCD",
        LineBreakingCarriesPerCarry: "LBCC%",
        LineBreakingActions: "LBA",
        LineBreakingActionsMD: "LBAMD",
        LineBreakingActionsM: "LBAM",
        LineBreakingActionsD: "LBAD",
        PassesPerLineBreakingPass: "PPLBP",
        CarriesPerLineBreakingCarry: "CPLBC",
        LinesBrokenByPasses: "LBByP",
        LinesBrokenByCarries: "LBByC",
        LinesBrokenByActions: "LBByA",
        LinesBrokenPerPass: "LBPP",
        LinesBrokenPerCarry: "LBPC",
      }
    },
    team: {
      title: "Ficha da equipa",
      subtitle: "Aprofundar as características e estatísticas da equipa",
      averageAge: "Idade média",
      transferBalance: "Saldo de Transferência",
      roster: "Plantel",
      transfers: "Transferências",
      trends: "Tendências",
      loans: "Empréstimos",
      loanFrom: "Empréstimo de",
      loanTo: "Empréstimo para",
      latestGames: "Últimos Jogos",
      latestXGames: "Últimos {0} partidos",
      playingFor: "Jogando para",
      overview: "Visão geral",
      visualization:"Visualização",
      location:"Localização",
      outcome:"Resultado",
      beeswarm: "Ranking",
      parentTeam: "Equipa Superior",
      childTeam: "Equipa De Jovens",
      preferredFormation: "Formações mais frequentes",
      viewType: "Tipo de visualização",
      overviewTab: {
        axisXTotal: "Total",
        axisXper90: "Por 90'",
        dataPerGameText: "Dados por jogo",
        season: "Estação",
        last: "Último",
        current: "Corrente",
        TeamStyle: "Estilo",
        TeamDefensive: "Defensivo",
        TeamOffensive: "Ofensivo",
        TeamCustom1: "Custom 1",
        TeamCustom2: "Custom 2",
        TeamCustom3: "Custom 3",
        TeamCustom4: "Custom 4",
        coach: "Treinador",
        groups: {
          Goals: {
            name: "Golos",
            desc: "Mostra golos de penálti e golos de não penalti (jogo aberto e bola parada."
          },
          Assists: {
            name: "Assistência",
            desc: "Jogadores com mais assistências (Jogo aberto e bola parada) esta temporada."
          },
          xG: {
            name: "Golos Esperados",
            desc: "Golos esperados em jogo aberto e bola parada, classificados descendo pelo total de xG gerados."
          },
          xA: {
            name: "Assistências Esperadas",
            desc: "Assistências esperadas em jogo aberto e bola parada."
          },
          Finishing: {
            name: "Finalização",
            desc: "Percentagem de remates que terminam num golo."
          },
          ScoringContribution: {
            name: "Contribuição golos",
            desc: "Número de Assistências e Golos da equipa."
          },
          xT: {
            name: "Ameaça Esperada",
            desc: "Ameaça esperada gerada a partir de jogo aberto, bola parada e xT negativo."
          },
        },
        stats: {
          openPlay: "Jogo Aberto",
          setPiece: "Bola Parada",
          negative: "Negativo",
          npg: "Golos sem Penaltis",
          goalsPenalty: "Golos de Penaltis",
          npgOpenPlay: "GSP Jogo Aberto",
          npgSetPiece: "GSP Bola Parada",
          assists: "Assistência",
          assistsOpenPlay: "Assistência Jogo Aberto",
          assistsSetPiece: "Assistência Bola Parada",
          xGOpenPlay: "xG Jogo Aberto",
          xGSetPiece: "xG Bola Parada",
          xAOpenPlay: "xA Jogo Aberto",
          xASetPiece: "xA Bola Parada ",
          nonPenaltyShots: "Remates sem Penaltis",
          penaltyShots: "Penalty Shots",
          xT: "Ameaça Esperada",
          xTOpenPlay: "xT Jogo Aberto",
          xTSetPiece: "xT Bola Parada ",
          xTNeg: "Negativo xT",
          totalFinishing: "Gols Marcados",
          nonPenaltyFinishing: "Non Penalty Gols Marcados",
          goalsPenaltyFinishing: "Penalty Gols Marcados",
          walkingDistance: "Caminhada",
          joggingDistance: "Trote",
          runningDistance: "Corrida",
          hsrDistance: "HSR",
          sprintsDistance: "Sprint",
          runningNumber: "Número de Corridas",
          hsrNumber: "Sprints HSR",
          sprintsNumber: "Número de Sprints",
          maxSpeed: "Velocidade Máxima",
          accelerations: "Acelerações",
          extremeAccelerations: "Acelerações extremas",
          maxAcceleration: "Aceleração máxima"
        },
      },
      teamAnalysis: "Análise da Equipa",
      agentView: {
        positions: {
          "gk": "GK",
          "leftFullback": "LT Esquerdo",
          "centralDefender": "Def. central",
          "rightFullback": "LT Direito ",
          "midfielder": "Médio",
          "attackingMidfielder": "Méd. atacante",
          "leftWinger": "Ala esquerdo",
          "rightWinger": "Ala direita",
          "fw": "FW"
        },
        groups: {
          "contractEnd": "Meses",
          "age": "Anos",
          "availability": "Disponibilidade"
        },
        placer: {
          legend: "Força baseada na idade, contrato, disponibilidade e desempenho"
        }
      },
      transfersTab: {
        valueMovements: "Valor dos movimentos",
        valueTransfers: "Valor das Transferências",
        valueLoans: "Valor dos Empréstimos",
        avgAgeMovements: " Idade média Movimentos ",
        avgAgeTransfers: " Idade média Transferências ",
        avgAgeLoans: "Idade media de empréstimos",
        operations: {
          buys: {
            "buy": "Comprar",
            "loan": "Empréstimo",
            "end of loan": "Fim do Empréstimo",
            "free transfer": "Grátis",
            "free": "Grátis",
            "loan transfer": "Empréstimo",
            "other": "Outros"
          },
          sells: {
            "buy": "Vender",
            "loan": "Empréstimo",
            "end of loan": "Fim do Empréstimo",
            "free transfer": "Grátis",
            "free": "Grátis",
            "loan transfer": "Empréstimo",
            "other": "Outros",
            "retired": "Retirado"
          }
        }
      },
      trendsTab: {
        streaks: "Streaks",
        wins: "Vitórias",
        cleanSheets: "Folhas Limpas",
        goalPeriods: "Períodos com Golos Marcados",
        concededGoalPeriods: "Períodos com Golos Sofridos",
        comebacks: "Remontadas",
        avgTime: "Promedio de Tiempo",
        kindOfGoals: "Tipos de Goles",
        percentWinning: "% Ganando",
        percentDrawing: "% Empatando",
        percentLosing: "% Perdiendo",
        totalOf: "Total de",
        minutes: "minutes",
        before: "Antes de",
        after: "Depois de",
        playedOn: "Jogado em",
        scored: "Marcado",
        conceded: "Concedido",
        ownGoals: "Golos Próprios",
        phasesOfGame: "Fases do Jogo",
        buildup: "Construção",
        midfieldProgression: "Progressão no meio-campo",
        attackOpposition: "Ataque ao adversário",
        attackingTransition: "Transição ofensiva",
        highPress: "Pressão alta",
        midBlock: "Bloco médio",
        lowBlock: "Bloco baixo",
        defensiveTransition: "Transição defensiva"
      },
      onOff: "Ligado/Desligado",
      dragUpTo5Players: "Arraste até 5 jogadores",
      selectUpTo5Players: "Selecione até 5 jogadores",
      onOffTab: {
        G90: "Golos 90",
        GA90: "Golos contra 90",
        diffG90: "Diferença de golos 90",
        XG90: "xG 90",
        XGA90: "xG Contra 90",
        diffXG90: "xG Diferença 90",
        playersOn: "Combo ON",
        playersOff: "Combo OFF",
        ground: "Terreno",
        playersOnThePitch: "Jogadores no campo",
        playersOffThePitch: "Jogadores fora do campo",
        attackTitle: "Ataque",
        attackSubTitle: "Estatísticas ofensivas",
        defenseTitle: "Defesa",
        defenseSubTitle: "Estatísticas defensivas",
        associationTitle: "Associação",
        associationSubTitle: "Estatísticas Associativas",
        comboOn: "Combo ativo",
        comboOff: "Qualquer outro",
        "diffGoals90": "G Diff 90",
        "goals90": "Golos sem Penaltis 90",
        "goalsAgainst90": "Golos sem Penaltis contra 90",
        "xgAgainstPer90": "xG Contra 90",
        "xgDiffPer90": "xG Diff 90",
        "xgPer90": "xG 90",
        "xt90": "xT 90",
        "shotsOnTarget90": "Remates no alvo 90",
        "touchesOppBox90": "Toques na área adversária 90",
        "shotsOnTargetAgainst90": "Remates no alvo contra 90",
        "ppda90": "PPDA 90",
        "xa90": "xA 90",
        "directness90": "Objetividade 90",
        "possession": "Posse %",
        "pctPasses": "Passes %",
        "pctPassesFinalThird": "Passes ultimo terço %",
        placeholder: "Comece por selecionar uma equipa",
        subtitle: "Otimize as métricas da equipa adicionando ou removendo jogadores da formação"
      },
      terms: {
        short: "Curto Prazo",
        mid: "Médio Prazo",
        long: "Longo prazo",
      },
      report: {
        title: 'Relatório da Equipa',
        selectedPeriod: 'Período Selecionado',
        stackedCharts: 'Gráficos Empilhados',
        generalData: 'Dados Gerais',
        scoringChances: 'Oportunidades de Golo',
        areasReport: 'Relatório de Áreas',
        setPieceReport: 'Relatório de Bolas Paradas',
        corners: 'Cantos',
        cornersAgainst: 'Cantos Contra',
        indirectFreeKicks: 'Livres Indiretos',
        indirectFreeKicksAgainst: 'Livres Indiretos Contra',
        freeKicks: 'Livres Diretos',
        freeKicksAgainst: 'Livres Diretos Contra',
        penaltys: 'Penáltis',
        freeKicksContribution: 'Contribuição dos Livres Diretos',
        shotsContribution: 'Contribuição dos Remates',
        topXPlayersByStats: 'Top {x} Jogadores por Estatísticas',
        lastShotZone: 'Última Zona de Remate',
        throwSide: 'Lado do Lançamento',
        kindOfThrow: 'Tipo de Lançamento',
        scored: 'Marcados',
        against: 'Sofridos',
        perGame: 'por Jogo',
        total: 'Total',
        efficiency: 'Eficiência',
        organizedAttack: 'Ataque Organizado',
        offTransition: 'Transição Ofensiva',
        chances: 'Oportunidades',
        chancesScored: 'Oportunidades Convertidas',
        chancesAgainst: 'Oportunidades Sofridas',
        goalsScored: 'Golos Marcados',
        goalsAgainst: 'Golos Sofridos',
        goalsOrganizedAttack: 'Golos Ataque Organizado',
        goalsOffTransition: 'Golos Transição Ofensiva',
        goalsSetPiece: 'Golos Bola Parada',
        goalsOrganizedAttackScored: 'Golos Atq. Org. Marcados',
        goalsOrganizedAttackAgainst: 'Golos Atq. Org. Sofridos',
        goalsOffTransitionScored: 'Golos Trans. Of. Marcados',
        goalsOffTransitionAgainst: 'Golos Trans. Of. Sofridos',
        goalsSetPieceScored: 'Golos Bola Parada Marcados',
        goalsSetPieceAgainst: 'Golos Bola Parada Sofridos',
        crossSide: 'Lado do Cruzamento',
        externalShot: 'Remate Externo',
        innerPlay: 'Jogo Interior',
        throwIn: 'Lançamento Lateral',
        box: 'Área',
        zone2: 'Zona 2',
        goalsPerPhases: 'Golos por Fases'
      },      
      minutesAlert: "*Mostrando apenas jogadores com 450 ou mais minutos jogados",
      minutesException: "Não há jogadores com 450 ou mais minutos jogados. Mostrando a todos os jogadores",
      analysis: "Analysis",
      substitutions:"Substitutions",
      attackZones:"Attack Zones",
      formations:"Formations",
      shotZones:"Shot Zones",
      crossings:"Crossings",
      byTime:"By Time",
      byPosition:"By Position",
      byPlayer:"By Player",
      W:"Winning",
      D:"Drawing",
      L:"Losing",
      substitutionsByGame:"Substitutions by game",
      substitutionsShort:"Subs.",
      avgSeasonShort:"Avg. Season",
      startingAt:"Starting at",
      endingAt:"Ending at",
      startingAtInfo: "Mostra a quota de posse baseada na localização do primeiro evento",
      endingAtInfo: "Mostra a quota de posse baseada na localização do último evento",
      endingWithShot:"Ending with shot",
      endingInBox:"Ending in box",
      pfX:"PF {x}",
      bySide: "By Side",
      cornerKicks:"Corner Kicks",
      included: "Included",
      excluded:"Excluded",
      onlyCorner:"Only Corner",
      sizeByMarketValue:"Size by Market Value",
      timeInTeam:"Épocas na Equipa",
      newSignings:"New Signings",
      sizeBy:"Size by",
      connections:"Connections",
      assistant:"Passer",
      finisher:"Finisher",
      playersMinutesAlert: "Mostrando apenas jogadores com minutos jogados na temporada selecionada"
    },
    leagueTable: {
      subtitle: "Verifique como vão as ligas."
    },
    leagueMatchdays: {
      byRound: "Por jornada",
      byDate: "Por data",
      byTeam: "Por equipa"
    },    
    teamStats: {
      subtitle: "Compare como as equipas estão a atuar",
      xGDiffPerGame: "xGD",
      xGDiffPerGameExplicit: "Difference between Expected Goals and Goals",
      expectedPointsDiff: "xPD",
      expectedPointsDiffExplicit: "Difference between Expected Points and Points",
      games: "GAM",
      gamesExplicit: "Games played",
      pointsPerGame: "PPG",
      pointsPerGameExplicit: "Points per Game",
    },
    roles: {
      "ROLE_USER": "Utilizador",
      "ROLE_ADMIN": "Administrador",
      "ROLE_REPORTS": "Driblab Reports",
      "ROLE_API": "Driblab API",
      "ROLE_PHYSICAL_DATA": "Dados físicos",
      "ROLE_VIDEO": "Capture",
      "ROLE_EVENTING_DATA": "Driblab XY",
      "ROLE_DRIBLAB_HUB": "Driblab Hub",
      "ROLE_TRACKING": "Tracking",
      "ROLE_ARRIGO": "Arrigo",
      "ROLE_API_description": "Extraia informações de jogadores, equipas, jogos e ligas sem esforço no formato JSON.",
      "ROLE_EVENTING_DATA_description": "Mergulhe fundo nas estatísticas com gráficos de radar, classificações de jogadores, mapas e muito mais com base em mais de 100 métricas de desempenho.",
      "ROLE_PHYSICAL_DATA_description": "Aceder aos dados de condição física e filtrar os jogadores por vários parâmetros de desempenho (distância, velocidade, sprints, aceleração...).",
      "ROLE_VIDEO_description": "Forneça vídeos e alinhamentos e obtenha jogos marcados com eventos e estatísticas para uma análise aprofundada.",
      "ROLE_DRIBLAB_HUB_description": "Acompanhe e gira eficazmente as tarefas de prospeção com calendários, notas, alertas e partilha de documentos.",
      "ROLE_TRACKING_description": "Receba dados posicionais de todos os jogadores num jogo através da nossa API para uma análise abrangente.",
      "ROLE_ARRIGO_description": "Combina eventing e tracking em métricas inovadoras que vão além do tradicional e adicionam valor a cada ação.",
      "ROLE_REPORTS_description": "Solicite relatórios de prospeção detalhados à nossa equipa de analistas para encontrar a equipa ou o jogador perfeito."
    },
    administration: {
      pageSubtitle: "Gerir o funcionamento da aplicação",
      newClient: "Novo Cliente",
      newUser: "Novo Utilizador",
      editClient: "Editar Cliente",
      editUser: "Editar Utilizador",
      clientName: "Nome",
      permissions: "Permissões",
      releaseUser: "Utilizador de lançamento",
      connectAsUser: "Conecte-se como Utilizador",
      releaseModalTitle: "Liberação de confirmação do utilizador",
      releaseModalMessage: "O utilizador receberá um e-mail sobre a sua nova conta. Tem certeza que quer notificá-lo?",
      clientType: {
        Driblab: "Driblab",
        Team: "Equipa",
        Brand: "Marca",
        Federation: "Federação",
        Media: "Meios de comunicação",
        Agency: "Agência",
        Individual: "Individual"
      },
      userType: {
        Ownership: "Propriedade",
        SportingDirector: "Diretor Desportivo",
        Brand: "Marca",
        Federation: "Federação",
        Media: "Meios de comunicação",
        Agency: "Agência",
        Individual: "Individual",
        Scout: "Olheiro",
        Coach: "Treinador"
      },
      visibleYears: "Anos Visíveis",
      areaModalTitle: "Ativar/Desativar Ligas Confirmação",
      areaModalMessage: "Tem certeza de ativar/desativar todas as ligas de área selecionada?",
      countStats:"Count Stats",
      userClientModalTitle:"User already exists in another client",
      eventing: "Eventing",
      hub: "Hub"
    },
    dashboards: {
      lastGame: "Última análise de jogo",
      lastGameSimple: "Last game",
      seeAllGameInfo: "Ver todas as informações do jogo",
      nextGame: "Antevisão do próximo jogo",
      myTeam: "A minha equipa",
      lastMatchdayGames: "Última Jornada",
      lastAdded: "Última adição",
      myFavorites: "Os meus favoritos",
      seeAllFavorites: "Ver todos os favoritos",
      placeholderFavorites: "Pode adicionar os favoritos ao detalhe do jogador",
      placeholderTeamFavorites: "You can add favorites from team detail",
      myCollections: "Minhas Coleções",
      placeholderCollections: "Ainda não tem nenhuma coleção.",
      lastCreated: "Última Criação",
      seeAllCollections: "Ver todas as coleções",
      seeRival: "Ver Rival",
      seeMyTeam: "Ver A Minha Equipa",
      title: "Visão geral do painel",
      subtitle: "Bem-vindo de volta",
      recentPlayers: "Jogadores recentes",
      lastScouted: "Última exploração",
      scout: "Olheiro",
      reportsRequested: "Relatórios",
      lastRequested: "Última solicitação",
      goInbox: "Ir Caixa de entrada",
      placeholderLastScouted: "Pode procurar jogadores na barra esquerda ou na ferramenta de scout",
      placeholderReports: "Pode solicitar relatórios dos detalhes dos jogadores",
      nationalPlayers: "Jogadores nacionais mais valiosos noutros países",
      lastGames: "Últimos Jogos",
      nationalPlayersShort: "Jogadores nacionais em outros países",
      nextMatchdayGames: "Próxima jornada",
      injuredPlayers: "Jogadores lesionados",
      atPresent: "Hoje em dia",
      seeAllPlayers: "Ver todos os jogadores",
      suspendedPlayers: "Jogadores Suspensos",
      placeholderInjured: "Não há jogadores lesionados",
      teamValueImpacted: "Valor da equipa impactado",
      placeholderSuspended: "Não há jogadores suspensos",
      placeholderNextGame: "Não há jogo disponível",
      placeholderNoGames: "Ainda não há jogos disponíveis",
      placeholderLastMatchDayNotFound: "Última jornada não disponível",
      placeholderNextMatchDayNotFound: "Próxima jornada não disponível",
      usersMostSearch: "Utilizadores com mais pesquisas",
      lastTwoDays: "Últimos dois dias",
      searchesHistory: "Pesquisa histórico",
      dayByDay: "Diariamente",
      activeUsersTitle: "Utilizadores Ativos",
      activeUsersSubtitle: "Registado pelo menos no mês passado.",
      onlineUsersTitle: "Utilizadores Online",
      onlineUsersSubtitle: "Procure algo na última hora",
      searchesPerformed: "Pesquisas feitas",
      onlyClients: "Apenas clientes",
      activeClientsTitle: "Clientes Ativos",
      activeClientsSubtitle: "Ter pelo menos um utilizador ativo",
      onlineUsersTitle: "Utilizadores Online",
      onlineUsersSubtitle: "Procure algo na última hora",
      searchesPerformed: "Pesquisas feitas",
      onlyClients: "Apenas clientes",
      activeClientsTitle: "Clientes Ativos",
      activeClientsSubtitle: "Ter pelo menos um utilizador ativo",
      last24Hours: "Últimas 24 Horas",
      activityHistory: "História da Atividade",
      loginHistory: "História do Acesso",
      failLogins: "Acesso a falhas",
      successLogins: "Acesso ao Sucesso",
      clientStats: "Estatísticas do Cliente",
      playersMostSearch: "Jogadores com mais pesquisas",
      toolsMoreUsed: "Ferramentas mais usadas",
      hotPlayers: "Jogadores quentes",
      last_month: "Mês passado",
      last_week: "A semana passada",
      last_day: "Último Dia",
      nClients: "Nº de Clientes",
      userDashboard: "Painel de controlo do utilizador",
      userDashboardSubtitle: "Resumo da atividade da conta",
      offlineDaysOfClient: "Dias offline para cada cliente",
      hideNoConnected: "Ocultar não conectados",
      onlyTrial: "Apenas clientes de teste",
      daysWithoutLogin: "Dias sem login",
      trialDays: "Dias de teste"
    },
    faq: {
      subtitle: "Saiba mais sobre o que é o Driblab PRO",
      categories: {
        playerMetrics: "Métricas do jogador",
        teamMetrics: "Métricas da Equipa",
        positions: "Posições da equipa",
        tools: "Ferramentas",
        api: "API",
        videos:"Tutorials",
        playerPositions: "Posições dos Jogadores"
      },
      positions: {
        "GK": "Guarda-redes",
        "DR": "Defesa Direito / Lateral Direito (RB)",
        "DC": "Defesa Central / Defensa central (CB)",
        "DL": "Defesa Esquerdo / Lateral Esquerdo (LB)",
        "DMR": "Ala Lateral direito (RWB)",
        "DMC": "Médio-defensivo central (CDM)",
        "DML": "Ala lateral esquerdo (LWB)",
        "MR": "Médio direito (RM)",
        "MC": "Médio-centro (CM)",
        "ML": "Médio esquerdo (LM)",
        "AMR": "Médio ofensivo Direito / Ala direito (RW)",
        "AMC": "Centro médio ofensivo / Médio Avançado",
        "AML": "Médio ofensivo esquerdo / Ala esquerdo (LW)",
        "FWR": "Avançado direito / Ponta-de-lança (RS)",
        "FW": "Avançado / Ponta de lança (ST)",
        "FWL": "Avançado esquerdo / ponta-de-lança esquerdo (LS)"
      },
      metrics: {
        categories: {
          Association: "Associação",
          Saving: "Defesas",
          Shooting: "Remates",
          Defending: "Defender",
          Passing: "Passe",
          BallHandling: "Manipulação de Bola",
          Aerial: "Aéreo",
          Physical: "Física",
          Predictive: "Preditivo",
          Arrigo: "Arrigo",
          Score: "Pontuação",
          Turnovers: "Perdidas",
          Carries: "Condução",
          SequenceInvolvement: "Envolvimento de sequências",
          Crosses: "Cruzamentos",
          Distance: "Distância",
          Sprint: "Sprint",
          Acceleration: "Acelerações",
          MaxAcceleration: "Aceleração máxima",
          Speed: "Velocidade",
          OutPlay: "Outplay",
          LineBreakingPasses: "Passes entre Linhas",
          LineBreakingCarries: "Condução entre Linhas",
          LineBreakingActions: "Ações entre Linhas",
          PassUnderPressure: "Passe sob Pressão",
          BallReceived: "Bola Recebida",
          OnBallPressureReceived: "Pressão Recebida com Bola",
          OnBallPressure: "Pressão Sobre a Bola",
          SpatialCoverage: "Controle do Campo",
          OffBallPressure: "Pressão sem Bola",
          NoCategory: "Others",
          subcategories: {
            Quality: "Qualidade",
            Quantity: "Quantidade",
            TeamComparison: "Comparação de equipas",
            Receptions: "Receções",
            LongBalls: "Passes longos",
            Efficiency: "Eficiência",
            Ratio: "Rácio",
            Defensive: "Defensivo",
            Offensive: "Ofensivo",
            Foot: "Pé",
            Progression: "Progressão",
            TopValue: "Valor máximo",
            Predictive: "Preditivo",
            Distance: "Distância",
            Aerial: "Aéreo",
            Crosses: "Cruzamentos",
          },
          desc: {
            Association: "Associação",
            Saving: "Defesas",
            Shooting: "Remates",
            Defending: "Defender",
            Passing: "Passe",
            BallHandling: "Manipulação de Bola",
            Aerial: "Aéreo",
            Physical: "Física",
            Predictive: "Preditivo",
            Arrigo: "Arrigo",
            Score: "Pontuação",
            Turnovers: "Perdidas",
            Carries: "Condução",
            SequenceInvolvement: "Envolvimento de sequências",
            Crosses: "Cruzamentos",
            Distance: "Distância percorrida a diferentes velocidades",
            Sprint: "Corridas a diferentes velocidades",
            Acceleration: "Acelerações",
            Speed: "Velocidade",
            OutPlay: "Outplay",
            LineBreakingPasses: "Passes entre Linhas",
            LineBreakingCarries: "Condução entre Linhas",
            LineBreakingActions: "Ações entre Linhas",
            PassUnderPressure: "Passe sob Pressão",
            BallReceived: "Bola Recebida",
            OnBallPressureReceived: "Pressão Recebida com Bola",
            OnBallPressure: "Pressão Sobre a Bola",
            SpatialCoverage: "Controle do Campo",
            OffBallPressure: "Pressão sem Bola",
          },
          abbr: {
            Association: "Associação",
            Saving: "Defesas",
            Shooting: "Remates",
            Defending: "Defender",
            Passing: "Passe",
            BallHandling: "M. Bola",
            Aerial: "Aéreo",
            Physical: "Física",
            Predictive: "Preditivo",
            Arrigo: "Arrigo",
            Score: "Score",
            Turnovers: "Perdidas",
            Carries: "Condução",
            SequenceInvolvement: "Envol. de seq.",
            Crosses: "Cruzamentos",
            Distance: "Distância",
            Sprint: "Corridas",
            Acceleration: "Acelerações",
            MaxAcceleration: "Máx. Aceleração",
            Speed: "Velocidade",
            OutPlay: "Outplay",
            LineBreakingPasses: "Passes entre Linhas",
            LineBreakingCarries: "Condução entre Linhas",
            LineBreakingActions: "Ações entre Linhas",
            PassUnderPressure: "Passe sob Pressão",
            BallReceived: "Bola Recebida",
            OnBallPressureReceived: "Pressão Recebida com Bola",
            OnBallPressure: "Pressão Sobre a Bola",
            SpatialCoverage: "Controle do Campo",
            OffBallPressure: "Pressão sem Bola",
          },
        },
        types: {
            1: "Por 90",
            2: "Percentagem",
            3: "Taxa",
            4: "Eficiência",
            5: "Média",
            6: "Por jogo",
            7: "Diferença",
            8: "Max",
        }
      },
      api: {
        subtitle:"Obter informação de diferentes pedidos",
        resourcesTitle: "Recursos",
        authentication: "Autenticação",
        authText: "Para ligar para a API tem de incluir em cada pedido o cabeçalho 'Autorização' com o valor 'Portador {API_TOKEN}'»",
        generate: "Gerar",
        tokenPlaceholder: "Se não tiver um token ou tiver expirado, clique em 'Gerar'",
        pathParameters: "Parâmetros do caminho",
        queryParameters: "Parâmetros de consulta",
        responseModel: "Modelo de resposta",
        tokenWarning: "* Gere um símbolo para utilizar a API",
        pathParamsWarning: "* Existem parâmetros de caminho não preenchidos",
        genericDescription: "Uma API (Interface de Programação de Aplicações) permite que os desenvolvedores acessem e integrem dados ou funcionalidades em suas próprias aplicações. A nossa API de estatísticas de futebol oferece acesso abrangente a uma variedade de dados sobre países, competições, equipes, jogadores, jogos e muito mais. Usando esta API, você pode criar aplicações que aproveitem os nossos ricos dados de futebol para análises, visualizações ou outras soluções inovadoras.",
        methods: {
          getAllCountries: "Este método recupera uma lista completa de todos os países disponíveis na API, fornecendo detalhes importantes como o identificador único e o nome de cada país. Este endpoint é ideal para aplicações que necessitam de dados geográficos de futebol, permitindo funcionalidades como seleção de país, filtragem e análises. Também serve como um recurso fundamental para interagir com outros endpoints que dependem do parâmetro `countryId`, garantindo uma navegação e integração fluida com o conjunto de dados da API.",
          getCountryDetail: "Este método fornece informações detalhadas sobre um país específico disponível na API. Utilizando este endpoint, é possível obter dados como o nome do país, código e quaisquer metadados relevantes associados. Este método é particularmente útil para aplicações que precisam de detalhes específicos de um país para melhorar a experiência do utilizador, como exibir informações contextuais ou criar insights personalizados com base em dados geográficos. Complementa outros endpoints ao permitir uma exploração mais aprofundada de um país selecionado.",
          getCountryCompetitions: "Este método recupera uma lista de todas as competições disponíveis em um país específico. É um recurso valioso para criar funcionalidades que permitem aos utilizadores explorar competições por região, oferecendo uma forma fluida de conectar dados de países com os seus torneios associados. Este endpoint é essencial para aplicações focadas em conteúdos de futebol localizados ou análises regionais.",
          getAllCompetitionTypes: "Este método retorna uma lista de todos os tipos de competições disponíveis na API, como ligas, taças e torneios internacionais. Este endpoint é ideal para categorizar competições e fornecer aos utilizadores uma visão organizada dos diferentes tipos de eventos cobertos. É especialmente útil para criar funcionalidades como filtros ou menus suspensos que permitem aos utilizadores explorar dados de futebol com base na natureza da competição.",
          getAllCompetitions: "Este método recupera uma lista abrangente de todas as competições disponíveis na API, independentemente do tipo ou localização. Este endpoint é útil para aplicações que precisam exibir ou analisar uma ampla gama de competições de futebol, permitindo aos utilizadores explorar e selecionar eventos de interesse.",
          getCompetitionAvailable: "Este método recupera uma lista de competições atualmente marcadas como disponíveis na API. Isso garante que os dados retornados estejam atualizados e prontos para uso em aplicações. É particularmente útil para desenvolvedores que criam funcionalidades baseadas em competições ativas ou acessíveis, permitindo aos utilizadores explorar eventos relevantes sem encontrar dados desatualizados ou incompletos.",
          getCompetitionDetail: "Este método fornece informações detalhadas sobre uma competição específica disponível na API. É particularmente útil para aplicações que necessitam de informações aprofundadas sobre uma competição, permitindo funcionalidades como visualizações detalhadas, insights contextuais ou opções de filtragem baseadas nas características da competição.",
          getCompetitionSeasons: "Este método recupera uma lista de todas as temporadas associadas a uma competição específica. Este endpoint é essencial para aplicações que visam fornecer uma cobertura abrangente da história ou do estado atual de uma competição, permitindo aos utilizadores explorar dados temporada por temporada.",
          getSeasonAvailable: "Este método fornece uma lista de temporadas atualmente marcadas como disponíveis na API. É particularmente útil para aplicações focadas em eventos de futebol ao vivo ou em andamento, permitindo aos usuários interagir com dados relevantes e atuais da temporada.",
          getSeasonDetail: "Este método recupera informações detalhadas sobre uma temporada específica, incluindo sua linha do tempo, competição associada e metadados chave. Este endpoint é essencial para aplicações que necessitam de insights aprofundados sobre uma temporada específica, possibilitando funcionalidades como visões gerais da temporada, filtragem por competição ou exibição de linhas do tempo detalhadas para interação do usuário.",
          getSeasonTeams: "Este método fornece uma lista de todas as equipes que participam de uma temporada específica. É ideal para funcionalidades como gerenciamento de plantel, análise de desempenho das equipes ou criação de filtros específicos para a temporada.",
          getSeasonPlayer: "Este método recupera uma lista de todos os jogadores registrados em uma temporada específica. É ideal para criar funcionalidades como plantéis de jogadores, acompanhamento de desempenho ou filtragem de jogadores com base na temporada selecionada.",
          getSeasonPlayerStats: "Este método fornece estatísticas detalhadas para todos os jogadores de uma temporada específica. É particularmente útil para aplicações focadas em análises, comparações de jogadores ou criação de visualizações dinâmicas das conquistas dos jogadores ao longo da temporada.",
          getSeasonArrigoMetrics:"Este método fornece estatísticas combinadas para todos os jogadores numa época específica. É particularmente útil para aplicações focadas em análises, comparações de jogadores ou criação de visualizações dinâmicas de conquistas dos jogadores ao longo da época.",
          getGameTeamPhysicalStats: "Este método recupera estatísticas de desempenho físico das equipes em um jogo específico. É ideal para aplicações que analisam os níveis de preparo físico das equipes, tendências de desempenho físico ou fornecem análises detalhadas do esforço de uma equipe durante uma partida.",
          getSeasonTeamStats: "Este método fornece estatísticas abrangentes para todas as equipes que participam de uma temporada específica. É particularmente útil para aplicações focadas na análise de equipes, resumos da temporada ou comparações de desempenho das equipes ao longo da temporada.",
          getSeasonCoaches: "Este método recupera uma lista de todos os treinadores que geriram equipes durante uma temporada específica. É particularmente útil para aplicações que focam em insights da temporada, análises de treinadores ou acompanhamento de mudanças na gestão das equipes ao longo da temporada.",
          getSeasonGames: "Este método fornece uma lista de todos os jogos disputados em uma temporada específica. É ideal para aplicações que precisam exibir cronogramas completos da temporada, analisar resultados de jogos ou fornecer aos usuários acesso a dados abrangentes sobre os jogos da temporada.",
          getSeasonGamesMatchday: "Este método recupera todos os jogos de uma rodada específica dentro de uma determinada temporada. É particularmente útil para aplicações que visam exibir cronogramas de rodadas, analisar rodadas específicas ou fornecer insights focados em um conjunto particular de jogos durante a temporada.",
          getSeasonLeagueTable: "Este método fornece a tabela classificativa de uma temporada específica, incluindo rankings, pontos, vitórias, empates, derrotas e outras estatísticas relevantes para cada equipe. Este endpoint é essencial para aplicações focadas no acompanhamento das classificações das equipes, análise da progressão da liga ou apresentação de classificações atualizadas aos usuários ao longo da temporada.",
          getTeamDetail: "Este método fornece informações detalhadas sobre uma equipe específica, incluindo seu nome, ano de fundação, estádio e outros metadados. Este endpoint é ideal para aplicações que necessitam de insights específicos sobre equipes, possibilitando funcionalidades como perfis detalhados de equipes, contexto histórico ou experiências de usuário aprimoradas com dados ricos sobre as equipes.",
          getTeamLoans: "Este método recupera informações sobre transações de empréstimo envolvendo uma equipe específica. Este endpoint é particularmente útil para aplicações focadas em análise de transferências, gerenciamento de elenco ou rastreamento de movimentações de jogadores durante uma temporada.",
          getTeamRoster: "Este método fornece uma lista completa de jogadores no elenco de uma equipe específica. É ideal para aplicações que precisam exibir escalações de equipes, analisar funções dos jogadores ou gerenciar funcionalidades relacionadas ao elenco de uma equipe.",
          getTeamGames: "Este método recupera uma lista de todos os jogos disputados por uma equipe específica. É particularmente útil para aplicações focadas no desempenho da equipe, acompanhamento de cronogramas ou fornecimento aos usuários do histórico completo de jogos de uma equipe.",
          getTeamGameStats: "Este método fornece estatísticas detalhadas de uma equipe específica em um determinado jogo. É particularmente útil para aplicações focadas em análises de jogos, avaliações de desempenho ou detalhamento aprofundado do desempenho de uma equipe em partidas individuais.",
          getTeamTransfers: "Este método recupera informações sobre transações de transferência envolvendo uma equipe específica. É particularmente útil para aplicações que se concentram em análises do mercado de transferências, mudanças no elenco da equipe ou rastreamento de movimentações de jogadores ao longo do tempo.",
          getGameStatus: "Este método fornece uma lista de todos os possíveis status de jogos disponíveis na API, como agendado, em progresso, concluído, adiado ou cancelado. Este endpoint é particularmente útil para aplicações que exigem rastreamento de jogos em tempo real, filtragem de jogos por status ou fornecimento de atualizações claras aos usuários sobre o andamento ou estado de uma partida.",
          getPlayerPositions: "Este método retorna uma lista de todas as possíveis posições de jogadores, como goleiro, defensor, meio-campista e atacante. Este endpoint é particularmente útil para aplicações que categorizam jogadores, analisam dados posicionais ou permitem que os usuários filtrem jogadores com base em suas funções no campo.",
          getGameDetail: "Este método fornece informações abrangentes sobre um jogo específico, incluindo detalhes como equipes participantes, data e hora, local, placar e outros metadados importantes. Este endpoint é ideal para aplicações que necessitam de insights detalhados sobre partidas, possibilitando funcionalidades como prévias detalhadas, relatórios ou análises de jogos.",
          getGameStats: "Este método fornece estatísticas detalhadas de um jogo específico, incluindo métricas como gols, finalizações, porcentagem de posse de bola, passes e ações defensivas. Este endpoint é particularmente útil para aplicações focadas em análise de partidas, relatórios pós-jogo ou visualizações do desempenho das equipes durante uma partida.",
          getGamePlayerStats: "Este método recupera estatísticas detalhadas de desempenho para todos os jogadores que participaram de um jogo específico. É particularmente útil para aplicações que analisam o desempenho individual dos jogadores, geram relatórios de partidas ou comparam jogadores no contexto de um único jogo.",
          getGamePlayerPhysicalStats: "Este método fornece métricas detalhadas de desempenho físico para jogadores em um jogo específico. É particularmente útil para aplicações que se concentram na análise de condicionamento físico dos jogadores, no acompanhamento de desempenho físico ou na geração de insights detalhados sobre partidas para jogadores individuais.",
          getGameTeamPhysicalStats: "Este método fornece métricas detalhadas de desempenho físico das equipes em um jogo específico. Inclui dados como a distância total percorrida, número de sprints, corridas de alta intensidade e outros atributos físicos. É particularmente útil para aplicações focadas na análise da condição física das equipes, comparação dos esforços físicos entre equipes ou avaliação do desempenho geral em uma partida.",
          getGamePlayerArrigoMetrics: "Este método fornece métricas de arrigo detalhadas para os jogadores numa partida específica. É particularmente útil para aplicações focadas na análise e na geração de insights detalhados sobre os jogadores numa partida.",
          getGameTeamArrigoMetrics: "Este método fornece métricas detalhadas sobre o arrigo da equipa numa partida específica. Isto inclui dados como jogadores derrotados e outros atributos. É particularmente útil para aplicações focadas na análise da avaliação do desempenho geral da partida.",
          getGameLineup: "Este método recupera a escalação de um jogo específico, incluindo os jogadores titulares, substitutos e suas respectivas posições. Este endpoint é particularmente útil para aplicações que exibem informações pré-jogo, analisam formações táticas ou fornecem insights sobre decisões estratégicas feitas pelas equipes para uma partida.",
          getGameTimeline: "Este método fornece uma lista cronológica de eventos que ocorreram durante um jogo específico. É particularmente útil para aplicações que oferecem atualizações ao vivo, resumos pós-jogo ou análises detalhadas dos eventos de uma partida.",
          getGameTracking: "Este método fornece um link para download do arquivo de dados de rastreamento de um jogo específico. Este arquivo contém dados detalhados de movimento e posicionamento dos jogadores e da bola ao longo da partida. É particularmente útil para aplicações focadas em análises avançadas, análises táticas ou na criação de visualizações dos movimentos dos jogadores e da bola durante o jogo.",
          getTrackingStatus: "Este método devolve uma lista completa de todos os estados disponíveis no rastreio, fornecendo detalhes importantes como o identificador único e o nome de cada estado. Este endpoint é ideal para aplicações que requerem o rastreio de correspondência, permitindo funcionalidades como a seleção de estado, filtragem e análise. Serve também como um recurso crítico para interagir com outros endpoints que dependem de um parâmetro `statusId`, garantindo uma navegação e integração perfeitas com o conjunto de dados mais amplo da API.",
          getPlayerTransfersTypes: "Este método recupera uma lista dos possíveis tipos de transferências de jogadores, como transferência permanente, empréstimo, transferência gratuita ou troca. Este endpoint é particularmente útil para aplicações que analisam tendências do mercado de transferências, categorizam movimentações de jogadores ou fornecem insights detalhados sobre os tipos de transações envolvendo jogadores.",
          getPlayerDetail: "Este método fornece informações detalhadas sobre um jogador específico, incluindo detalhes pessoais, estatísticas de carreira e afiliação à equipe atual. Este endpoint é ideal para aplicações que oferecem perfis de jogadores, insights históricos ou análises sobre desempenho individual e trajetórias de carreira.",
          getPlayerGames: "Este método recupera uma lista de todos os jogos em que um jogador específico participou. É particularmente útil para aplicações focadas no acompanhamento do desempenho do jogador, análise do histórico de partidas ou fornecimento de registros completos de jogos para jogadores individuais.",
          getPlayerInjuries: "Este método fornece um registro detalhado das lesões sofridas por um jogador específico. É particularmente útil para aplicações focadas em análises de saúde do jogador, avaliações de impacto na carreira ou acompanhamento dos prazos de recuperação.",
          getPlayerNationalTeam: "Este método recupera informações detalhadas sobre a participação de um jogador em partidas da seleção nacional. É particularmente útil para aplicações que analisam o desempenho de jogadores em nível nacional, acompanham carreiras internacionais ou fornecem insights sobre contribuições durante torneios e amistosos.",
          getPlayerSeasons: "Este método fornece uma lista de todas as temporadas em que um jogador específico participou. É particularmente útil para aplicações que acompanham a progressão da carreira de um jogador, analisam o desempenho ao longo das temporadas ou fornecem contexto histórico para suas conquistas.",
          getPlayerTransfers: "Este método recupera um histórico detalhado das transações de transferência envolvendo um jogador específico. É particularmente útil para aplicações focadas na análise da carreira do jogador, insights sobre o mercado de transferências ou rastreamento das movimentações dos jogadores entre equipes ao longo do tempo.",
          getPlayerSeasonTeamStats: "Este método fornece estatísticas detalhadas de desempenho de um jogador específico durante uma temporada com uma equipe. É particularmente útil para aplicações focadas na análise do desempenho de jogadores ao longo de uma temporada, comparações entre equipes ou temporadas e acompanhamento das contribuições individuais para o sucesso da equipe.",
          getPlayerSeasonPhysicalStats: "Este método fornece métricas detalhadas de desempenho físico de um jogador específico ao longo de uma temporada. É particularmente útil para aplicações que acompanham a condição física do jogador, analisam o desempenho físico ou avaliam a carga de trabalho de um jogador durante a temporada.",
          getPlayerSeasonGamePhysicalStats: "Este método fornece métricas detalhadas de desempenho físico de um jogador específico em cada jogo de uma temporada. É particularmente útil para aplicações que analisam o condicionamento físico em jogos específicos, acompanham a carga de trabalho dos jogadores ou comparam o desempenho físico em diferentes partidas.",
          getPlayerSeasonGameStats: "Este método recupera estatísticas detalhadas de desempenho de um jogador específico em cada jogo de uma temporada. É particularmente útil para aplicações que analisam o desempenho de jogadores em partidas específicas, tendências de desempenho ou comparações detalhadas entre jogos dentro de uma temporada.",
          getCoachDetail: "Este método fornece informações detalhadas sobre um treinador específico, incluindo seu nome, histórico de carreira, equipes treinadas e conquistas notáveis. Este endpoint é particularmente útil para aplicações que destacam perfis de treinadores, acompanham carreiras de técnicos ou analisam o impacto dos treinadores no desempenho das equipes.",
          getCoachHistory: "Este método recupera um histórico abrangente da carreira de um treinador específico, incluindo as equipes que ele treinou, competições em que participou e as durações de seus mandatos. Este endpoint é particularmente útil para aplicações que analisam carreiras de técnicos, acompanham mudanças na gestão ou fornecem insights sobre a trajetória profissional e conquistas de um treinador.",          
        },
        responseCodes: "Códigos de Resposta",
        furtherInformation:"For further information, please read our API documentation",
        clipboard: "Copiado para a área de transferência!"
      }
    },
    globalSearch: {
      subtitle: "Filtragem profunda"
    },
    iso: {
      AF: "Afeganistão",
      DZ: "Argélia",
      AO: "Angola",
      AR: "Argentina",
      AU: "Austrália",
      AZ: "Azerbaijão",
      BH: "Bahrein",
      BB: "Barbados",
      BE: "Bélgica",
      BJ: "Benin",
      BO: "Bolívia",
      BW: "Botsuana",
      BN: "Brunei",
      BF: "Burkina Faso",
      KH: "Camboja",
      CA: "Canadá",
      CF: "Rep. África central",
      CL: "Chile",
      CO: "Colômbia",
      CD: "Congo DR",
      CG:"Congo",
      CI: "Costa do Marfim",
      CU: "Cuba",
      CZ: "República Checa",
      DJ: "Djibouti",
      DO: "República Dominicana",
      EC: "Equador",
      SV: "El Salvador",
      ER: "Eritrea",
      ET: "Etiópia",
      FI: "Finlândia",
      PF: "Polinésia Francesa",
      GM: "Gâmbia",
      DE: "Alemanha",
      GI: "Gibraltar",
      GL: "Gronelândia",
      GP: "Guadeloupe",
      GN: "Guiné",
      GY: "Guiana",
      HN: "Honduras",
      HU: "Hungria",
      IN: "Índia",
      IR: "Irão",
      IE: "Irlanda",
      IT: "Itália",
      JP: "Japão",
      KZ: "Cazaquistão",
      KI: "Kiribati",
      KR: "Coreia do Sul",
      KG: "Quirguizistão",
      LV: "Letónia",
      LS: "Lesoto",
      LY: "Libia",
      LT: "Lituânia",
      MO: "RAE de Macau",
      MG: "Madagáscar",
      MY: "Malásia",
      ML: "Mali",
      MH: "Ilhas Marshall",
      MR: "Mauritânia",
      MX: "México",
      MD: "Moldávia",
      MN: "Mongólia",
      MA: "Marrocos",
      MM: "Rio Myanmar",
      NR: "Nauru",
      NL: "Países Baixos",
      NZ: "Nova Zelândia",
      NE: "Rio Níger",
      MP: "Ilhas Marianas do Norte",
      OM: "Omã",
      PW: "Palau",
      PA: "Panamá",
      PY: "Paraguai",
      PH: "Filipinas",
      PT: "Portugal",
      QA: "Catar",
      RO: "Roménia",
      RW: "Ruanda",
      LC: "Santa Lúcia",
      SM: "São Marino",
      SA: "Arábia Saudita",
      RS: "Sérvia",
      SL: "Serra Leoa",
      SK: "Eslováquia",
      SB: "Ilhas Salomão",
      ZA: "África do Sul",
      LK: "Sri Lanka",
      SD: "Sudão",
      SZ: "Suazilândia",
      CH: "Suíça",
      TW: "Taiwan",
      TZ: "Tanzânia",
      TG: "Togo",
      TT: "Trindade e Tobago",
      TR: "Turquia",
      TV: "Tuvalu",
      UA: "Ucrânia",
      GB: "Reino Unido",
      UY: "Uruguai",
      VU: "Vanuatu",
      VE: "Venezuela",
      VG: "Ilhas Virgens, Britânica",
      EH: "Sara Ocidental",
      ZM: "Zâmbia",
      AL: "Albânia",
      AD: "Andorra",
      AG: "Antígua e Barbuda",
      AM: "Arménia",
      AT: "Áustria",
      BS: "Bahamas",
      BD: "Bangladesh",
      BY: "Bielorrússia",
      BZ: "Belize",
      BT: "Butão",
      BA: "Bósnia e Herz.",
      BR: "Brasil",
      BG: "Bulgária",
      BI: "Burundi",
      CM: "Camarões",
      CV: "Cabo Verde",
      TD: "Chad",
      CN: "China",
      KM: "Comoras",
      CR: "Costa Rica",
      HR: "Croácia",
      CY: "Chipre",
      DK: "Dinamarca",
      DM: "Dominica",
      TL: "Timor-Leste",
      EG: "Egito",
      GQ: "Guiné Equatorial",
      EE: "Estónia",
      FJ: "Fiji",
      FR: "França",
      GA: "Gabão",
      GE: "Geórgia",
      GH: "Gana",
      GR: "Grécia",
      GD: "Granada",
      GT: "Guatemala",
      GW: "Guiné-Bissau",
      HT: "Haiti",
      HK: "Hong Kong SAR",
      IS: "Islândia",
      ID: "Indonésia",
      IQ: "Iraque",
      IL: "Israel",
      JM: "Jamaica",
      JO: "Jordânia",
      KE: "Quénia",
      KP: "Coreia do Norte",
      KW: "Kuwait",
      LA: "Laos",
      LB: "Líbano",
      LR: "Libéria",
      LI: "Liechtenstein",
      LU: "Luxemburgo",
      MK: "Macedónia",
      MW: "Malawi",
      MV: "Maldivas",
      MT: "Malta",
      MQ: "Martinica",
      MU: "Ilha Maurícia",
      FM: "Micronésia",
      MC: "Mónaco",
      ME: "Montenegro",
      MZ: "Moçambique",
      NA: "Namíbia",
      NP: "Nepal",
      NC: "Nova Caledónia",
      NI: "Nicarágua",
      NG: "Nigéria",
      NO: "Noruega",
      PK: "Paquistão",
      PS: "Territórios Palestinianos",
      PG: "Papua-Nova Guiné",
      PE: "Peru",
      PL: "Polónia",
      PR: "Porto Rico",
      RE: "Reunião",
      RU: "Federação Russa",
      KN: "São Cristóvão e Nevis",
      WS: "Samoa",
      ST: "São Tomé e Princ.",
      SN: "Senegal",
      SC: "Seychelles",
      SG: "Singapura",
      SI: "Eslovénia",
      SO: "Somália",
      ES: "Espanha",
      VC: "São Vicente e Gren.",
      SR: "Suriname",
      SE: "Suécia",
      SY: "Síria",
      TJ: "Tajiquistão",
      TH: "Tailândia",
      TO: "Tonga",
      TN: "Tunísia",
      TM: "Turquemenistão",
      UG: "Uganda",
      AE: "Emirados Árabes Unidos",
      US: "Estados Unidos",
      UZ: "Usbequistão",
      VA: "Cidade do Vaticano",
      VN: "Vietname",
      VI: "Ilhas Virgens, E.U.A..",
      YE: "Iémen",
      ZW: "Zimbabue",
      EU: "Europa",
      INT:"Internacional",
      CW: "Curaçao",
      AFC:"AFC",
      CONCACAF:"CONCACAF",
      "GB-ENG": "Inglaterra",
      "GB-WLS": "País de Gales",
      "GB-SCT": "Escócia",
      "LATAM": "América do Sul",
      "CAF":"CAF",
      "XK":"Kosovo",
      AI: "Anguilla",
      AN: "Netherlands Antilles",
      AS: "American Samoa",
      AW: "Aruba",
      BM: "Bermuda",
      BQ: "Bonaire, SE and Saba",
      CK: "The Cook Islands",
      FO: "The Faroe Islands",
      GF: "Guyane",
      GG: "The Bailiwick of Guernsey",
      GU: "The Territory of Guam",
      IM: "The Isle of Man",
      JE: "The Bailiwick of Jersey",
      KY: "The Cayman Islands",
      MF: "The Collectivity of Saint-Martin",
      MS: "Montserrat",
      NU: "Niue",
      OC: "Oceania",
      RI: "Indonesia",
      SS: "The Republic of South Sudan",
      TC: "The Turks and Caicos Islands",
      YT: "The Department of Mayotte",
      SX: "São Martinho",
    },
    loadingMessages: {
      players: "Preparando jogadores",
      teams: "Equipas de Encomenda",
      games: "Jogos de Busca",
      stats: "Cálculo das Métricas",
      graphs: "Gráficos de desenho",
      gettingReady: "Aquecimento",
      placeholder: "Prepare-se"
    },
    requestReport: {
      subtitle: "Obtenha um relatório profundo com tudo o que precisa",
      categories: {
          "scouting": {
              title: "Scouting",
              subtitle: "Quem são os melhores jogadores de uma certa liga? E de várias ligas juntas? Solicite um relatório feito sob medida com qualquer filtro que queira (idade, altura, fim do contrato, etc.) e descubra quais os jogadores que melhor se adequam"
          },
          "coaches": {
              title: "Treinadores",
              subtitle: "Como é que um treinador se encaixaria no sistema da tua equipa? Obtenha informações detalhadas ou, dado um determinado perfil, conheça quais os treinadores que melhor se adequam"
          },
          "team analysis": {
              title: "Equipa",
              subtitle: "Especifique uma equipa e obtenha o resumo da temporada com informações valiosas sobre estilo, desempenho defensivo e ofensivo, pontos fracos, melhores jogadores, etc..."
          },
          "game analysis": {
              title: "Análise de Jogos",
              subtitle: "Dado um jogo, obtenha uma análise profunda pré-jogo e pós-jogo com informações detalhadas"
          },
          "special projects": {
              title: "Projetos Especiais",
              subtitle: "Como se sai um jogador em jogos fora? Como é que os jogadores mudam de liga para liga? Que jogadores estão disponíveis para empréstimo? Pergunte em tudo o que puder pensar."
          },
          "conversation": {
              title: "Conversa",
              subtitle: "Iniciar uma conversa com a nossa equipa"
          }
      },
      notesPlaceholder: "Informe-nos sobre a liga, o perfil, as estatísticas, o treinador, a equipa ou o jogo que queiram saber mais sobre",
      chooseType: "Selecione um tipo de relatório",
      requestSummary: "Resumo do Pedido",
      reportType: "Tipo de Relatório",
      reportLanguage: "Língua de relatório",
      detailTitle: "Acompanhamento do relatório",
      detailSubtitle: "Todas as informações sobre o relatório que solicitou"
    },
    bugReport: {
      modalSubtitle: "Ajude-nos a melhorar",
      about: "Sobre",
      sendSuccess: "Notificado com sucesso. Ver atualizações na Caixa de Entrada",
      bugs: "Insetos"
    },
    gbe: {
      autopass: "Passe Automático",
      bandX: "Band {0}",
      bandXCont: "Banda {0} Competição Continental",
      points: "Pontos",
      titleWinner: "Vencedor do Título",
      qualifiedGroupsBandX: "Qualificado para a fase de grupos de uma Banda {0} Competição Continental",
      qualifiedQualifiersBandX: "Qualificado para a qualificação de uma Banda {0} Competição Continental",
      midTable: "Meio da tabela",
      relegation: "Despromoção",
      promotion: "Promoção",
      final: "Final",
      semifinal: "Meias-Finais",
      quarterfinal: "Quartos de Final",
      round16: "Oitavos de Final",
      round32: "Um dezesseis avos de Final ",
      groupstage: "Fase de Grupos",
      firstRound: "1st Round",
      secondRound: "2nd Round",
      thirdRound: "3rd Round",
      fourthRound: "4th Round",
      preliminaryRound: "Preliminary Round",
      other: "Outros",
      score: "Resultado",
      totalSummary: "Resumo Total",
      currentlyPlayingInUK: "O jogador é cidadão do Reino Unido ou da Irlanda, ou o jogador é residente permanente no Reino Unido",
      bandsAlert: "Há minutos tocados em mais de uma banda, o total é o valor máximo",
      bandsAlertMax: "Há minutos jogados em mais de uma banda, o total é o valor máximo",
      bandsAlertAvg: "Há minutos jogados em mais de uma banda, total é o valor médio",
      generate: "GBEApplicationForm",
      debutYouthPlayer:"Debut for Youth Player",
      table1: {
        name: "Aparições Internacionais do Jogador",
        title1: "Ranking Mundial agregado da FIFA da Associação Nacional de Jogadores",
        title2: "Aparições Internacionais do Jogador"
      },
      table2: {
        name: "Minutos Domésticos do Jogador",
        title1: "Minutos Domésticos do Jogador"
      },
      table3: {
        name: "Minutos Continentais do Jogador",
        title1: "Minutos Continentais do Jogador"
      },
      table4: {
        name: "Posição final da Liga do Último Clube do Jogador",
        title1: "Posição final da Liga do Último Clube"
      },
      table5: {
        name: "Progressão Continental do Último Clube do Jogador",
        title1: "Progressão Continental"
      },
      table6: {
        name: "Qualidade da Liga do Clube Atual do Jogador",
        title1: "Band of Player's Current Club"
      },
      table7: {
        name: "Juventude - Estreia",
        title1: "Banda"
      },
      table8: {
        name: "Juventude - Posição final da Liga",
        title1: "Last Club's Final League Position"
      },
      table9: {
        name: "Juventude - Progressão Continental",
        title1: "Progressão Continental"
      },
      table10: {
        name: "Juventude - Qualidade da Liga da Corrente do Jogador",
        title1: "Band of Player's Current Club"
      },
      table11: {
        name: "Juventude - Qualidade da Liga da Corrente do Jogador",
        title1: "Band of Player's Current Club"
      },
      table12: {
        name: "Juventude - Aparições Internacionais",
        title1: "Aparições Internacionais do Jogador"
      }
    },
    mediaMode: {
      borderColor: "Cor da borda",
      fillColor: "Preencha a cor",
      bgColor: "Cor de fundo",
      upperText: "Texto superior",
      lowerText: "Texto inferior",
      socialMedia: "Mídia Social",
      textColor: "Cor de texto",
      axisColor: "Cor do eixo",
      logo: "Logotipo",
      comparisonBorderColor: "Comparação de cores de fronteira",
      comparisonFillColor: "Comparação Preencha a cor",
      comparisonUpperText: "Comparação do texto superior",
      comparisonLowerText: "Comparação Menor Texto",
      homeFillColor: "Cor de preenchimento de casa",
      homeBorderColor: "Cor de borda de casa",
      awayFillColor: "Distância Preencher Cor",
      awayBorderColor: "Cor de fronteira distante",
      face: "Rosto",
      nationalTeam: 'Seleção Nacional',
      comparisonFace: "Face de comparação",
      upperTextX: "Texto superior {0}",
      lowerTextX: "Texto inferior {0}",
      borderColorX: "Cor da borda {0}",
      fillColorX: "Preencha a cor {0}",
      homeFillColorX: "Preencha a cor (casa) {0}",
      homeBorderColorX: "Cor da borda (casa) {0}",
      awayFillColorX: "Preencha a cor (fora) {0}",
      awayBorderColorX: "Cor da borda (longe) {0}",
      faceX: "Rosto {0}",
      selectField: "Selecione um imóvel",
      orientationX: "Orientação {0}",
      searchBarPlaceholder: "Pesquisar jogadores e/ou jogos...",
      title: "Media Dashboard",
      pageSubtitle: "Navegar e descarregar mapas e gráficos",
      chooseChart: "Escolha gráfico...",
      headerTextX: "Texto do cabeçalho {0}",
      avatarLineLength: "Comprimento da linha avatar",
      avatarLineWeight: "Peso da linha avatar",
      avatarSize: "Tamanho do Avatar",
      chartX: "Gráfico {0}",
      chartHeaderFontSize: "Tamanho do tipo de fonte cabeçalho dos gráficos",
      chartHeaderFontWeight: "Peso da fonte dos cabeçalhos do gráfico",
      upperTextFontSize: "Tamanho do tipo de letra de texto superior",
      upperTextFontWeight: "Peso de fonte de texto superior",
      lowerTextFontSize: "Tamanho inferior do tipo de letra de texto",
      lowerTextFontWeight: "Menor peso da fonte de texto",
      socialMediaFontSize: "Tamanho do tipo de fonte de média social",
      socialMediaFontWeight: "Social Media Font Weight",
      subtitle: "Legenda",
      subtitleFontSize: "Tamanho do tipo de fonte de legenda",
      subtitleFontWeight: "Peso de fonte de legenda",
      subtitleX: "Legenda {0}",
      subtitleFontSizeX: "Subtítulo ${0} Tamanho da fonte",
      subtitleFontWeightX: "Subtítulo ${0} Peso de Fonte",
      titleX: "Título {0}",
      titleFontSize: "Tamanho do título de fonte",
      titleFontWeight: "Title Font Weight",
      sponsor: "Patrocinador",
      fontFamily:"Font family"
    },
    documents: {
      types: {
        "SCOUTING_REPORT": "Relatórios de Scouting",
        "GAME_REPORT": "Relatórios do Jogo",
        "MEDICAL_REPORT": "Relatórios Médicos",
        "PHYSICAL_REPORT": "Relatórios Físicos",
        "PSYCHOLOGICAL_REPORT": "Relatórios Psicológicos",
        "OTHER": "Outros",
        "QUICK_NOTES": "Notas Rápidas",
        "PLAYER_REPORT": "Relatórios de Jogadores",
        "GENERAL_COMMENTS": "Comentários gerais",
        "PLAYER_ANALYSIS": "Análise do jogador"
      },
      uploadDocument: "Documento de upload",
      notesPlaceholder: "Tipo de notas descritivas ou comentários relacionados com o documento",
      notesPlaceholderAlt: "Escreva notas descritivas ou comentários relacionados com o jogador",
      uploadedBy: "Carregado por",
      updatedBy: "Atualizado por",
      seeNotes: "Ver Notas",
      addNote: "Adicionar Nota",
      rating: "Rating",
      position: "Melhor posição",
      physical: "Physical",
      onBall: "On Ball",
      offBall: "Off Ball",
      mental: "Mental",
      potential: "Potential",
      conclusion: "Conclusion",
      recommendation: {
        label: "Recomendação",
        1: "Contratar",
        2: "Monitorizar",
        3: "Descartar",
        4: "Interessante"
      },
      match: "Jogo",
      deleteQuickNote: "Eliminar nota",
      deleteQuickNoteMessage: "A nota será eliminada permanentemente. Tem a certeza?",
      noQuickNotes: "Sem dados. Comece adicionando algumas notas!",
      deleteDocument: "Eliminar documento",
      deleteDocumentMessage: "O documento será eliminado permanentemente. Tem a certeza?",
      noDocuments: "Sem dados. Comece adicionando alguns documentos!"
    },
    notifications: {
      newReportMessage: "Há uma nova mensagem num relatório."
    },
    blog: {
      subtitle: "Artigos mais recentes, atualizações e novidades",
      newEntry: "Nova Entrada",
      title: "Título",
      text: "Texto",
      link: "Ligação",
      image: "Imagem",
      author: "Autor",
      date: "Data de lançamento",
      deleteEntry: "Excluir Entrada",
      deleteEntryMessage: "Tem certeza de que deseja apagar esta entrada?"
    },
    positionsOrlegi: {
      "GK": "Guarda-redes",
      "DC": "Defesa",
      "DR": "Lateral",
      "MC": "Médio",
      "AMC": "Médio ofensivo",
      "FW": "Para a frente",
      "FWR": "Ala"
    },
    library: {
      subtitle: "Ver e partilhar documentos actualizados",
      mediaSubtitle:"Ver e partilhar gráficos exportados",
      charts: "Gráficos",
      goToLibrary: "Ir à biblioteca"
    },
    scatterPlot: {
      bubbleSize: "Tamanho da bolha",
      byMinutes: "Por Minutos",
      byAge: "Por Idade",
      byMarketValue: "Por Valor de Mercado"
    },
    eventChart:{
      successfulEvent:"Successful Event",
      unsuccessfulEvent:"Unsuccessful Event",
      successfulPass:"Successful Pass",
      unsuccessfulPass:"Unsuccessful Pass",
      successfulCarry:"Successful Carry",
      unsuccessfulCarry:"Unsuccessful Carry",
      carryAndKeyPass:"Carry & Key Pass",
      carryAndAssist:"Carry & Assist",
      carryAndShot:"Carry & Shot",
      ballProgressionAndPass:"Ball Prog. & Pass",
      ballProgression:"Ball Progression",
      ballProgressionAndKeyPass:"Ball Prog. & Key Pass",
      ballProgressionAndAssist:"Ball Prog. & Assist",
      ballProgressionAndShot:"Ball Prog. & Shot",
      ballProgressionAndGoal:"Ball Prog. & Goal",
      pass:"Pass",
      carryAndPass:"Carry & Pass",
      carryAndAssist:"Carry & Assist",
      carryAndShot:"Carry & Shot",
      carryAndGoal:"Carry & Goal",
      totalTouches:"Total Touches",
      successful:"Bem-sucedido",
      unsuccessful:"Malsucedido"
    },
    event:{
      Pass: "Passe",
      TakeOn: "Dribble",
      Takeon: "Dribble",
      Foul: "Falta",
      Tackle: "Tackle",
      Interception: "Interceptação",
      Clearance: "Limpou O Perigo",
      MissedShot: "Remate Falhado",
      ShotOnPost: "Remate ao Poste",
      SavedShot: "Remate Defendido",
      Goal: "Golo",
      Aerial: "Aéreo",
      Error: "Erro",
      BallRecovery: "Recuperação da Bola",
      Dispossessed: "Perdeu a Bola",
      ChanceMissed: "Oportunidade Falhada",
      BallTouch: "Toque da Bola",
      BlockedPass: "Passe Bloqueado",
      Challenge: "Challenge",
      lossPossession: "Pérdida de posesión",
      "Ball touch": "Ball touch",
      "Smother": "Smother",
      "Keeper pickup": "Keeper pickup",
      "Good skill": "Good skill",
      "Punch": "Punch",
      "Saved shot":"Saved shot",
      "Shot on post":"Shot on post",
      "Missed shot":"Missed shot",
      "Save":"Save",
      "Take on":"Take on",
      "Offside pass":"Offside pass",
      "Claim": "Claim",
      "Blocked pass": "Passe Bloqueado",
    },
    leagueTab:{
      leagueTable:"League Table",
      matchdays:"Matchdays",
      playerInsights:"Player Insights",
      teamInsights:"Team Insights",
      head2head:"Head To Head",
      addNewChart:"Add new chart",
      rounds: {
        "W": "Winner",
        "F": "Final",
        "SF": "Semi-Finals",
        "QF": "Quarter-Finals",
        "16": "Round of 16",
        "32": "Round of 32",
        "GR": "Group Stage",
        "4R": "Fourth Round",
        "3R": "Third Round",
        "2R": "Second Round",
        "1R": "First Round",
        "PR": "Preliminary Round",
        "QPO1": "Make Round of 32 Tier Below",
        "QPO2": "Qualifier Round of 16",
      },
      prediction:"Predictions",
      predicted:"Predição",
      groups:"Groups",
      ranking:"Ranking",
      positions:"Positions",
      numberOfTeams: "Número de equipas",
      statsWithMinimum: {
        message: "A mostrar apenas jogadores com mais de {0} {1} na época selecionada",
        dribblesTotal90: "dribles por 90 minutos",
        crosses90: "cruzamentos por 90 minutos",
        tacklesAttempted90: "desarmes tentados por 90 minutos",
        aerialsTotal90: "duelos aéreos por 90 minutos"
      }      
    },
    similarity:{
      subtitle:"Find similar players",
      searchBarPlaceholder:"Search and select a player to find similar",
      radarFilters:"Radar filters",
      similarityFilters:"Similarity filters",
      playersFilters:"Players filters",
      similarPlayers:"Similar Players",
      seasonWarning: "Apenas as épocas disponíveis na ferramenta Similaridade em que ele jogou mais de 450 minutos"
    },
    squadBuilder:{
      subtitle:"Sketch your unique elevens",
      playerSelector:"Player selector",
      loadSquad:"Load squad",
      yearsOld:"yo.",
      playersPerPosition:"Players per position",
      custom:'Custom',
      removeSquad: 'Eliminar equipa',
      removeSquadMessage: 'Tem a certeza de que pretende eliminar a equipa?',
      deleteSquadSuccess: 'A equipa foi eliminada com sucesso',
      playerDetails: "Visibilidade dos detalhes",
      ageFormat: "Formato da idade",
      mainPlayer: "Jogador principal",
      showDetails: "Mostrar detalhes",
      all: "Todos",
      squadPosition: "Posição no plantel",
      noData: "Sem dados. Comece por adicionar alguns jogadores ao campo!",
    },
    tours:{
      buttons: {
        dontShowAgain: "Não volte a aparecer",
        skipTour: "Saltar visita guiada",
        previous: "Anterior",
        next: "Seguinte",
        finish: "Terminar"
      },
      playerRadar:{
        step1:{
          title: "FICHEIRO PESSOAL",
          message: "Verificar dados básicos do jogador: idade, altura ou data de contrato"
        },
        step2:{
          title: "FILTRO GBE",
          message: "Funcionalidade que permite saber se um jogador tem pontos GBE suficientes para jogar no Reino Unido"
        },
        step3:{
          title: "DISPONIBILIDADE",
          message: "Percentagem de minutos disponíveis e percentagem de minutos jogados"
        },
        step4:{
          title: "POSIÇÕES",
          message: "Descubra em que posições o jogador jogou e quantos minutos jogou em cada posição"
        },
        step5:{
          title: "EXIBIR FORMATOS",
          message: "Medir o desempenho com 4 visualizações diferentes, Radar, Polar, Pirulito e Texto, para o comparar com os jogadores na sua posição"
        },
        step6:{
          title: "RADAR DE DESEMPENHO",
          message: "Aqui o desempenho é reflectido visualmente. O painel é interactivo, pode passar o rato sobre cada métrica e obter a respectiva definição"
        },
        step7:{
          title: "SELECÇÃO DE ESTAÇÃO",
          message: "Seleccionar ou adicionar épocas para medir o seu desempenho"
        },
        step8:{
          title: "SELECÇÃO DE MODELO PERSONALIZADO",
          message: "Utilize os modelos personalizados que criou para medir o jogador com métricas diferentes do radar padrão"
        },
        step9:{
          title: "SELECÇÃO DE POSIÇÕES JOGADAS",
          message: "Marque e desmarque as diferentes posições para o medir na posição em que pretende medi-lo"
        },
        step10:{
          title: "SELECÇÃO DE MÍNIMOS E MÁXIMOS",
          message: "Medir o jogador com os máximos e mínimos da sua época, das cinco principais ligas ou da época própria e por defeito da conta de utilizador"
        },
        step11:{
          title: "COMPARAÇÕES",
          message: "Compara o jogador com o seu desempenho anterior, com outros jogadores da sua posição, com a média da posição"
        },
        step12:{
          title: "FORMATOS DE DESCARREGAMENTO DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        }
      },
      playerRanking:{
        step1:{
          title: "ÉPOCA, PLANTEL E POSIÇÃO",
          message: "Seleccione a época, a equipa e a posição com que pretende comparar o jogador"
        },
        step2:{
          title: "FILTROS BÁSICOS",
          message: "Filtrar jogadores por idade, minutos jogados ou altura"
        },
        step3:{
          title: "DESTACAR E EXCLUIR",
          message: "Destacar os jogadores que pretende e excluir equipas na visualização"
        },
        step4:{
          title: "FILTRAR POR CATEGORIA",
          message: "Filtrar estatísticas por categoria: Associação, Defesa, Passe, Manuseamento de bola, etc"
        },
        step5:{
          title: "FORMATOS DE DESCARREGAMENTO DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        }
      },
      playerFinishing:{
        step1:{
          title: "SELECCIONAR VISUALIZAÇÃO",
          message: "Pode ver o mapa de acabamento na vista principal, na vista de objectivos e num quadro de distribuição"
        },
        step2:{
          title: "SELECCIONAR ÉPOCAS",
          message: "Adicione épocas para medir a sua eficácia de remate"
        },
        step3:{
          title: "LOCALIZAÇÃO DO REMATE",
          message: "Seleccione a possibilidade de ver a localização exacta do remate (círculos) ou por áreas da área e do campo (áreas)"
        },
        step4:{
          title: "xG NO ALVO",
          message: "Marque as caixas xG to Goal e xG Completion para ver o valor acrescentado pelo jogador após o remate"
        },
        step5:{
          title: "TIPO DE REMATE",
          message: "Filtrar por tipo de remate, estratégia, área ou parte do corpo"
        },
        step6:{
          title: "FILTRAR MINUTOS",
          message: "Barra de minutos para seleccionar remates e golos marcados por períodos de jogo específicos"
        },
        step7:{
          title: "FORMATOS DE DESCARREGAMENTO DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        },
        step8:{
          title: "MAPA DE REMATES",
          message: "O mapa é interactivo. Verifique cada círculo com o rato para saber o xG de cada tiro"
        }
      },
      playerKeyPass:{
        step1:{
          title: "SELECÇÃO DE ÉPOCA",
          message: "Adicione épocas para medir a sua eficiência de remate"
        },
        step2:{
          title: "LOCALIZAÇÃO DO PASSE-CHAVE",
          message: "Seleccione a possibilidade de ver a localização exacta do passe-chave (círculo) ou por áreas da área e do campo (áreas)"
        },
        step3:{
          title: "TIPO DE REMATE APÓS PASSE-CHAVE",
          message: "Filtrar por tipo de remate, estratégia, área ou parte do corpo efectuado após o passe-chave"
        },
        step4:{
          title: "FILTRAR MINUTOS",
          message: "Barra de minutos para seleccionar remates e golos marcados em períodos de jogo específicos"
        },
        step5:{
          title: "FORMATOS DE DESCARREGAMENTO DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        },
        step6:{
          title: "MAPA DE PASSES-CHAVE",
          message: "O mapa é interactivo. Consulte cada círculo com o rato para saber o xA de cada passagem"
        }
      },
      playerThreat:{
        step1:{
          title: "SELECÇÃO DE ÉPOCAS",
          message: "Adicione épocas para medir a sua eficácia de remate"
        },
        step2:{
          title: "LOCALIZAÇÃO DA AMEAÇA",
          message: "Seleccione a possibilidade de ver a localização exacta do passe-chave (círculo) ou por área e zonas de campo (áreas)"
        },
        step3:{
          title: "ACÇÃO E CONCLUSÃO",
          message: "Marque e desmarque de acordo com o tipo de acção e conclusão que pretende visualizar no mapa"
        },
        step4:{
          title: "MINUTOS E AMEAÇA",
          message: "Filtrar por período, por minutos e por valor de ameaça das acções"
        },
        step5:{
          title: "FORMATOS DE DESCARREGAMENTO DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        },
        step6:{
          title: "MAPA DE AMEAÇAS",
          message: "O mapa é interactivo. Consulte cada círculo com o rato para descobrir a ameaça gerada em cada jogada xT de cada passe"
        }
      },
      playerTouches:{
        step1:{
          title: "SELECÇÃO DE JOGOS E EVENTOS",
          message: "Seleccione o jogo e os eventos que pretende visualizar no mapa"
        },
        step2:{
          title: "TIPO DE EVENTO",
          message: "Marcar e desmarcar de acordo com a natureza defensiva ou ofensiva do evento do jogador durante o jogo"
        },
        step3:{
          title: "FILTRO DE VISUALIZAÇÃO",
          message: "Filtrar o mapa por acções básicas, mapa de calor, círculos ou caixas"
        },
        step4:{
          title: "FORMATOS DE DESCARREGAMENTO DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        },
        step5:{
          title: "MAPA DE TOQUES",
          message: "O mapa é interactivo. Pode visualizar cada evento clicando em cada um deles"
        }
      },
      playerAllGames:{
        step1:{
          title: "DISPONIBILIDADE",
          message: "Verificar a disponibilidade e os minutos jogados jogo a jogo"
        },
        step2:{
          title: "POSIÇÕES",
          message: "Consultar as posições em que jogou em cada jogo"
        }
      },
      playerInjuries:{
        step1:{
          title: "HISTORIAL E DIAS PERDIDOS",
          message: "Consultar as lesões do último ano ou o historial completo e o intervalo de lesões de acordo com a sua duração em dias"
        },
        step2:{
          title: "LESÕES POR CLUBE",
          message: "Consultar as lesões separadas por época e/ou clube da sua trajectória"
        }
      },
      playerInfo:{
        step1:{
          title: "CARREIRA E TRANSFERÊNCIAS",
          message: "Pode consultar o histórico de minutos, posição ou disponibilidade no seu clube, na sua selecção nacional e as transferências do jogador ao longo da sua carreira"
        }
      },
      teamOverview:{
        step1:{
          title: "FICHA DA EQUIPA",
          message: "Consultar dados básicos da equipa: idade média, formação de base, ELO ou saldo de transferências"
        },
        step2:{
          title: "ESTATÍSTICAS DE BASE",
          message: "Consultar posse de bola, xG, remates, PPDA ou verticalidade"
        },
        step3:{
          title: "RADAR E ESTAÇÃO",
          message: "Selecionar o radar, a época e os jogos em casa ou fora para medir o desempenho da equipa"
        },
        step4:{
          title: "FILTRAR POR TREINADOR E JOGOS",
          message: "Selecionar o desempenho por fase para cada treinador"
        },
        step5:{
          title: "RADAR DE DESEMPENHO",
          message: "O painel é interativo, pode passar o cursor sobre cada métrica e obter a respectiva definição"
        },
        step6:{
          title: "FORMATOS DE DESCARREGAMENTO DE IMAGENS",
          message: "Estão disponíveis dois formatos para descarregar: png e svg"
        },
        step7:{
          title: "CALENDÁRIO",
          message: "Ver o calendário de jogos da equipa"
        },
        step8:{
          title: "MELHORES JOGADORES POR MÉTRICA",
          message: "Neste painel, pode selecionar diferentes métricas e ver quais são os jogadores mais importantes"
        },
        step9:{
          title: "PRÓXIMO JOGO E LESÕES",
          message: "Verificar o próximo adversário e os jogadores lesionados e suspensos da equipa"
        },
        step10:{
          title: "GRÁFICOS E TENDÊNCIAS",
          message: "Ver gráficos diferentes para os últimos 10 ou 20 jogos"
        }
      },
      teamRoster:{
        step1:{
          title: "TIPO DE VISUALIZAÇÃO",
          message: "Ver o plantel em 6 categorias diferentes: por posição, fim de contrato, idade, disponibilidade, perfil etário e campo"
        }
      },
      teamLoans:{
        step1:{
          title: "JOGADORES DE EMPRÉSTIMO",
          message: "Consultar os jogadores emprestados a outras equipas e a posição em que jogam"
        }
      },
      teamBeeswarm:{
        step1:{
          title: "ÉPOCA E PLANTEL",
          message: "Filtrar por época, radar de equipa e comparar com ligas à sua escolha"
        },
        step2:{
          title: "DESEMPENHO POR MÉTRICA",
          message: "Ver a posição da equipa em cada métrica em comparação com todas as equipas das ligas previamente seleccionadas"
        },
        step3:{
          title: "FORMATOS DE DESCARGA DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        }
      },
      teamFinishingMap:{
        step1:{
          title: "SELECÇÃO DA ÉPOCA",
          message: "Adicionar épocas para medir a eficiência de remate"
        },
        step2:{
          title: "FINALIZAÇÃO PRÓPRIA OU DO ADVERSÁRIO",
          message: "Escolha se pretende ver o mapa de conclusão da equipa ou de todos os seus adversários"
        },
        step3:{
          title: "COLOCAÇÃO DO TIRO",
          message: "Seleccione como pretende ver os remates da equipa, por círculos ou por zonas (caixas)"
        },
        step4:{
          title: "TIPO DE TIRO",
          message: "Filtrar por tipo de fotografia, estratégia, área ou parte do corpo"
        },
        step5:{
          title: "FILTRAR MINUTOS",
          message: "Barra de minutos para selecionar remates e golos marcados em períodos de jogo específicos"
        },
        step6:{
          title: "FORMATOS DE DESCARGA DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        },
        step7:{
          title: "MAPA DE TIRO",
          message: "O mapa é interativo. Verifique cada círculo com o rato para saber o xG de cada tiro"
        },
      },
      teamKeyPassMap:{
        step1:{
          title: "SELECÇÃO DA ÉPOCA",
          message: "Adicionar épocas para medir a eficiência de remate"
        },
        step2:{
          title: "PASSES DE CHAVES PRÓPRIOS OU DE RIVAIS",
          message: "Escolha se pretende ver um mapa dos principais passes da equipa ou de todos os seus rivais"
        },
        step3:{
          title: "LOCALIZAÇÃO DO CARTÃO DE ACESSON",
          message: "Seleccione se pretende ver a localização exacta do cartão de acesso (círculo) ou por área e campo (caixas)"
        },
        step4:{
          title: "TIPO DE ACABAMENTO APÓS A PASSAGEM",
          message: "Filtrar por tipo de remate, estratégia, área ou parte do corpo efectuado após um passe-chave"
        },
        step5:{
          title: "FILTRAR MINUTOS",
          message: "Barra de minutos para selecionar remates e golos marcados em períodos de jogo específicos"
        },
        step6:{
          title: "FORMATOS DE DESCARGA DE IMAGENS",
          message: "Estão disponíveis três formatos de transferência: png, svg e embed"
        },
        step7:{
          title: "MAPA DE TIRO",
          message: "O mapa é interativo. Consulte cada círculo com o rato para saber o xA de cada passagem"
        },
      },
      teamLatestGames:{
        step1:{
          title: "JOGOS MAIS RECENTES",
          message: "Consultar resultados, posse de bola, xG e % de vitórias de todos os jogos da equipa"
        }
      },
      teamTransfers:{
        step1:{
          title: "CHEGADAS",
          message: "Consultar todas as chegadas (compras + transferências) por ano civil"
        },
        step2:{
          title: "PARTIDAS",
          message: "Consultar todas as saídas (vendas + transferências) por ano civil"
        }
      },
      teamAnalysis:{
        step1:{
          title: "TENDÊNCIAS",
          message: "Consultar a forma da equipa através de séries, vitórias, jogos sem sofrer golos, reviravoltas, períodos com golos ou tipos de golos"
        },
        step2:{
          title: "BOLA PARADA",
          message: "Compare o desempenho da equipe entre jogadas de bola parada e jogadas abertas e obtenha uma visão geral detalhada dos diferentes tipos de peças de bola parada"
        },
        step3:{
          title: "SUBSTITUIÇÕES",
          message: "Ver quando a equipa faz substituições e quais os jogadores mais substituídos"
        },
        step4:{
          title: "CONEXÕES",
          message: "Consultar as ligações mais comuns entre jogadores. Filtrar por época e tipo de jogo"
        },
        step5:{
          title: "ZONAS DE ATAQUE",
          message: "Descubra as zonas de ataque da equipa e filtre por época ou tipo de ataque"
        },
        step6:{
          title: "FORMAÇÕES",
          message: "Verificar as formações mais utilizadas e a sua percentagem de vitórias, empates e derrotas com cada uma delas"
        },
        step7:{
          title: "ZONAS DE TIRO",
          message: "Filtrar por época, equipa ou adversário, forma de visualização do mapa, tipos de remate ou minutos"
        },
        step8:{
          title: "CRUZAMENTOS",
          message: "Consulta e filtragem por época, tipo de exibição, com ou sem sucesso, de onde começam e terminam ou incluindo pontapés de canto"
        },
        step9:{
          title: "JOGADORES",
          message: "Filtrar por época, tipo de exibição, bem ou mal sucedida, de onde começam e terminam ou incluindo pontapés de canto"
        }
      },
      teamOnOff:{
        step1:{
          title: "TEMPORADAS E JOGOS",
          message: "Filtrar por época, por jogos ou por jogos em casa ou fora"
        },
        step2:{
          title: "JOGADORES",
          message: "Ver o desempenho de todos os jogadores do plantel através de inúmeras métricas"
        }
      }
    },
    alerts:{
      numPlayers:"Number of players",
      newPlayersLastWeek:"New players last week",
      subtitle: "Get alerts when new players meet your search criteria",
      generalSubtitle: "Alertas sobre novos jogadores de acordo com os seus critérios e notícias sobre os seus jogadores favoritos",
      subtitlePlayer: "Receba alertas quando tivermos notícias sobre os seus jogadores favoritos",
      subtitleSearch: "Receba alertas quando novos jogadores corresponderem aos seus critérios de pesquisa",
      favorite: "Favorito",
      newEventCalendar: "Novo Evento",
      updatedEventCalendar: "Evento Atualizado",
      newShareFrom: "Nova Partilha de ana@gmail.com",
      injuryAlert: "Alerta de Lesão",
      contractAlert: "Alerta de Contrato",
      teamAlert: "Alerta de Assinatura",
      marketValueAlert: "Alerta de Valor de Mercado",
      gameAlert: "Alerta de Jogo Disputado",
    },
    videoEvents:{
      highlights:"Highlights",
      fullGame:"Full game",
      autoplay:"Autoplay",
      searchBarPlaceholder:"Search player, game or team...",
      subtitle:"Analyze events through video",
      successful:"Success",
      unsuccessful:"Fail",
      playing:"Playing",
      games:"Games",
      moreFilters:"More filters...",
      startArea:"Start area",
      endArea:"End area",
      select:"Select",
      selectLastXGames: "Select last {0} games",
      advancedFilters: "Advanced Filters",
      freeKicks:"Free Kicks",
      cornerKicks:"Corner Kicks",
      allShots:"All Shots",
      generateZip:"Generate ZIP",
      zippedModalMessage:"ZIP process has been started, could take some minutes. You would receive an email when is finished",
      clickToSeeVideo:"Click to see video"
    },
    videoUpload:{
      subtitle: "Upload video and create new game",
      uploadVideo: "Upload video",
      selectPeriod: "Select period",
      gameData: "Game Data",
      venue:"Venue",
      matchType: "Match type",
      matchGroup: "Match group",
      roundType: "Round type",
      roundNumber: "Round number",
      offsetFh:"Offset First Half",
      offsetSh:"Offset Second Half",
      offsetFhOT:"Offset Overtime First Half",
      offsetShOT:"Offset Overtime Second Half",
      homeLineup: "Home Lineup",
      awayLineup: "Away Lineup",
      existingPlayer: "Existing player",
      newPlayer: "New player",
      startingTeam:"Starting",
      saveAndUpload:"Save and upload",
      existingGame: "Game exists already",
      sendToKora:"Send",
      invalidForm:"Invalid form",
      warningModalTitle:"Anomalies have been detected",
      noScoreSheetWarning:"No scoresheet attached",
      onlyOnePartUploadedWarning: "Only one half time attached",
      continueQuestion: "continue?",
      slaLimit: "Enviou {0} jogos com {1}. O seu limite é {2}",
      requestedGames: "Jogos solicitados",
      limitClose: "Apenas {0} jogos restantes para solicitar",
      limitReached: "Atingiu o limite de carregamento de vídeos. Carregar mais jogos pode resultar em custos adicionais.",
      seasonFinishedWarning: "Isto irá criar um jogo numa temporada que já terminou. Por favor, verifique se está correto.",
      teamCountryWarning: "Esta equipa é de um país diferente do da liga escolhida. Por favor, verifique se está correto.",
    },
    videoPlaylists:{
      subtitle: "Collections of video highlights filters",
      savePlaylist: "Save Playlist",
      seeAllPlaylists: "Ver todas as listas"
    },
    videoHighlights: {
      recap:"Recapitular",
      homeCondensed:"Jogo condensado em casa",
      awayCondensed:"Jogo fora de casa condensado",
      selectedActions: "Ações selecionadas",
      noActions: "Não há ações que correspondam aos critérios de filtro especificados",
      noGames: "Ainda não foram carregados jogos",
      attackingActions: "Ações ofensivas",
      defensiveActions: "Ações defensivas",
      groundDuels: "Duelos no chão",
      penaltiesProvoked: "Penáltis provocados",
      goalkeeperActions: "Ações do Guarda-redes",
      addSomeGames: "Começa por adicionar alguns jogos!",
      goToVideoUploadTool: "Ir para Carregar Vídeos",
      ballInPlay:"Bola em jogo",
      qualifiers: {
        "Pass": "Passe",
        "Save": "Defesa",
        "Saved Shot": "Remate Defendido",
        "Shot": "Remate",
        "Goal": "Golo",
        "Missed Shot": "Remate Falhado",
        "Shot on Post": "Remate ao Poste",
        "Error": "Erro",
        "Clearance": "Alívio",
        "Aerial": "Duelo Aéreo",
        "Challenge": "Duelo Perdido",
        "Dispossessed": "Perda de Bola",
        "Foul": "Falta",
        "Card": "Cartão",
        "Offside Pass": "Passe em Fora de Jogo",
        "Claim": "Bola Agarrada",
        "Keeper Pickup": "Recolha do Guarda-Redes",
        "Ball Touch": "Toque de Bola",
        "Dribble": "Drible",
        "Interception": "Interceção",
        "Tackle": "Desarme",
        "Ball Recovery": "Recuperação de Bola"
      },
      qualifierIds: {
        "1": "Passe longo",
        "2": "Cruzamento",
        "5": "Livre direto",
        "6": "Canto",
        "9": "Penálti",
        "15": "De cabeça",
        "20": "Pé direito",
        "21": "Outra parte do corpo",
        "22": "Jogo aberto",
        "23": "Contra-ataque",
        "24": "Bola parada",
        "25": "De canto",
        "26": "Livre",
        "28": "Autogolo",
        "29": "Assistido",
        "31": "Cartão amarelo",
        "32": "Segundo cartão amarelo",
        "33": "Cartão vermelho",
        "72": "Pé esquerdo",
        "73": "Esquerda",
        "82": "Remate defendido (sem guarda-redes)",
        "94": "Bloqueio defensivo",
        "123": "Lançamento do guarda-redes",
        "124": "Pontapé de baliza",
        "160": "Lançamento lateral",
        "170": "Que resulta em golo",
        "173": "Alívio seguro",
        "174": "Alívio perigoso",
        "177": "Recolhido",
        "178": "Em pé",
        "179": "Em mergulho",
        "182": "Mãos",
        "183": "Pés",
        "185": "Cruzamento bloqueado",
        "210": "Assistência",
        "215": "Jogada individual",
        "279": "Pontapé de saída",
        "285": "Defensivo",
        "286": "Ofensivo"
      },
      areas: {
        "goalArea": "Pequena Área",
        "boxLeft": "Área Esquerda",
        "boxCenter": "Área Central",
        "boxRight": "Área Direita",
        "outBoxDeepLeft": "Fora da Área Profunda Esquerda",
        "outBoxDeepRight": "Fora da Área Profunda Direita",
        "outBoxLeft": "Fora da Área Esquerda",
        "outBoxCentreLeft": "Fora da Área Centro-Esquerda",
        "outBoxCentre": "Fora da Área Central",
        "outBoxCentreRight": "Fora da Área Centro-Direita",
        "outBoxRight": "Fora da Área Direita",
        "midfieldLeft35": "Meio-Campo Esquerda",
        "midfieldCentreLeft35": "Meio-Campo Centro-Esquerda",
        "midfieldCentre35": "Meio-Campo Central",
        "midfieldCentreRight35": "Meio-Campo Centro-Direita",
        "midfieldRight35": "Meio-Campo Direita",
        "ownGoalArea": "Própria Área de Baliza",
        "ownBoxLeft": "Própria Área Esquerda",
        "ownBoxCenter": "Própria Área Central",
        "ownBoxRight": "Própria Área Direita",
        "ownFieldOutOfBoxDeepLeft": "Próprio Campo Fora da Área Profunda Esquerda",
        "ownFieldOutOfBoxDeepRight": "Próprio Campo Fora da Área Profunda Direita",
        "ownFieldOutOfBoxLeft": "Próprio Campo Fora da Área Esquerda",
        "ownFieldOutOfBoxCentreLeft": "Próprio Campo Fora da Área Centro-Esquerda",
        "ownFieldOutOfBoxCentre": "Próprio Campo Fora da Área Central",
        "ownFieldOutOfBoxCentreRight": "Próprio Campo Fora da Área Centro-Direita",
        "ownFieldOutOfBoxRight": "Próprio Campo Fora da Área Direita"
      },
      outcomes: {
        "success": "Sucesso",
        "fail": "Falha",
        "possessionWon": "Posse Ganha",
        "possessionNotWon": "Posse Não Ganha",
        "received": "Recebido",
        "provoked": "Provocado"
      }      
    },    
    share:{
      shareTo:"Send to",
      viaApp: "App (Driblab Message)",
      viaEmail: "Email",
      description: "Description",
      titleTab: "Shares",
      toMe:"Recebido",
      fromMe:"Enviado",
      typeInternal:"Internal",
      typeExternal:"External",
      title: "Partilhados",
      subtitle: "Visão geral dos itens na sua lista de partilha",
      selectUser: "Selecionar usuário",
      expired:"Expirado",
      limitReached:"O link atingiu o limite de utilizações"
    },
    homeStats: {
      data: "Dados disponíveis",
      players: "jogadores",
      totalPlayers: "jogadores em total",
      teams: "equipas",
      totalTeams: "equipas em total",
      leagues: "ligas",
      totalLeagues: "ligas em total",
      seasons: "temporadas",
      totalSeasons: "temporadas em total",
      games: "jogos",
      totalGames: "jogos em total"
    },
    scoutingCalendar: {
      subtitle: "Crie e organize as suas tarefas de scouting",
      myCalendars: "Calendário privado",
      publicCalendars: "Calendários públicos",
      otherCalendars: "Outros calendários",
      calendarSettings: "Configurações do calendário",
      individualScouting: "Scouting Individual",
      matchScouting: "Scouting de Jogo",
      moreInfo: "Mais informações",
      calendarView: {
        type: "Tipo de calendário",
        month: "Mês",
        week: "Semana",
        day: "Dia"
      },
      weekView: {
        type: "Tipo de semana",
        monSun: "Segunda - Domingo",
        sunSat: "Domingo - Sábado",
        monFri: "Segunda - Sexta"
      },
      tasks: {
        addNew: "Adicionar nova tarefa",
        myTasks: "As minhas tarefas",
        filterTasks: "Filtrar tarefas",
        sharedWithMe: "Partilhado comigo",
        createTask: "Criar tarefa",
        newTask: "Nova tarefa",
        taskName: "Nome da tarefa",
        allDay: "Todo o dia",
        startDate: "Data de início",
        endDate: "Data de fim",
        startHour: "Hora de início",
        endHour: "Hora de fim",
        assignedTo: "Atribuído a",
        assignedToMe: "Atribuído a mim",
        color: "Cor",
        scoutingType: "Tipo de scouting",
        taskLocation: "Localização da tarefa",
        selectLeague: "Selecionar liga",
        selectMatch: "Selecionar jogo",
        useMatchdate: "Usar a data do jogo como data",
        stadium: "Estádio",
        travel: "Viagem",
        hotel: "Hotel",
        tickets: "Bilhetes",
        taskNotes: "Digite notas descritivas ou comentários relacionados com a tarefa",
        states: {
          toDo: "Por fazer",
          inProgress: "Em progresso",
          done: "Concluído"
        },
        type: {
          player: "Avaliação de Jogador",
          team: "Avaliação de Equipa",
          other: "Outro"
        },
        location: {
          stadium: "No estádio",
          video: "Vídeo"
        },
        accommodation: {
          accommodationDetails: "Detalhes do alojamento",
          ownArrangement: "Acordo próprio",
          required: "Necessário",
          notRequired: "Não necessário",
          booked: "Reservado"
        },
        assignToMe: "Atribuir a mim",
        addOther: "Adicionar outro",
        deleteTask: "Eliminar tarefa",
        deleteTaskMessage: "A tarefa será removida, tem a certeza?",
        cancelUpdate: "Cancelar atualização",
        cancelUpdateMessage: "As alterações não serão guardadas, tem a certeza?",
        selectGame: "Por favor, selecione um jogo para adicionar ficheiros",
        noData: "Sem dados. Comece adicionando algumas tarefas!",
        widgetSubtitle: "Verifique suas próximas tarefas",
        scoutingDetails: "Detalhes do scouting",
        taskDetails: "Detalhes da tarefa",
        playerDocuments: "Documentos do jogador",
        teamDocuments: "Documentos da equipe",
        gameDocuments: "Documentos do jogo",
        taskDocuments: "Documentos da tarefa",
        task: "Tarefa"
      },
      nextGames: "Próximos jogos",
    },
    scoutingTasksBoard: {
      period: {
        week: "Esta semana",
        month: "Este mês",
        year: "Este ano",
      },
      noTasks: "Crie novas tarefas ou arraste uma para aqui!",
      goToBoard: "Ir para o board"
    },
    profile: {
      title: "Perfil",
      subtitle: "Personalize os detalhes da sua conta e subscrição"
    },
    hub: {
      onlyHub: "Disponível apenas no Driblab Hub"
    },
    uploadedGames: {
      subtitle: "All uploaded games",
      timeRequested:"Time it was requested",
      timeReceived:"When it was received",
      diffHours:"Difference in hours",
      collectionCompleted: "Collection completed",
      dateFrom:"Date from",
      dateTo:"Date to",
      goToUploadedGames: "Ir para Partidas Carregadas",
      sla: "Acordo de Nível de Serviço",
      matchDate: "Data do jogo",
      rejectedGame: "Rejeitado"
    },
    gameMap: {
      title: "Mapa dos Jogos",
      subtitle: "Explore os jogos dos próximos dias",
      warning: "A hora e o local podem não estar corretos. Por favor, confirme estas informações.",
      taskAdded: "Tarefa criada com sucesso. Consulte o Scouting Calendar."
    },
    leagueRequestAccess: {
      sendSuccess: "Notificação enviada com sucesso",
      notPermissions: "Não tens permissão para ver",
      notPermissionsLeague: "Não tens permissão para ver esta liga",
      notPermissionsGame: "Não tens permissão para ver este jogo",
      requestAccessTo: "Pedir acesso a",
      sendRequest: "Enviar Pedido",
    },
    videoTeams: {
      subtitle: "Encontre os últimos jogos etiquetados por equipa",
      noGamesUploaded: "Ainda não foram carregados jogos"
    },
    scoutingAnalysis: {
      scoutingAnalysis: "Análise de Scouting",
      scoutingAnalyses: "Análises de Scouting",
      analyses: "Análises",
      addReport: "Adicionar análise",
      technical: "Técnico",
      tactical: "Tático",
      physical: "Físico",
      mental: "Psicológico",
      technicalNotes: "Notas técnicas",
      tacticalNotes: "Notas táticas",
      physicalNotes: "Notas físicas",
      mentalNotes: "Notas sobre o perfil psicológico",
      conclusion: "Conclusão",
      charactersMax: "Máximo de 1000 caracteres",
      globalRating: "Avaliação global",
      noData: "Sem dados. Comece por adicionar algumas análises de scouting!",
      deleteAnalysis: "Eliminar Análise de Scouting",
      deleteAnalysisMessage: "A análise será permanentemente removida. Tem a certeza?",
      avgTooltip: "Média baseada nas classificações finais das análises visíveis para si",
      avgOverallScoreTooltip: "Média baseada nas pontuações gerais do jogador visíveis para você",
      scouter: "Scouter",
      lastEdited: "Última edição",
      analysisFilters: "Filtros de Análise",
      generalFilters: "Filtros Gerais",
      widgetSubtitle: "Últimas análises adicionadas",
      addPlayerReport: "Adicionar análise de scouting do jogador",
      seeReports: "Ver relatórios"
    },
    addPlayerForm: {
      noLeague: "Criar uma equipe sem liga pode ter um efeito negativo na sua indexação e pesquisa subsequente dentro da aplicação."
    },
    expenses: {
      expense: "Despesa",
      expenses: "Despesas",
      addExpense: "Adicionar despesa",
      transportation: "Transporte",
      accommodation: "Alojamento",
      dietary: "Alimentação",
      eventTicket: "Bilhete de evento",
      expenseType: "Tipo de despesa",
      amount: "Montante",
      expenseDate: "Data da despesa",
      expenseFilters: "Filtros de despesas",
      noData: "Sem dados. Comece por adicionar algumas despesas!",
      deleteExpense: "Eliminar despesa",
      deleteExpenseMessage: "A despesa será removida permanentemente. Tem a certeza?"      
    },
    disabledTooltips: {
      general: "Esta funcionalidade está atualmente desativada",
      youth: "Deve ser juvenil para definir uma idade",
      unit: "A estatística deve ser Runs, HSR ou SPR",
      seasonsWithout60MinsGames: "O jogador não jogou mais de 60 minutos num único jogo na(s) temporada(s) selecionada(s)",
      notEditable: "Isto não pode ser editado",
      noMatchdate: "Data do jogo indisponível",
      selectGame: "Selecione um jogo primeiro",
      selectPlayer: "Selecione um jogador primeiro",
      selectTeam: "Selecione uma equipa primeiro",
      selectBoxes: "A visualização de caixas deve ser selecionada",
      selectYear: "Selecione um ano primeiro",
      pdScoreNotAvailable: "Pontuação não disponível porque o jogador não jogou 60 minutos numa partida",
      pdSeasonNotAvailable: "Dados físicos não disponíveis para esta época",
      pdGameNotAvailable: "Dados físicos não disponíveis para este jogo",
    },
    leagueTypes: {
      regular: "Regular",
      continental: "Continental",
      nationalTeam: "Seleção Nacional",
      countryCup: "Taça Nacional",
      qualifier: "Qualificação",
      playOff: "Play-Off",
      regionalLeague: "Liga Regional",
      friendly: "Amigável",
      nationalFriendly: "Amigável Nacional",
      nationaQualifier: "Qualificação Nacional",
    },
    playerSides:{
      "Left/Right":"Esquerda/Certo",
      "Left/Centre/Right":"Esquerda/Centro/Certo",
      "Right":"Certo",
      "Centre":"Centro",
      "Centre/Right":"Centro/Certo",
      "Left":"Esquerda",
      "Left/Centre":"Esquerda/Centro"
    },
    areaSelector: {
      selectAreas: "Selecionar áreas",
      filterAreas: "Filtrar áreas",
    },
    spatialCoverage:{
      lastDefenderDist: "Distância do último defensor",
      defensiveLineDist: "Distância da linha defensiva",
      fullBackAvgDist: "Distância lateral média",
      offensiveLineDist: "Distância da linha ofensiva",
      distanceToGoal: "Distância até ao golo",
      avgLineWidth: "Largura média da linha",
      leagueAvgDistanceToGoal: "Distância média da liga até à baliza",
      leagueAvgLineWidth:"Largura média da linha na liga",
      meters:"metros",
      leagueAvgDist: "Distância média da liga",
      distance: "Distância",
      avgPositionYAxis: "Posição média no eixo Y",
      leagueAvgPositionYAxis: "Posição média da liga no eixo Y"
    }
        
  }



// WEBPACK FOOTER //
// ./src/utils/translations/pt.js